/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const stealth = $root.stealth = (() => {

    /**
     * Namespace stealth.
     * @exports stealth
     * @namespace
     */
    const stealth = {};

    /**
     * InstrumentType enum.
     * @name stealth.InstrumentType
     * @enum {number}
     * @property {number} NoInstrument=0 NoInstrument value
     * @property {number} CommonStock=1 CommonStock value
     * @property {number} StockOption=2 StockOption value
     * @property {number} Future=3 Future value
     * @property {number} Index=4 Index value
     * @property {number} ForexContract=5 ForexContract value
     * @property {number} FutureOption=6 FutureOption value
     * @property {number} FutureInstrument=7 FutureInstrument value
     * @property {number} Combo=8 Combo value
     * @property {number} ComboInstrument=9 ComboInstrument value
     * @property {number} CryptoCurrency=10 CryptoCurrency value
     * @property {number} PerpetualCrypto=11 PerpetualCrypto value
     */
    stealth.InstrumentType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NoInstrument"] = 0;
        values[valuesById[1] = "CommonStock"] = 1;
        values[valuesById[2] = "StockOption"] = 2;
        values[valuesById[3] = "Future"] = 3;
        values[valuesById[4] = "Index"] = 4;
        values[valuesById[5] = "ForexContract"] = 5;
        values[valuesById[6] = "FutureOption"] = 6;
        values[valuesById[7] = "FutureInstrument"] = 7;
        values[valuesById[8] = "Combo"] = 8;
        values[valuesById[9] = "ComboInstrument"] = 9;
        values[valuesById[10] = "CryptoCurrency"] = 10;
        values[valuesById[11] = "PerpetualCrypto"] = 11;
        return values;
    })();

    /**
     * PutOrCall enum.
     * @name stealth.PutOrCall
     * @enum {number}
     * @property {number} NoPutCall=0 NoPutCall value
     * @property {number} Put=1 Put value
     * @property {number} Call=2 Call value
     */
    stealth.PutOrCall = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NoPutCall"] = 0;
        values[valuesById[1] = "Put"] = 1;
        values[valuesById[2] = "Call"] = 2;
        return values;
    })();

    /**
     * StrategySignal enum.
     * @name stealth.StrategySignal
     * @enum {number}
     * @property {number} None=0 None value
     * @property {number} LongSignal=1 LongSignal value
     * @property {number} ShortSignal=2 ShortSignal value
     */
    stealth.StrategySignal = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "None"] = 0;
        values[valuesById[1] = "LongSignal"] = 1;
        values[valuesById[2] = "ShortSignal"] = 2;
        return values;
    })();

    /**
     * GaugeSignal enum.
     * @name stealth.GaugeSignal
     * @enum {number}
     * @property {number} Unknown=0 Unknown value
     * @property {number} Short=1 Short value
     * @property {number} Flat=2 Flat value
     * @property {number} Long=3 Long value
     * @property {number} Dual=4 Dual value
     */
    stealth.GaugeSignal = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Unknown"] = 0;
        values[valuesById[1] = "Short"] = 1;
        values[valuesById[2] = "Flat"] = 2;
        values[valuesById[3] = "Long"] = 3;
        values[valuesById[4] = "Dual"] = 4;
        return values;
    })();

    stealth.ConnectSettings = (function() {

        /**
         * Properties of a ConnectSettings.
         * @memberof stealth
         * @interface IConnectSettings
         * @property {string|null} [productType] ConnectSettings productType
         */

        /**
         * Constructs a new ConnectSettings.
         * @memberof stealth
         * @classdesc Represents a ConnectSettings.
         * @implements IConnectSettings
         * @constructor
         * @param {stealth.IConnectSettings=} [properties] Properties to set
         */
        function ConnectSettings(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ConnectSettings productType.
         * @member {string} productType
         * @memberof stealth.ConnectSettings
         * @instance
         */
        ConnectSettings.prototype.productType = "";

        /**
         * Creates a new ConnectSettings instance using the specified properties.
         * @function create
         * @memberof stealth.ConnectSettings
         * @static
         * @param {stealth.IConnectSettings=} [properties] Properties to set
         * @returns {stealth.ConnectSettings} ConnectSettings instance
         */
        ConnectSettings.create = function create(properties) {
            return new ConnectSettings(properties);
        };

        /**
         * Encodes the specified ConnectSettings message. Does not implicitly {@link stealth.ConnectSettings.verify|verify} messages.
         * @function encode
         * @memberof stealth.ConnectSettings
         * @static
         * @param {stealth.IConnectSettings} message ConnectSettings message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ConnectSettings.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.productType != null && Object.hasOwnProperty.call(message, "productType"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.productType);
            return writer;
        };

        /**
         * Encodes the specified ConnectSettings message, length delimited. Does not implicitly {@link stealth.ConnectSettings.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.ConnectSettings
         * @static
         * @param {stealth.IConnectSettings} message ConnectSettings message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ConnectSettings.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ConnectSettings message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.ConnectSettings
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.ConnectSettings} ConnectSettings
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ConnectSettings.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.ConnectSettings();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.productType = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ConnectSettings message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.ConnectSettings
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.ConnectSettings} ConnectSettings
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ConnectSettings.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ConnectSettings message.
         * @function verify
         * @memberof stealth.ConnectSettings
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ConnectSettings.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.productType != null && message.hasOwnProperty("productType"))
                if (!$util.isString(message.productType))
                    return "productType: string expected";
            return null;
        };

        /**
         * Creates a ConnectSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.ConnectSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.ConnectSettings} ConnectSettings
         */
        ConnectSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.ConnectSettings)
                return object;
            let message = new $root.stealth.ConnectSettings();
            if (object.productType != null)
                message.productType = String(object.productType);
            return message;
        };

        /**
         * Creates a plain object from a ConnectSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.ConnectSettings
         * @static
         * @param {stealth.ConnectSettings} message ConnectSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ConnectSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.productType = "";
            if (message.productType != null && message.hasOwnProperty("productType"))
                object.productType = message.productType;
            return object;
        };

        /**
         * Converts this ConnectSettings to JSON.
         * @function toJSON
         * @memberof stealth.ConnectSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ConnectSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ConnectSettings
         * @function getTypeUrl
         * @memberof stealth.ConnectSettings
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ConnectSettings.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.ConnectSettings";
        };

        return ConnectSettings;
    })();

    stealth.RealtimeUpdate = (function() {

        /**
         * Properties of a RealtimeUpdate.
         * @memberof stealth
         * @interface IRealtimeUpdate
         * @property {number|Long|null} [askPrice] RealtimeUpdate askPrice
         * @property {number|Long|null} [askSize] RealtimeUpdate askSize
         * @property {number|Long|null} [bidPrice] RealtimeUpdate bidPrice
         * @property {number|Long|null} [bidSize] RealtimeUpdate bidSize
         * @property {number|Long|null} [lastPrice] RealtimeUpdate lastPrice
         * @property {number|Long|null} [lastSize] RealtimeUpdate lastSize
         */

        /**
         * Constructs a new RealtimeUpdate.
         * @memberof stealth
         * @classdesc Represents a RealtimeUpdate.
         * @implements IRealtimeUpdate
         * @constructor
         * @param {stealth.IRealtimeUpdate=} [properties] Properties to set
         */
        function RealtimeUpdate(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RealtimeUpdate askPrice.
         * @member {number|Long} askPrice
         * @memberof stealth.RealtimeUpdate
         * @instance
         */
        RealtimeUpdate.prototype.askPrice = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RealtimeUpdate askSize.
         * @member {number|Long} askSize
         * @memberof stealth.RealtimeUpdate
         * @instance
         */
        RealtimeUpdate.prototype.askSize = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RealtimeUpdate bidPrice.
         * @member {number|Long} bidPrice
         * @memberof stealth.RealtimeUpdate
         * @instance
         */
        RealtimeUpdate.prototype.bidPrice = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RealtimeUpdate bidSize.
         * @member {number|Long} bidSize
         * @memberof stealth.RealtimeUpdate
         * @instance
         */
        RealtimeUpdate.prototype.bidSize = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RealtimeUpdate lastPrice.
         * @member {number|Long} lastPrice
         * @memberof stealth.RealtimeUpdate
         * @instance
         */
        RealtimeUpdate.prototype.lastPrice = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RealtimeUpdate lastSize.
         * @member {number|Long} lastSize
         * @memberof stealth.RealtimeUpdate
         * @instance
         */
        RealtimeUpdate.prototype.lastSize = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new RealtimeUpdate instance using the specified properties.
         * @function create
         * @memberof stealth.RealtimeUpdate
         * @static
         * @param {stealth.IRealtimeUpdate=} [properties] Properties to set
         * @returns {stealth.RealtimeUpdate} RealtimeUpdate instance
         */
        RealtimeUpdate.create = function create(properties) {
            return new RealtimeUpdate(properties);
        };

        /**
         * Encodes the specified RealtimeUpdate message. Does not implicitly {@link stealth.RealtimeUpdate.verify|verify} messages.
         * @function encode
         * @memberof stealth.RealtimeUpdate
         * @static
         * @param {stealth.IRealtimeUpdate} message RealtimeUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RealtimeUpdate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.askPrice != null && Object.hasOwnProperty.call(message, "askPrice"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.askPrice);
            if (message.askSize != null && Object.hasOwnProperty.call(message, "askSize"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.askSize);
            if (message.bidPrice != null && Object.hasOwnProperty.call(message, "bidPrice"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.bidPrice);
            if (message.bidSize != null && Object.hasOwnProperty.call(message, "bidSize"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.bidSize);
            if (message.lastPrice != null && Object.hasOwnProperty.call(message, "lastPrice"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.lastPrice);
            if (message.lastSize != null && Object.hasOwnProperty.call(message, "lastSize"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.lastSize);
            return writer;
        };

        /**
         * Encodes the specified RealtimeUpdate message, length delimited. Does not implicitly {@link stealth.RealtimeUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.RealtimeUpdate
         * @static
         * @param {stealth.IRealtimeUpdate} message RealtimeUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RealtimeUpdate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RealtimeUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.RealtimeUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.RealtimeUpdate} RealtimeUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RealtimeUpdate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.RealtimeUpdate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.askPrice = reader.uint64();
                        break;
                    }
                case 2: {
                        message.askSize = reader.uint64();
                        break;
                    }
                case 3: {
                        message.bidPrice = reader.uint64();
                        break;
                    }
                case 4: {
                        message.bidSize = reader.uint64();
                        break;
                    }
                case 5: {
                        message.lastPrice = reader.uint64();
                        break;
                    }
                case 6: {
                        message.lastSize = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RealtimeUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.RealtimeUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.RealtimeUpdate} RealtimeUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RealtimeUpdate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RealtimeUpdate message.
         * @function verify
         * @memberof stealth.RealtimeUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RealtimeUpdate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.askPrice != null && message.hasOwnProperty("askPrice"))
                if (!$util.isInteger(message.askPrice) && !(message.askPrice && $util.isInteger(message.askPrice.low) && $util.isInteger(message.askPrice.high)))
                    return "askPrice: integer|Long expected";
            if (message.askSize != null && message.hasOwnProperty("askSize"))
                if (!$util.isInteger(message.askSize) && !(message.askSize && $util.isInteger(message.askSize.low) && $util.isInteger(message.askSize.high)))
                    return "askSize: integer|Long expected";
            if (message.bidPrice != null && message.hasOwnProperty("bidPrice"))
                if (!$util.isInteger(message.bidPrice) && !(message.bidPrice && $util.isInteger(message.bidPrice.low) && $util.isInteger(message.bidPrice.high)))
                    return "bidPrice: integer|Long expected";
            if (message.bidSize != null && message.hasOwnProperty("bidSize"))
                if (!$util.isInteger(message.bidSize) && !(message.bidSize && $util.isInteger(message.bidSize.low) && $util.isInteger(message.bidSize.high)))
                    return "bidSize: integer|Long expected";
            if (message.lastPrice != null && message.hasOwnProperty("lastPrice"))
                if (!$util.isInteger(message.lastPrice) && !(message.lastPrice && $util.isInteger(message.lastPrice.low) && $util.isInteger(message.lastPrice.high)))
                    return "lastPrice: integer|Long expected";
            if (message.lastSize != null && message.hasOwnProperty("lastSize"))
                if (!$util.isInteger(message.lastSize) && !(message.lastSize && $util.isInteger(message.lastSize.low) && $util.isInteger(message.lastSize.high)))
                    return "lastSize: integer|Long expected";
            return null;
        };

        /**
         * Creates a RealtimeUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.RealtimeUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.RealtimeUpdate} RealtimeUpdate
         */
        RealtimeUpdate.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.RealtimeUpdate)
                return object;
            let message = new $root.stealth.RealtimeUpdate();
            if (object.askPrice != null)
                if ($util.Long)
                    (message.askPrice = $util.Long.fromValue(object.askPrice)).unsigned = true;
                else if (typeof object.askPrice === "string")
                    message.askPrice = parseInt(object.askPrice, 10);
                else if (typeof object.askPrice === "number")
                    message.askPrice = object.askPrice;
                else if (typeof object.askPrice === "object")
                    message.askPrice = new $util.LongBits(object.askPrice.low >>> 0, object.askPrice.high >>> 0).toNumber(true);
            if (object.askSize != null)
                if ($util.Long)
                    (message.askSize = $util.Long.fromValue(object.askSize)).unsigned = true;
                else if (typeof object.askSize === "string")
                    message.askSize = parseInt(object.askSize, 10);
                else if (typeof object.askSize === "number")
                    message.askSize = object.askSize;
                else if (typeof object.askSize === "object")
                    message.askSize = new $util.LongBits(object.askSize.low >>> 0, object.askSize.high >>> 0).toNumber(true);
            if (object.bidPrice != null)
                if ($util.Long)
                    (message.bidPrice = $util.Long.fromValue(object.bidPrice)).unsigned = true;
                else if (typeof object.bidPrice === "string")
                    message.bidPrice = parseInt(object.bidPrice, 10);
                else if (typeof object.bidPrice === "number")
                    message.bidPrice = object.bidPrice;
                else if (typeof object.bidPrice === "object")
                    message.bidPrice = new $util.LongBits(object.bidPrice.low >>> 0, object.bidPrice.high >>> 0).toNumber(true);
            if (object.bidSize != null)
                if ($util.Long)
                    (message.bidSize = $util.Long.fromValue(object.bidSize)).unsigned = true;
                else if (typeof object.bidSize === "string")
                    message.bidSize = parseInt(object.bidSize, 10);
                else if (typeof object.bidSize === "number")
                    message.bidSize = object.bidSize;
                else if (typeof object.bidSize === "object")
                    message.bidSize = new $util.LongBits(object.bidSize.low >>> 0, object.bidSize.high >>> 0).toNumber(true);
            if (object.lastPrice != null)
                if ($util.Long)
                    (message.lastPrice = $util.Long.fromValue(object.lastPrice)).unsigned = true;
                else if (typeof object.lastPrice === "string")
                    message.lastPrice = parseInt(object.lastPrice, 10);
                else if (typeof object.lastPrice === "number")
                    message.lastPrice = object.lastPrice;
                else if (typeof object.lastPrice === "object")
                    message.lastPrice = new $util.LongBits(object.lastPrice.low >>> 0, object.lastPrice.high >>> 0).toNumber(true);
            if (object.lastSize != null)
                if ($util.Long)
                    (message.lastSize = $util.Long.fromValue(object.lastSize)).unsigned = true;
                else if (typeof object.lastSize === "string")
                    message.lastSize = parseInt(object.lastSize, 10);
                else if (typeof object.lastSize === "number")
                    message.lastSize = object.lastSize;
                else if (typeof object.lastSize === "object")
                    message.lastSize = new $util.LongBits(object.lastSize.low >>> 0, object.lastSize.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a RealtimeUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.RealtimeUpdate
         * @static
         * @param {stealth.RealtimeUpdate} message RealtimeUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RealtimeUpdate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.askPrice = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.askPrice = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.askSize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.askSize = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.bidPrice = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.bidPrice = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.bidSize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.bidSize = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.lastPrice = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastPrice = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.lastSize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastSize = options.longs === String ? "0" : 0;
            }
            if (message.askPrice != null && message.hasOwnProperty("askPrice"))
                if (typeof message.askPrice === "number")
                    object.askPrice = options.longs === String ? String(message.askPrice) : message.askPrice;
                else
                    object.askPrice = options.longs === String ? $util.Long.prototype.toString.call(message.askPrice) : options.longs === Number ? new $util.LongBits(message.askPrice.low >>> 0, message.askPrice.high >>> 0).toNumber(true) : message.askPrice;
            if (message.askSize != null && message.hasOwnProperty("askSize"))
                if (typeof message.askSize === "number")
                    object.askSize = options.longs === String ? String(message.askSize) : message.askSize;
                else
                    object.askSize = options.longs === String ? $util.Long.prototype.toString.call(message.askSize) : options.longs === Number ? new $util.LongBits(message.askSize.low >>> 0, message.askSize.high >>> 0).toNumber(true) : message.askSize;
            if (message.bidPrice != null && message.hasOwnProperty("bidPrice"))
                if (typeof message.bidPrice === "number")
                    object.bidPrice = options.longs === String ? String(message.bidPrice) : message.bidPrice;
                else
                    object.bidPrice = options.longs === String ? $util.Long.prototype.toString.call(message.bidPrice) : options.longs === Number ? new $util.LongBits(message.bidPrice.low >>> 0, message.bidPrice.high >>> 0).toNumber(true) : message.bidPrice;
            if (message.bidSize != null && message.hasOwnProperty("bidSize"))
                if (typeof message.bidSize === "number")
                    object.bidSize = options.longs === String ? String(message.bidSize) : message.bidSize;
                else
                    object.bidSize = options.longs === String ? $util.Long.prototype.toString.call(message.bidSize) : options.longs === Number ? new $util.LongBits(message.bidSize.low >>> 0, message.bidSize.high >>> 0).toNumber(true) : message.bidSize;
            if (message.lastPrice != null && message.hasOwnProperty("lastPrice"))
                if (typeof message.lastPrice === "number")
                    object.lastPrice = options.longs === String ? String(message.lastPrice) : message.lastPrice;
                else
                    object.lastPrice = options.longs === String ? $util.Long.prototype.toString.call(message.lastPrice) : options.longs === Number ? new $util.LongBits(message.lastPrice.low >>> 0, message.lastPrice.high >>> 0).toNumber(true) : message.lastPrice;
            if (message.lastSize != null && message.hasOwnProperty("lastSize"))
                if (typeof message.lastSize === "number")
                    object.lastSize = options.longs === String ? String(message.lastSize) : message.lastSize;
                else
                    object.lastSize = options.longs === String ? $util.Long.prototype.toString.call(message.lastSize) : options.longs === Number ? new $util.LongBits(message.lastSize.low >>> 0, message.lastSize.high >>> 0).toNumber(true) : message.lastSize;
            return object;
        };

        /**
         * Converts this RealtimeUpdate to JSON.
         * @function toJSON
         * @memberof stealth.RealtimeUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RealtimeUpdate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RealtimeUpdate
         * @function getTypeUrl
         * @memberof stealth.RealtimeUpdate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RealtimeUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.RealtimeUpdate";
        };

        return RealtimeUpdate;
    })();

    stealth.SnapshotUpdate = (function() {

        /**
         * Properties of a SnapshotUpdate.
         * @memberof stealth
         * @interface ISnapshotUpdate
         * @property {number|Long|null} [openPrice] SnapshotUpdate openPrice
         * @property {number|Long|null} [highPrice] SnapshotUpdate highPrice
         * @property {number|Long|null} [lowPrice] SnapshotUpdate lowPrice
         * @property {number|Long|null} [closePrice] SnapshotUpdate closePrice
         * @property {number|Long|null} [previousClose] SnapshotUpdate previousClose
         * @property {number|Long|null} [volume] SnapshotUpdate volume
         * @property {number|Long|null} [high52Price] SnapshotUpdate high52Price
         * @property {number|Long|null} [low52Price] SnapshotUpdate low52Price
         */

        /**
         * Constructs a new SnapshotUpdate.
         * @memberof stealth
         * @classdesc Represents a SnapshotUpdate.
         * @implements ISnapshotUpdate
         * @constructor
         * @param {stealth.ISnapshotUpdate=} [properties] Properties to set
         */
        function SnapshotUpdate(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SnapshotUpdate openPrice.
         * @member {number|Long} openPrice
         * @memberof stealth.SnapshotUpdate
         * @instance
         */
        SnapshotUpdate.prototype.openPrice = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SnapshotUpdate highPrice.
         * @member {number|Long} highPrice
         * @memberof stealth.SnapshotUpdate
         * @instance
         */
        SnapshotUpdate.prototype.highPrice = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SnapshotUpdate lowPrice.
         * @member {number|Long} lowPrice
         * @memberof stealth.SnapshotUpdate
         * @instance
         */
        SnapshotUpdate.prototype.lowPrice = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SnapshotUpdate closePrice.
         * @member {number|Long} closePrice
         * @memberof stealth.SnapshotUpdate
         * @instance
         */
        SnapshotUpdate.prototype.closePrice = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SnapshotUpdate previousClose.
         * @member {number|Long} previousClose
         * @memberof stealth.SnapshotUpdate
         * @instance
         */
        SnapshotUpdate.prototype.previousClose = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SnapshotUpdate volume.
         * @member {number|Long} volume
         * @memberof stealth.SnapshotUpdate
         * @instance
         */
        SnapshotUpdate.prototype.volume = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SnapshotUpdate high52Price.
         * @member {number|Long} high52Price
         * @memberof stealth.SnapshotUpdate
         * @instance
         */
        SnapshotUpdate.prototype.high52Price = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SnapshotUpdate low52Price.
         * @member {number|Long} low52Price
         * @memberof stealth.SnapshotUpdate
         * @instance
         */
        SnapshotUpdate.prototype.low52Price = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new SnapshotUpdate instance using the specified properties.
         * @function create
         * @memberof stealth.SnapshotUpdate
         * @static
         * @param {stealth.ISnapshotUpdate=} [properties] Properties to set
         * @returns {stealth.SnapshotUpdate} SnapshotUpdate instance
         */
        SnapshotUpdate.create = function create(properties) {
            return new SnapshotUpdate(properties);
        };

        /**
         * Encodes the specified SnapshotUpdate message. Does not implicitly {@link stealth.SnapshotUpdate.verify|verify} messages.
         * @function encode
         * @memberof stealth.SnapshotUpdate
         * @static
         * @param {stealth.ISnapshotUpdate} message SnapshotUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SnapshotUpdate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.openPrice != null && Object.hasOwnProperty.call(message, "openPrice"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.openPrice);
            if (message.highPrice != null && Object.hasOwnProperty.call(message, "highPrice"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.highPrice);
            if (message.lowPrice != null && Object.hasOwnProperty.call(message, "lowPrice"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.lowPrice);
            if (message.closePrice != null && Object.hasOwnProperty.call(message, "closePrice"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.closePrice);
            if (message.previousClose != null && Object.hasOwnProperty.call(message, "previousClose"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.previousClose);
            if (message.volume != null && Object.hasOwnProperty.call(message, "volume"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.volume);
            if (message.high52Price != null && Object.hasOwnProperty.call(message, "high52Price"))
                writer.uint32(/* id 7, wireType 0 =*/56).uint64(message.high52Price);
            if (message.low52Price != null && Object.hasOwnProperty.call(message, "low52Price"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint64(message.low52Price);
            return writer;
        };

        /**
         * Encodes the specified SnapshotUpdate message, length delimited. Does not implicitly {@link stealth.SnapshotUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.SnapshotUpdate
         * @static
         * @param {stealth.ISnapshotUpdate} message SnapshotUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SnapshotUpdate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SnapshotUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.SnapshotUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.SnapshotUpdate} SnapshotUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SnapshotUpdate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.SnapshotUpdate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.openPrice = reader.uint64();
                        break;
                    }
                case 2: {
                        message.highPrice = reader.uint64();
                        break;
                    }
                case 3: {
                        message.lowPrice = reader.uint64();
                        break;
                    }
                case 4: {
                        message.closePrice = reader.uint64();
                        break;
                    }
                case 5: {
                        message.previousClose = reader.uint64();
                        break;
                    }
                case 6: {
                        message.volume = reader.uint64();
                        break;
                    }
                case 7: {
                        message.high52Price = reader.uint64();
                        break;
                    }
                case 8: {
                        message.low52Price = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SnapshotUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.SnapshotUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.SnapshotUpdate} SnapshotUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SnapshotUpdate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SnapshotUpdate message.
         * @function verify
         * @memberof stealth.SnapshotUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SnapshotUpdate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.openPrice != null && message.hasOwnProperty("openPrice"))
                if (!$util.isInteger(message.openPrice) && !(message.openPrice && $util.isInteger(message.openPrice.low) && $util.isInteger(message.openPrice.high)))
                    return "openPrice: integer|Long expected";
            if (message.highPrice != null && message.hasOwnProperty("highPrice"))
                if (!$util.isInteger(message.highPrice) && !(message.highPrice && $util.isInteger(message.highPrice.low) && $util.isInteger(message.highPrice.high)))
                    return "highPrice: integer|Long expected";
            if (message.lowPrice != null && message.hasOwnProperty("lowPrice"))
                if (!$util.isInteger(message.lowPrice) && !(message.lowPrice && $util.isInteger(message.lowPrice.low) && $util.isInteger(message.lowPrice.high)))
                    return "lowPrice: integer|Long expected";
            if (message.closePrice != null && message.hasOwnProperty("closePrice"))
                if (!$util.isInteger(message.closePrice) && !(message.closePrice && $util.isInteger(message.closePrice.low) && $util.isInteger(message.closePrice.high)))
                    return "closePrice: integer|Long expected";
            if (message.previousClose != null && message.hasOwnProperty("previousClose"))
                if (!$util.isInteger(message.previousClose) && !(message.previousClose && $util.isInteger(message.previousClose.low) && $util.isInteger(message.previousClose.high)))
                    return "previousClose: integer|Long expected";
            if (message.volume != null && message.hasOwnProperty("volume"))
                if (!$util.isInteger(message.volume) && !(message.volume && $util.isInteger(message.volume.low) && $util.isInteger(message.volume.high)))
                    return "volume: integer|Long expected";
            if (message.high52Price != null && message.hasOwnProperty("high52Price"))
                if (!$util.isInteger(message.high52Price) && !(message.high52Price && $util.isInteger(message.high52Price.low) && $util.isInteger(message.high52Price.high)))
                    return "high52Price: integer|Long expected";
            if (message.low52Price != null && message.hasOwnProperty("low52Price"))
                if (!$util.isInteger(message.low52Price) && !(message.low52Price && $util.isInteger(message.low52Price.low) && $util.isInteger(message.low52Price.high)))
                    return "low52Price: integer|Long expected";
            return null;
        };

        /**
         * Creates a SnapshotUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.SnapshotUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.SnapshotUpdate} SnapshotUpdate
         */
        SnapshotUpdate.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.SnapshotUpdate)
                return object;
            let message = new $root.stealth.SnapshotUpdate();
            if (object.openPrice != null)
                if ($util.Long)
                    (message.openPrice = $util.Long.fromValue(object.openPrice)).unsigned = true;
                else if (typeof object.openPrice === "string")
                    message.openPrice = parseInt(object.openPrice, 10);
                else if (typeof object.openPrice === "number")
                    message.openPrice = object.openPrice;
                else if (typeof object.openPrice === "object")
                    message.openPrice = new $util.LongBits(object.openPrice.low >>> 0, object.openPrice.high >>> 0).toNumber(true);
            if (object.highPrice != null)
                if ($util.Long)
                    (message.highPrice = $util.Long.fromValue(object.highPrice)).unsigned = true;
                else if (typeof object.highPrice === "string")
                    message.highPrice = parseInt(object.highPrice, 10);
                else if (typeof object.highPrice === "number")
                    message.highPrice = object.highPrice;
                else if (typeof object.highPrice === "object")
                    message.highPrice = new $util.LongBits(object.highPrice.low >>> 0, object.highPrice.high >>> 0).toNumber(true);
            if (object.lowPrice != null)
                if ($util.Long)
                    (message.lowPrice = $util.Long.fromValue(object.lowPrice)).unsigned = true;
                else if (typeof object.lowPrice === "string")
                    message.lowPrice = parseInt(object.lowPrice, 10);
                else if (typeof object.lowPrice === "number")
                    message.lowPrice = object.lowPrice;
                else if (typeof object.lowPrice === "object")
                    message.lowPrice = new $util.LongBits(object.lowPrice.low >>> 0, object.lowPrice.high >>> 0).toNumber(true);
            if (object.closePrice != null)
                if ($util.Long)
                    (message.closePrice = $util.Long.fromValue(object.closePrice)).unsigned = true;
                else if (typeof object.closePrice === "string")
                    message.closePrice = parseInt(object.closePrice, 10);
                else if (typeof object.closePrice === "number")
                    message.closePrice = object.closePrice;
                else if (typeof object.closePrice === "object")
                    message.closePrice = new $util.LongBits(object.closePrice.low >>> 0, object.closePrice.high >>> 0).toNumber(true);
            if (object.previousClose != null)
                if ($util.Long)
                    (message.previousClose = $util.Long.fromValue(object.previousClose)).unsigned = true;
                else if (typeof object.previousClose === "string")
                    message.previousClose = parseInt(object.previousClose, 10);
                else if (typeof object.previousClose === "number")
                    message.previousClose = object.previousClose;
                else if (typeof object.previousClose === "object")
                    message.previousClose = new $util.LongBits(object.previousClose.low >>> 0, object.previousClose.high >>> 0).toNumber(true);
            if (object.volume != null)
                if ($util.Long)
                    (message.volume = $util.Long.fromValue(object.volume)).unsigned = true;
                else if (typeof object.volume === "string")
                    message.volume = parseInt(object.volume, 10);
                else if (typeof object.volume === "number")
                    message.volume = object.volume;
                else if (typeof object.volume === "object")
                    message.volume = new $util.LongBits(object.volume.low >>> 0, object.volume.high >>> 0).toNumber(true);
            if (object.high52Price != null)
                if ($util.Long)
                    (message.high52Price = $util.Long.fromValue(object.high52Price)).unsigned = true;
                else if (typeof object.high52Price === "string")
                    message.high52Price = parseInt(object.high52Price, 10);
                else if (typeof object.high52Price === "number")
                    message.high52Price = object.high52Price;
                else if (typeof object.high52Price === "object")
                    message.high52Price = new $util.LongBits(object.high52Price.low >>> 0, object.high52Price.high >>> 0).toNumber(true);
            if (object.low52Price != null)
                if ($util.Long)
                    (message.low52Price = $util.Long.fromValue(object.low52Price)).unsigned = true;
                else if (typeof object.low52Price === "string")
                    message.low52Price = parseInt(object.low52Price, 10);
                else if (typeof object.low52Price === "number")
                    message.low52Price = object.low52Price;
                else if (typeof object.low52Price === "object")
                    message.low52Price = new $util.LongBits(object.low52Price.low >>> 0, object.low52Price.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a SnapshotUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.SnapshotUpdate
         * @static
         * @param {stealth.SnapshotUpdate} message SnapshotUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SnapshotUpdate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.openPrice = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.openPrice = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.highPrice = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.highPrice = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.lowPrice = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lowPrice = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.closePrice = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.closePrice = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.previousClose = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.previousClose = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.volume = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.volume = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.high52Price = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.high52Price = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.low52Price = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.low52Price = options.longs === String ? "0" : 0;
            }
            if (message.openPrice != null && message.hasOwnProperty("openPrice"))
                if (typeof message.openPrice === "number")
                    object.openPrice = options.longs === String ? String(message.openPrice) : message.openPrice;
                else
                    object.openPrice = options.longs === String ? $util.Long.prototype.toString.call(message.openPrice) : options.longs === Number ? new $util.LongBits(message.openPrice.low >>> 0, message.openPrice.high >>> 0).toNumber(true) : message.openPrice;
            if (message.highPrice != null && message.hasOwnProperty("highPrice"))
                if (typeof message.highPrice === "number")
                    object.highPrice = options.longs === String ? String(message.highPrice) : message.highPrice;
                else
                    object.highPrice = options.longs === String ? $util.Long.prototype.toString.call(message.highPrice) : options.longs === Number ? new $util.LongBits(message.highPrice.low >>> 0, message.highPrice.high >>> 0).toNumber(true) : message.highPrice;
            if (message.lowPrice != null && message.hasOwnProperty("lowPrice"))
                if (typeof message.lowPrice === "number")
                    object.lowPrice = options.longs === String ? String(message.lowPrice) : message.lowPrice;
                else
                    object.lowPrice = options.longs === String ? $util.Long.prototype.toString.call(message.lowPrice) : options.longs === Number ? new $util.LongBits(message.lowPrice.low >>> 0, message.lowPrice.high >>> 0).toNumber(true) : message.lowPrice;
            if (message.closePrice != null && message.hasOwnProperty("closePrice"))
                if (typeof message.closePrice === "number")
                    object.closePrice = options.longs === String ? String(message.closePrice) : message.closePrice;
                else
                    object.closePrice = options.longs === String ? $util.Long.prototype.toString.call(message.closePrice) : options.longs === Number ? new $util.LongBits(message.closePrice.low >>> 0, message.closePrice.high >>> 0).toNumber(true) : message.closePrice;
            if (message.previousClose != null && message.hasOwnProperty("previousClose"))
                if (typeof message.previousClose === "number")
                    object.previousClose = options.longs === String ? String(message.previousClose) : message.previousClose;
                else
                    object.previousClose = options.longs === String ? $util.Long.prototype.toString.call(message.previousClose) : options.longs === Number ? new $util.LongBits(message.previousClose.low >>> 0, message.previousClose.high >>> 0).toNumber(true) : message.previousClose;
            if (message.volume != null && message.hasOwnProperty("volume"))
                if (typeof message.volume === "number")
                    object.volume = options.longs === String ? String(message.volume) : message.volume;
                else
                    object.volume = options.longs === String ? $util.Long.prototype.toString.call(message.volume) : options.longs === Number ? new $util.LongBits(message.volume.low >>> 0, message.volume.high >>> 0).toNumber(true) : message.volume;
            if (message.high52Price != null && message.hasOwnProperty("high52Price"))
                if (typeof message.high52Price === "number")
                    object.high52Price = options.longs === String ? String(message.high52Price) : message.high52Price;
                else
                    object.high52Price = options.longs === String ? $util.Long.prototype.toString.call(message.high52Price) : options.longs === Number ? new $util.LongBits(message.high52Price.low >>> 0, message.high52Price.high >>> 0).toNumber(true) : message.high52Price;
            if (message.low52Price != null && message.hasOwnProperty("low52Price"))
                if (typeof message.low52Price === "number")
                    object.low52Price = options.longs === String ? String(message.low52Price) : message.low52Price;
                else
                    object.low52Price = options.longs === String ? $util.Long.prototype.toString.call(message.low52Price) : options.longs === Number ? new $util.LongBits(message.low52Price.low >>> 0, message.low52Price.high >>> 0).toNumber(true) : message.low52Price;
            return object;
        };

        /**
         * Converts this SnapshotUpdate to JSON.
         * @function toJSON
         * @memberof stealth.SnapshotUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SnapshotUpdate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SnapshotUpdate
         * @function getTypeUrl
         * @memberof stealth.SnapshotUpdate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SnapshotUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.SnapshotUpdate";
        };

        return SnapshotUpdate;
    })();

    stealth.StatisticsUpdate = (function() {

        /**
         * Properties of a StatisticsUpdate.
         * @memberof stealth
         * @interface IStatisticsUpdate
         * @property {number|null} [beta] StatisticsUpdate beta
         * @property {number|null} [eps] StatisticsUpdate eps
         * @property {number|null} [peRatio] StatisticsUpdate peRatio
         * @property {number|Long|null} [sharesOutstanding] StatisticsUpdate sharesOutstanding
         * @property {number|null} [historicalVolatility] StatisticsUpdate historicalVolatility
         * @property {number|null} [impliedVolatility] StatisticsUpdate impliedVolatility
         */

        /**
         * Constructs a new StatisticsUpdate.
         * @memberof stealth
         * @classdesc Represents a StatisticsUpdate.
         * @implements IStatisticsUpdate
         * @constructor
         * @param {stealth.IStatisticsUpdate=} [properties] Properties to set
         */
        function StatisticsUpdate(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StatisticsUpdate beta.
         * @member {number} beta
         * @memberof stealth.StatisticsUpdate
         * @instance
         */
        StatisticsUpdate.prototype.beta = 0;

        /**
         * StatisticsUpdate eps.
         * @member {number} eps
         * @memberof stealth.StatisticsUpdate
         * @instance
         */
        StatisticsUpdate.prototype.eps = 0;

        /**
         * StatisticsUpdate peRatio.
         * @member {number} peRatio
         * @memberof stealth.StatisticsUpdate
         * @instance
         */
        StatisticsUpdate.prototype.peRatio = 0;

        /**
         * StatisticsUpdate sharesOutstanding.
         * @member {number|Long} sharesOutstanding
         * @memberof stealth.StatisticsUpdate
         * @instance
         */
        StatisticsUpdate.prototype.sharesOutstanding = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * StatisticsUpdate historicalVolatility.
         * @member {number} historicalVolatility
         * @memberof stealth.StatisticsUpdate
         * @instance
         */
        StatisticsUpdate.prototype.historicalVolatility = 0;

        /**
         * StatisticsUpdate impliedVolatility.
         * @member {number} impliedVolatility
         * @memberof stealth.StatisticsUpdate
         * @instance
         */
        StatisticsUpdate.prototype.impliedVolatility = 0;

        /**
         * Creates a new StatisticsUpdate instance using the specified properties.
         * @function create
         * @memberof stealth.StatisticsUpdate
         * @static
         * @param {stealth.IStatisticsUpdate=} [properties] Properties to set
         * @returns {stealth.StatisticsUpdate} StatisticsUpdate instance
         */
        StatisticsUpdate.create = function create(properties) {
            return new StatisticsUpdate(properties);
        };

        /**
         * Encodes the specified StatisticsUpdate message. Does not implicitly {@link stealth.StatisticsUpdate.verify|verify} messages.
         * @function encode
         * @memberof stealth.StatisticsUpdate
         * @static
         * @param {stealth.IStatisticsUpdate} message StatisticsUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StatisticsUpdate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.beta != null && Object.hasOwnProperty.call(message, "beta"))
                writer.uint32(/* id 1, wireType 5 =*/13).float(message.beta);
            if (message.eps != null && Object.hasOwnProperty.call(message, "eps"))
                writer.uint32(/* id 2, wireType 5 =*/21).float(message.eps);
            if (message.peRatio != null && Object.hasOwnProperty.call(message, "peRatio"))
                writer.uint32(/* id 3, wireType 5 =*/29).float(message.peRatio);
            if (message.sharesOutstanding != null && Object.hasOwnProperty.call(message, "sharesOutstanding"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.sharesOutstanding);
            if (message.historicalVolatility != null && Object.hasOwnProperty.call(message, "historicalVolatility"))
                writer.uint32(/* id 5, wireType 5 =*/45).float(message.historicalVolatility);
            if (message.impliedVolatility != null && Object.hasOwnProperty.call(message, "impliedVolatility"))
                writer.uint32(/* id 6, wireType 5 =*/53).float(message.impliedVolatility);
            return writer;
        };

        /**
         * Encodes the specified StatisticsUpdate message, length delimited. Does not implicitly {@link stealth.StatisticsUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.StatisticsUpdate
         * @static
         * @param {stealth.IStatisticsUpdate} message StatisticsUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StatisticsUpdate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a StatisticsUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.StatisticsUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.StatisticsUpdate} StatisticsUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StatisticsUpdate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.StatisticsUpdate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.beta = reader.float();
                        break;
                    }
                case 2: {
                        message.eps = reader.float();
                        break;
                    }
                case 3: {
                        message.peRatio = reader.float();
                        break;
                    }
                case 4: {
                        message.sharesOutstanding = reader.uint64();
                        break;
                    }
                case 5: {
                        message.historicalVolatility = reader.float();
                        break;
                    }
                case 6: {
                        message.impliedVolatility = reader.float();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a StatisticsUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.StatisticsUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.StatisticsUpdate} StatisticsUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StatisticsUpdate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a StatisticsUpdate message.
         * @function verify
         * @memberof stealth.StatisticsUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        StatisticsUpdate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.beta != null && message.hasOwnProperty("beta"))
                if (typeof message.beta !== "number")
                    return "beta: number expected";
            if (message.eps != null && message.hasOwnProperty("eps"))
                if (typeof message.eps !== "number")
                    return "eps: number expected";
            if (message.peRatio != null && message.hasOwnProperty("peRatio"))
                if (typeof message.peRatio !== "number")
                    return "peRatio: number expected";
            if (message.sharesOutstanding != null && message.hasOwnProperty("sharesOutstanding"))
                if (!$util.isInteger(message.sharesOutstanding) && !(message.sharesOutstanding && $util.isInteger(message.sharesOutstanding.low) && $util.isInteger(message.sharesOutstanding.high)))
                    return "sharesOutstanding: integer|Long expected";
            if (message.historicalVolatility != null && message.hasOwnProperty("historicalVolatility"))
                if (typeof message.historicalVolatility !== "number")
                    return "historicalVolatility: number expected";
            if (message.impliedVolatility != null && message.hasOwnProperty("impliedVolatility"))
                if (typeof message.impliedVolatility !== "number")
                    return "impliedVolatility: number expected";
            return null;
        };

        /**
         * Creates a StatisticsUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.StatisticsUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.StatisticsUpdate} StatisticsUpdate
         */
        StatisticsUpdate.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.StatisticsUpdate)
                return object;
            let message = new $root.stealth.StatisticsUpdate();
            if (object.beta != null)
                message.beta = Number(object.beta);
            if (object.eps != null)
                message.eps = Number(object.eps);
            if (object.peRatio != null)
                message.peRatio = Number(object.peRatio);
            if (object.sharesOutstanding != null)
                if ($util.Long)
                    (message.sharesOutstanding = $util.Long.fromValue(object.sharesOutstanding)).unsigned = true;
                else if (typeof object.sharesOutstanding === "string")
                    message.sharesOutstanding = parseInt(object.sharesOutstanding, 10);
                else if (typeof object.sharesOutstanding === "number")
                    message.sharesOutstanding = object.sharesOutstanding;
                else if (typeof object.sharesOutstanding === "object")
                    message.sharesOutstanding = new $util.LongBits(object.sharesOutstanding.low >>> 0, object.sharesOutstanding.high >>> 0).toNumber(true);
            if (object.historicalVolatility != null)
                message.historicalVolatility = Number(object.historicalVolatility);
            if (object.impliedVolatility != null)
                message.impliedVolatility = Number(object.impliedVolatility);
            return message;
        };

        /**
         * Creates a plain object from a StatisticsUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.StatisticsUpdate
         * @static
         * @param {stealth.StatisticsUpdate} message StatisticsUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StatisticsUpdate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.beta = 0;
                object.eps = 0;
                object.peRatio = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.sharesOutstanding = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.sharesOutstanding = options.longs === String ? "0" : 0;
                object.historicalVolatility = 0;
                object.impliedVolatility = 0;
            }
            if (message.beta != null && message.hasOwnProperty("beta"))
                object.beta = options.json && !isFinite(message.beta) ? String(message.beta) : message.beta;
            if (message.eps != null && message.hasOwnProperty("eps"))
                object.eps = options.json && !isFinite(message.eps) ? String(message.eps) : message.eps;
            if (message.peRatio != null && message.hasOwnProperty("peRatio"))
                object.peRatio = options.json && !isFinite(message.peRatio) ? String(message.peRatio) : message.peRatio;
            if (message.sharesOutstanding != null && message.hasOwnProperty("sharesOutstanding"))
                if (typeof message.sharesOutstanding === "number")
                    object.sharesOutstanding = options.longs === String ? String(message.sharesOutstanding) : message.sharesOutstanding;
                else
                    object.sharesOutstanding = options.longs === String ? $util.Long.prototype.toString.call(message.sharesOutstanding) : options.longs === Number ? new $util.LongBits(message.sharesOutstanding.low >>> 0, message.sharesOutstanding.high >>> 0).toNumber(true) : message.sharesOutstanding;
            if (message.historicalVolatility != null && message.hasOwnProperty("historicalVolatility"))
                object.historicalVolatility = options.json && !isFinite(message.historicalVolatility) ? String(message.historicalVolatility) : message.historicalVolatility;
            if (message.impliedVolatility != null && message.hasOwnProperty("impliedVolatility"))
                object.impliedVolatility = options.json && !isFinite(message.impliedVolatility) ? String(message.impliedVolatility) : message.impliedVolatility;
            return object;
        };

        /**
         * Converts this StatisticsUpdate to JSON.
         * @function toJSON
         * @memberof stealth.StatisticsUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StatisticsUpdate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for StatisticsUpdate
         * @function getTypeUrl
         * @memberof stealth.StatisticsUpdate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        StatisticsUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.StatisticsUpdate";
        };

        return StatisticsUpdate;
    })();

    stealth.QuoteUpdate = (function() {

        /**
         * Properties of a QuoteUpdate.
         * @memberof stealth
         * @interface IQuoteUpdate
         * @property {number|Long|null} [timestamp] QuoteUpdate timestamp
         * @property {stealth.IRealtimeUpdate|null} [realtime] QuoteUpdate realtime
         * @property {stealth.ISnapshotUpdate|null} [snapshot] QuoteUpdate snapshot
         * @property {stealth.IStatisticsUpdate|null} [statistics] QuoteUpdate statistics
         */

        /**
         * Constructs a new QuoteUpdate.
         * @memberof stealth
         * @classdesc Represents a QuoteUpdate.
         * @implements IQuoteUpdate
         * @constructor
         * @param {stealth.IQuoteUpdate=} [properties] Properties to set
         */
        function QuoteUpdate(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * QuoteUpdate timestamp.
         * @member {number|Long} timestamp
         * @memberof stealth.QuoteUpdate
         * @instance
         */
        QuoteUpdate.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * QuoteUpdate realtime.
         * @member {stealth.IRealtimeUpdate|null|undefined} realtime
         * @memberof stealth.QuoteUpdate
         * @instance
         */
        QuoteUpdate.prototype.realtime = null;

        /**
         * QuoteUpdate snapshot.
         * @member {stealth.ISnapshotUpdate|null|undefined} snapshot
         * @memberof stealth.QuoteUpdate
         * @instance
         */
        QuoteUpdate.prototype.snapshot = null;

        /**
         * QuoteUpdate statistics.
         * @member {stealth.IStatisticsUpdate|null|undefined} statistics
         * @memberof stealth.QuoteUpdate
         * @instance
         */
        QuoteUpdate.prototype.statistics = null;

        /**
         * Creates a new QuoteUpdate instance using the specified properties.
         * @function create
         * @memberof stealth.QuoteUpdate
         * @static
         * @param {stealth.IQuoteUpdate=} [properties] Properties to set
         * @returns {stealth.QuoteUpdate} QuoteUpdate instance
         */
        QuoteUpdate.create = function create(properties) {
            return new QuoteUpdate(properties);
        };

        /**
         * Encodes the specified QuoteUpdate message. Does not implicitly {@link stealth.QuoteUpdate.verify|verify} messages.
         * @function encode
         * @memberof stealth.QuoteUpdate
         * @static
         * @param {stealth.IQuoteUpdate} message QuoteUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuoteUpdate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.timestamp);
            if (message.realtime != null && Object.hasOwnProperty.call(message, "realtime"))
                $root.stealth.RealtimeUpdate.encode(message.realtime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.snapshot != null && Object.hasOwnProperty.call(message, "snapshot"))
                $root.stealth.SnapshotUpdate.encode(message.snapshot, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.statistics != null && Object.hasOwnProperty.call(message, "statistics"))
                $root.stealth.StatisticsUpdate.encode(message.statistics, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified QuoteUpdate message, length delimited. Does not implicitly {@link stealth.QuoteUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.QuoteUpdate
         * @static
         * @param {stealth.IQuoteUpdate} message QuoteUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuoteUpdate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a QuoteUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.QuoteUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.QuoteUpdate} QuoteUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuoteUpdate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.QuoteUpdate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.timestamp = reader.uint64();
                        break;
                    }
                case 2: {
                        message.realtime = $root.stealth.RealtimeUpdate.decode(reader, reader.uint32());
                        break;
                    }
                case 3: {
                        message.snapshot = $root.stealth.SnapshotUpdate.decode(reader, reader.uint32());
                        break;
                    }
                case 4: {
                        message.statistics = $root.stealth.StatisticsUpdate.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a QuoteUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.QuoteUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.QuoteUpdate} QuoteUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuoteUpdate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a QuoteUpdate message.
         * @function verify
         * @memberof stealth.QuoteUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        QuoteUpdate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                    return "timestamp: integer|Long expected";
            if (message.realtime != null && message.hasOwnProperty("realtime")) {
                let error = $root.stealth.RealtimeUpdate.verify(message.realtime);
                if (error)
                    return "realtime." + error;
            }
            if (message.snapshot != null && message.hasOwnProperty("snapshot")) {
                let error = $root.stealth.SnapshotUpdate.verify(message.snapshot);
                if (error)
                    return "snapshot." + error;
            }
            if (message.statistics != null && message.hasOwnProperty("statistics")) {
                let error = $root.stealth.StatisticsUpdate.verify(message.statistics);
                if (error)
                    return "statistics." + error;
            }
            return null;
        };

        /**
         * Creates a QuoteUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.QuoteUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.QuoteUpdate} QuoteUpdate
         */
        QuoteUpdate.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.QuoteUpdate)
                return object;
            let message = new $root.stealth.QuoteUpdate();
            if (object.timestamp != null)
                if ($util.Long)
                    (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
                else if (typeof object.timestamp === "string")
                    message.timestamp = parseInt(object.timestamp, 10);
                else if (typeof object.timestamp === "number")
                    message.timestamp = object.timestamp;
                else if (typeof object.timestamp === "object")
                    message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
            if (object.realtime != null) {
                if (typeof object.realtime !== "object")
                    throw TypeError(".stealth.QuoteUpdate.realtime: object expected");
                message.realtime = $root.stealth.RealtimeUpdate.fromObject(object.realtime);
            }
            if (object.snapshot != null) {
                if (typeof object.snapshot !== "object")
                    throw TypeError(".stealth.QuoteUpdate.snapshot: object expected");
                message.snapshot = $root.stealth.SnapshotUpdate.fromObject(object.snapshot);
            }
            if (object.statistics != null) {
                if (typeof object.statistics !== "object")
                    throw TypeError(".stealth.QuoteUpdate.statistics: object expected");
                message.statistics = $root.stealth.StatisticsUpdate.fromObject(object.statistics);
            }
            return message;
        };

        /**
         * Creates a plain object from a QuoteUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.QuoteUpdate
         * @static
         * @param {stealth.QuoteUpdate} message QuoteUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        QuoteUpdate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.timestamp = options.longs === String ? "0" : 0;
                object.realtime = null;
                object.snapshot = null;
                object.statistics = null;
            }
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (typeof message.timestamp === "number")
                    object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                else
                    object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
            if (message.realtime != null && message.hasOwnProperty("realtime"))
                object.realtime = $root.stealth.RealtimeUpdate.toObject(message.realtime, options);
            if (message.snapshot != null && message.hasOwnProperty("snapshot"))
                object.snapshot = $root.stealth.SnapshotUpdate.toObject(message.snapshot, options);
            if (message.statistics != null && message.hasOwnProperty("statistics"))
                object.statistics = $root.stealth.StatisticsUpdate.toObject(message.statistics, options);
            return object;
        };

        /**
         * Converts this QuoteUpdate to JSON.
         * @function toJSON
         * @memberof stealth.QuoteUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        QuoteUpdate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for QuoteUpdate
         * @function getTypeUrl
         * @memberof stealth.QuoteUpdate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        QuoteUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.QuoteUpdate";
        };

        return QuoteUpdate;
    })();

    stealth.SentimentSpline = (function() {

        /**
         * Properties of a SentimentSpline.
         * @memberof stealth
         * @interface ISentimentSpline
         * @property {number|null} [average] SentimentSpline average
         * @property {number|null} [i] SentimentSpline i
         * @property {number|null} [j] SentimentSpline j
         * @property {number|null} [x] SentimentSpline x
         * @property {number|null} [y] SentimentSpline y
         * @property {number|null} [z] SentimentSpline z
         */

        /**
         * Constructs a new SentimentSpline.
         * @memberof stealth
         * @classdesc Represents a SentimentSpline.
         * @implements ISentimentSpline
         * @constructor
         * @param {stealth.ISentimentSpline=} [properties] Properties to set
         */
        function SentimentSpline(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SentimentSpline average.
         * @member {number} average
         * @memberof stealth.SentimentSpline
         * @instance
         */
        SentimentSpline.prototype.average = 0;

        /**
         * SentimentSpline i.
         * @member {number} i
         * @memberof stealth.SentimentSpline
         * @instance
         */
        SentimentSpline.prototype.i = 0;

        /**
         * SentimentSpline j.
         * @member {number} j
         * @memberof stealth.SentimentSpline
         * @instance
         */
        SentimentSpline.prototype.j = 0;

        /**
         * SentimentSpline x.
         * @member {number} x
         * @memberof stealth.SentimentSpline
         * @instance
         */
        SentimentSpline.prototype.x = 0;

        /**
         * SentimentSpline y.
         * @member {number} y
         * @memberof stealth.SentimentSpline
         * @instance
         */
        SentimentSpline.prototype.y = 0;

        /**
         * SentimentSpline z.
         * @member {number} z
         * @memberof stealth.SentimentSpline
         * @instance
         */
        SentimentSpline.prototype.z = 0;

        /**
         * Creates a new SentimentSpline instance using the specified properties.
         * @function create
         * @memberof stealth.SentimentSpline
         * @static
         * @param {stealth.ISentimentSpline=} [properties] Properties to set
         * @returns {stealth.SentimentSpline} SentimentSpline instance
         */
        SentimentSpline.create = function create(properties) {
            return new SentimentSpline(properties);
        };

        /**
         * Encodes the specified SentimentSpline message. Does not implicitly {@link stealth.SentimentSpline.verify|verify} messages.
         * @function encode
         * @memberof stealth.SentimentSpline
         * @static
         * @param {stealth.ISentimentSpline} message SentimentSpline message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SentimentSpline.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.average != null && Object.hasOwnProperty.call(message, "average"))
                writer.uint32(/* id 1, wireType 0 =*/8).sint32(message.average);
            if (message.i != null && Object.hasOwnProperty.call(message, "i"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.i);
            if (message.j != null && Object.hasOwnProperty.call(message, "j"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.j);
            if (message.x != null && Object.hasOwnProperty.call(message, "x"))
                writer.uint32(/* id 4, wireType 0 =*/32).sint32(message.x);
            if (message.y != null && Object.hasOwnProperty.call(message, "y"))
                writer.uint32(/* id 5, wireType 0 =*/40).sint32(message.y);
            if (message.z != null && Object.hasOwnProperty.call(message, "z"))
                writer.uint32(/* id 6, wireType 0 =*/48).sint32(message.z);
            return writer;
        };

        /**
         * Encodes the specified SentimentSpline message, length delimited. Does not implicitly {@link stealth.SentimentSpline.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.SentimentSpline
         * @static
         * @param {stealth.ISentimentSpline} message SentimentSpline message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SentimentSpline.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SentimentSpline message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.SentimentSpline
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.SentimentSpline} SentimentSpline
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SentimentSpline.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.SentimentSpline();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.average = reader.sint32();
                        break;
                    }
                case 2: {
                        message.i = reader.uint32();
                        break;
                    }
                case 3: {
                        message.j = reader.uint32();
                        break;
                    }
                case 4: {
                        message.x = reader.sint32();
                        break;
                    }
                case 5: {
                        message.y = reader.sint32();
                        break;
                    }
                case 6: {
                        message.z = reader.sint32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SentimentSpline message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.SentimentSpline
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.SentimentSpline} SentimentSpline
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SentimentSpline.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SentimentSpline message.
         * @function verify
         * @memberof stealth.SentimentSpline
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SentimentSpline.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.average != null && message.hasOwnProperty("average"))
                if (!$util.isInteger(message.average))
                    return "average: integer expected";
            if (message.i != null && message.hasOwnProperty("i"))
                if (!$util.isInteger(message.i))
                    return "i: integer expected";
            if (message.j != null && message.hasOwnProperty("j"))
                if (!$util.isInteger(message.j))
                    return "j: integer expected";
            if (message.x != null && message.hasOwnProperty("x"))
                if (!$util.isInteger(message.x))
                    return "x: integer expected";
            if (message.y != null && message.hasOwnProperty("y"))
                if (!$util.isInteger(message.y))
                    return "y: integer expected";
            if (message.z != null && message.hasOwnProperty("z"))
                if (!$util.isInteger(message.z))
                    return "z: integer expected";
            return null;
        };

        /**
         * Creates a SentimentSpline message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.SentimentSpline
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.SentimentSpline} SentimentSpline
         */
        SentimentSpline.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.SentimentSpline)
                return object;
            let message = new $root.stealth.SentimentSpline();
            if (object.average != null)
                message.average = object.average | 0;
            if (object.i != null)
                message.i = object.i >>> 0;
            if (object.j != null)
                message.j = object.j >>> 0;
            if (object.x != null)
                message.x = object.x | 0;
            if (object.y != null)
                message.y = object.y | 0;
            if (object.z != null)
                message.z = object.z | 0;
            return message;
        };

        /**
         * Creates a plain object from a SentimentSpline message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.SentimentSpline
         * @static
         * @param {stealth.SentimentSpline} message SentimentSpline
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SentimentSpline.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.average = 0;
                object.i = 0;
                object.j = 0;
                object.x = 0;
                object.y = 0;
                object.z = 0;
            }
            if (message.average != null && message.hasOwnProperty("average"))
                object.average = message.average;
            if (message.i != null && message.hasOwnProperty("i"))
                object.i = message.i;
            if (message.j != null && message.hasOwnProperty("j"))
                object.j = message.j;
            if (message.x != null && message.hasOwnProperty("x"))
                object.x = message.x;
            if (message.y != null && message.hasOwnProperty("y"))
                object.y = message.y;
            if (message.z != null && message.hasOwnProperty("z"))
                object.z = message.z;
            return object;
        };

        /**
         * Converts this SentimentSpline to JSON.
         * @function toJSON
         * @memberof stealth.SentimentSpline
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SentimentSpline.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SentimentSpline
         * @function getTypeUrl
         * @memberof stealth.SentimentSpline
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SentimentSpline.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.SentimentSpline";
        };

        return SentimentSpline;
    })();

    stealth.SentimentUpdate = (function() {

        /**
         * Properties of a SentimentUpdate.
         * @memberof stealth
         * @interface ISentimentUpdate
         * @property {number|Long|null} [timestamp] SentimentUpdate timestamp
         * @property {stealth.ISentimentSpline|null} [lengths] SentimentUpdate lengths
         * @property {stealth.ISentimentSpline|null} [colors] SentimentUpdate colors
         * @property {boolean|null} [isDirty] SentimentUpdate isDirty
         */

        /**
         * Constructs a new SentimentUpdate.
         * @memberof stealth
         * @classdesc Represents a SentimentUpdate.
         * @implements ISentimentUpdate
         * @constructor
         * @param {stealth.ISentimentUpdate=} [properties] Properties to set
         */
        function SentimentUpdate(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SentimentUpdate timestamp.
         * @member {number|Long} timestamp
         * @memberof stealth.SentimentUpdate
         * @instance
         */
        SentimentUpdate.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SentimentUpdate lengths.
         * @member {stealth.ISentimentSpline|null|undefined} lengths
         * @memberof stealth.SentimentUpdate
         * @instance
         */
        SentimentUpdate.prototype.lengths = null;

        /**
         * SentimentUpdate colors.
         * @member {stealth.ISentimentSpline|null|undefined} colors
         * @memberof stealth.SentimentUpdate
         * @instance
         */
        SentimentUpdate.prototype.colors = null;

        /**
         * SentimentUpdate isDirty.
         * @member {boolean} isDirty
         * @memberof stealth.SentimentUpdate
         * @instance
         */
        SentimentUpdate.prototype.isDirty = false;

        /**
         * Creates a new SentimentUpdate instance using the specified properties.
         * @function create
         * @memberof stealth.SentimentUpdate
         * @static
         * @param {stealth.ISentimentUpdate=} [properties] Properties to set
         * @returns {stealth.SentimentUpdate} SentimentUpdate instance
         */
        SentimentUpdate.create = function create(properties) {
            return new SentimentUpdate(properties);
        };

        /**
         * Encodes the specified SentimentUpdate message. Does not implicitly {@link stealth.SentimentUpdate.verify|verify} messages.
         * @function encode
         * @memberof stealth.SentimentUpdate
         * @static
         * @param {stealth.ISentimentUpdate} message SentimentUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SentimentUpdate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.timestamp);
            if (message.lengths != null && Object.hasOwnProperty.call(message, "lengths"))
                $root.stealth.SentimentSpline.encode(message.lengths, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.colors != null && Object.hasOwnProperty.call(message, "colors"))
                $root.stealth.SentimentSpline.encode(message.colors, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.isDirty != null && Object.hasOwnProperty.call(message, "isDirty"))
                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isDirty);
            return writer;
        };

        /**
         * Encodes the specified SentimentUpdate message, length delimited. Does not implicitly {@link stealth.SentimentUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.SentimentUpdate
         * @static
         * @param {stealth.ISentimentUpdate} message SentimentUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SentimentUpdate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SentimentUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.SentimentUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.SentimentUpdate} SentimentUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SentimentUpdate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.SentimentUpdate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.timestamp = reader.uint64();
                        break;
                    }
                case 2: {
                        message.lengths = $root.stealth.SentimentSpline.decode(reader, reader.uint32());
                        break;
                    }
                case 3: {
                        message.colors = $root.stealth.SentimentSpline.decode(reader, reader.uint32());
                        break;
                    }
                case 4: {
                        message.isDirty = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SentimentUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.SentimentUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.SentimentUpdate} SentimentUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SentimentUpdate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SentimentUpdate message.
         * @function verify
         * @memberof stealth.SentimentUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SentimentUpdate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                    return "timestamp: integer|Long expected";
            if (message.lengths != null && message.hasOwnProperty("lengths")) {
                let error = $root.stealth.SentimentSpline.verify(message.lengths);
                if (error)
                    return "lengths." + error;
            }
            if (message.colors != null && message.hasOwnProperty("colors")) {
                let error = $root.stealth.SentimentSpline.verify(message.colors);
                if (error)
                    return "colors." + error;
            }
            if (message.isDirty != null && message.hasOwnProperty("isDirty"))
                if (typeof message.isDirty !== "boolean")
                    return "isDirty: boolean expected";
            return null;
        };

        /**
         * Creates a SentimentUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.SentimentUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.SentimentUpdate} SentimentUpdate
         */
        SentimentUpdate.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.SentimentUpdate)
                return object;
            let message = new $root.stealth.SentimentUpdate();
            if (object.timestamp != null)
                if ($util.Long)
                    (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
                else if (typeof object.timestamp === "string")
                    message.timestamp = parseInt(object.timestamp, 10);
                else if (typeof object.timestamp === "number")
                    message.timestamp = object.timestamp;
                else if (typeof object.timestamp === "object")
                    message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
            if (object.lengths != null) {
                if (typeof object.lengths !== "object")
                    throw TypeError(".stealth.SentimentUpdate.lengths: object expected");
                message.lengths = $root.stealth.SentimentSpline.fromObject(object.lengths);
            }
            if (object.colors != null) {
                if (typeof object.colors !== "object")
                    throw TypeError(".stealth.SentimentUpdate.colors: object expected");
                message.colors = $root.stealth.SentimentSpline.fromObject(object.colors);
            }
            if (object.isDirty != null)
                message.isDirty = Boolean(object.isDirty);
            return message;
        };

        /**
         * Creates a plain object from a SentimentUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.SentimentUpdate
         * @static
         * @param {stealth.SentimentUpdate} message SentimentUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SentimentUpdate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.timestamp = options.longs === String ? "0" : 0;
                object.lengths = null;
                object.colors = null;
                object.isDirty = false;
            }
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (typeof message.timestamp === "number")
                    object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                else
                    object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
            if (message.lengths != null && message.hasOwnProperty("lengths"))
                object.lengths = $root.stealth.SentimentSpline.toObject(message.lengths, options);
            if (message.colors != null && message.hasOwnProperty("colors"))
                object.colors = $root.stealth.SentimentSpline.toObject(message.colors, options);
            if (message.isDirty != null && message.hasOwnProperty("isDirty"))
                object.isDirty = message.isDirty;
            return object;
        };

        /**
         * Converts this SentimentUpdate to JSON.
         * @function toJSON
         * @memberof stealth.SentimentUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SentimentUpdate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SentimentUpdate
         * @function getTypeUrl
         * @memberof stealth.SentimentUpdate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SentimentUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.SentimentUpdate";
        };

        return SentimentUpdate;
    })();

    stealth.EquilibriumUpdate = (function() {

        /**
         * Properties of an EquilibriumUpdate.
         * @memberof stealth
         * @interface IEquilibriumUpdate
         * @property {number|Long|null} [timestamp] EquilibriumUpdate timestamp
         * @property {number|Long|null} [equilibriumPrice] EquilibriumUpdate equilibriumPrice
         * @property {number|Long|null} [gapSize] EquilibriumUpdate gapSize
         * @property {number|null} [high] EquilibriumUpdate high
         * @property {number|null} [low] EquilibriumUpdate low
         * @property {number|null} [projected] EquilibriumUpdate projected
         * @property {number|null} [bias] EquilibriumUpdate bias
         * @property {number|Long|null} [lastPrice] EquilibriumUpdate lastPrice
         * @property {boolean|null} [isDirty] EquilibriumUpdate isDirty
         */

        /**
         * Constructs a new EquilibriumUpdate.
         * @memberof stealth
         * @classdesc Represents an EquilibriumUpdate.
         * @implements IEquilibriumUpdate
         * @constructor
         * @param {stealth.IEquilibriumUpdate=} [properties] Properties to set
         */
        function EquilibriumUpdate(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EquilibriumUpdate timestamp.
         * @member {number|Long} timestamp
         * @memberof stealth.EquilibriumUpdate
         * @instance
         */
        EquilibriumUpdate.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * EquilibriumUpdate equilibriumPrice.
         * @member {number|Long} equilibriumPrice
         * @memberof stealth.EquilibriumUpdate
         * @instance
         */
        EquilibriumUpdate.prototype.equilibriumPrice = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * EquilibriumUpdate gapSize.
         * @member {number|Long} gapSize
         * @memberof stealth.EquilibriumUpdate
         * @instance
         */
        EquilibriumUpdate.prototype.gapSize = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * EquilibriumUpdate high.
         * @member {number} high
         * @memberof stealth.EquilibriumUpdate
         * @instance
         */
        EquilibriumUpdate.prototype.high = 0;

        /**
         * EquilibriumUpdate low.
         * @member {number} low
         * @memberof stealth.EquilibriumUpdate
         * @instance
         */
        EquilibriumUpdate.prototype.low = 0;

        /**
         * EquilibriumUpdate projected.
         * @member {number} projected
         * @memberof stealth.EquilibriumUpdate
         * @instance
         */
        EquilibriumUpdate.prototype.projected = 0;

        /**
         * EquilibriumUpdate bias.
         * @member {number} bias
         * @memberof stealth.EquilibriumUpdate
         * @instance
         */
        EquilibriumUpdate.prototype.bias = 0;

        /**
         * EquilibriumUpdate lastPrice.
         * @member {number|Long} lastPrice
         * @memberof stealth.EquilibriumUpdate
         * @instance
         */
        EquilibriumUpdate.prototype.lastPrice = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * EquilibriumUpdate isDirty.
         * @member {boolean} isDirty
         * @memberof stealth.EquilibriumUpdate
         * @instance
         */
        EquilibriumUpdate.prototype.isDirty = false;

        /**
         * Creates a new EquilibriumUpdate instance using the specified properties.
         * @function create
         * @memberof stealth.EquilibriumUpdate
         * @static
         * @param {stealth.IEquilibriumUpdate=} [properties] Properties to set
         * @returns {stealth.EquilibriumUpdate} EquilibriumUpdate instance
         */
        EquilibriumUpdate.create = function create(properties) {
            return new EquilibriumUpdate(properties);
        };

        /**
         * Encodes the specified EquilibriumUpdate message. Does not implicitly {@link stealth.EquilibriumUpdate.verify|verify} messages.
         * @function encode
         * @memberof stealth.EquilibriumUpdate
         * @static
         * @param {stealth.IEquilibriumUpdate} message EquilibriumUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EquilibriumUpdate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.timestamp);
            if (message.equilibriumPrice != null && Object.hasOwnProperty.call(message, "equilibriumPrice"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.equilibriumPrice);
            if (message.gapSize != null && Object.hasOwnProperty.call(message, "gapSize"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.gapSize);
            if (message.high != null && Object.hasOwnProperty.call(message, "high"))
                writer.uint32(/* id 4, wireType 0 =*/32).sint32(message.high);
            if (message.low != null && Object.hasOwnProperty.call(message, "low"))
                writer.uint32(/* id 5, wireType 0 =*/40).sint32(message.low);
            if (message.projected != null && Object.hasOwnProperty.call(message, "projected"))
                writer.uint32(/* id 6, wireType 0 =*/48).sint32(message.projected);
            if (message.bias != null && Object.hasOwnProperty.call(message, "bias"))
                writer.uint32(/* id 7, wireType 0 =*/56).sint32(message.bias);
            if (message.lastPrice != null && Object.hasOwnProperty.call(message, "lastPrice"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint64(message.lastPrice);
            if (message.isDirty != null && Object.hasOwnProperty.call(message, "isDirty"))
                writer.uint32(/* id 9, wireType 0 =*/72).bool(message.isDirty);
            return writer;
        };

        /**
         * Encodes the specified EquilibriumUpdate message, length delimited. Does not implicitly {@link stealth.EquilibriumUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.EquilibriumUpdate
         * @static
         * @param {stealth.IEquilibriumUpdate} message EquilibriumUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EquilibriumUpdate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EquilibriumUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.EquilibriumUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.EquilibriumUpdate} EquilibriumUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EquilibriumUpdate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.EquilibriumUpdate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.timestamp = reader.uint64();
                        break;
                    }
                case 2: {
                        message.equilibriumPrice = reader.uint64();
                        break;
                    }
                case 3: {
                        message.gapSize = reader.uint64();
                        break;
                    }
                case 4: {
                        message.high = reader.sint32();
                        break;
                    }
                case 5: {
                        message.low = reader.sint32();
                        break;
                    }
                case 6: {
                        message.projected = reader.sint32();
                        break;
                    }
                case 7: {
                        message.bias = reader.sint32();
                        break;
                    }
                case 8: {
                        message.lastPrice = reader.uint64();
                        break;
                    }
                case 9: {
                        message.isDirty = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EquilibriumUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.EquilibriumUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.EquilibriumUpdate} EquilibriumUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EquilibriumUpdate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EquilibriumUpdate message.
         * @function verify
         * @memberof stealth.EquilibriumUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EquilibriumUpdate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                    return "timestamp: integer|Long expected";
            if (message.equilibriumPrice != null && message.hasOwnProperty("equilibriumPrice"))
                if (!$util.isInteger(message.equilibriumPrice) && !(message.equilibriumPrice && $util.isInteger(message.equilibriumPrice.low) && $util.isInteger(message.equilibriumPrice.high)))
                    return "equilibriumPrice: integer|Long expected";
            if (message.gapSize != null && message.hasOwnProperty("gapSize"))
                if (!$util.isInteger(message.gapSize) && !(message.gapSize && $util.isInteger(message.gapSize.low) && $util.isInteger(message.gapSize.high)))
                    return "gapSize: integer|Long expected";
            if (message.high != null && message.hasOwnProperty("high"))
                if (!$util.isInteger(message.high))
                    return "high: integer expected";
            if (message.low != null && message.hasOwnProperty("low"))
                if (!$util.isInteger(message.low))
                    return "low: integer expected";
            if (message.projected != null && message.hasOwnProperty("projected"))
                if (!$util.isInteger(message.projected))
                    return "projected: integer expected";
            if (message.bias != null && message.hasOwnProperty("bias"))
                if (!$util.isInteger(message.bias))
                    return "bias: integer expected";
            if (message.lastPrice != null && message.hasOwnProperty("lastPrice"))
                if (!$util.isInteger(message.lastPrice) && !(message.lastPrice && $util.isInteger(message.lastPrice.low) && $util.isInteger(message.lastPrice.high)))
                    return "lastPrice: integer|Long expected";
            if (message.isDirty != null && message.hasOwnProperty("isDirty"))
                if (typeof message.isDirty !== "boolean")
                    return "isDirty: boolean expected";
            return null;
        };

        /**
         * Creates an EquilibriumUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.EquilibriumUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.EquilibriumUpdate} EquilibriumUpdate
         */
        EquilibriumUpdate.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.EquilibriumUpdate)
                return object;
            let message = new $root.stealth.EquilibriumUpdate();
            if (object.timestamp != null)
                if ($util.Long)
                    (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
                else if (typeof object.timestamp === "string")
                    message.timestamp = parseInt(object.timestamp, 10);
                else if (typeof object.timestamp === "number")
                    message.timestamp = object.timestamp;
                else if (typeof object.timestamp === "object")
                    message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
            if (object.equilibriumPrice != null)
                if ($util.Long)
                    (message.equilibriumPrice = $util.Long.fromValue(object.equilibriumPrice)).unsigned = true;
                else if (typeof object.equilibriumPrice === "string")
                    message.equilibriumPrice = parseInt(object.equilibriumPrice, 10);
                else if (typeof object.equilibriumPrice === "number")
                    message.equilibriumPrice = object.equilibriumPrice;
                else if (typeof object.equilibriumPrice === "object")
                    message.equilibriumPrice = new $util.LongBits(object.equilibriumPrice.low >>> 0, object.equilibriumPrice.high >>> 0).toNumber(true);
            if (object.gapSize != null)
                if ($util.Long)
                    (message.gapSize = $util.Long.fromValue(object.gapSize)).unsigned = true;
                else if (typeof object.gapSize === "string")
                    message.gapSize = parseInt(object.gapSize, 10);
                else if (typeof object.gapSize === "number")
                    message.gapSize = object.gapSize;
                else if (typeof object.gapSize === "object")
                    message.gapSize = new $util.LongBits(object.gapSize.low >>> 0, object.gapSize.high >>> 0).toNumber(true);
            if (object.high != null)
                message.high = object.high | 0;
            if (object.low != null)
                message.low = object.low | 0;
            if (object.projected != null)
                message.projected = object.projected | 0;
            if (object.bias != null)
                message.bias = object.bias | 0;
            if (object.lastPrice != null)
                if ($util.Long)
                    (message.lastPrice = $util.Long.fromValue(object.lastPrice)).unsigned = true;
                else if (typeof object.lastPrice === "string")
                    message.lastPrice = parseInt(object.lastPrice, 10);
                else if (typeof object.lastPrice === "number")
                    message.lastPrice = object.lastPrice;
                else if (typeof object.lastPrice === "object")
                    message.lastPrice = new $util.LongBits(object.lastPrice.low >>> 0, object.lastPrice.high >>> 0).toNumber(true);
            if (object.isDirty != null)
                message.isDirty = Boolean(object.isDirty);
            return message;
        };

        /**
         * Creates a plain object from an EquilibriumUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.EquilibriumUpdate
         * @static
         * @param {stealth.EquilibriumUpdate} message EquilibriumUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EquilibriumUpdate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.timestamp = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.equilibriumPrice = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.equilibriumPrice = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.gapSize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.gapSize = options.longs === String ? "0" : 0;
                object.high = 0;
                object.low = 0;
                object.projected = 0;
                object.bias = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.lastPrice = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastPrice = options.longs === String ? "0" : 0;
                object.isDirty = false;
            }
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (typeof message.timestamp === "number")
                    object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                else
                    object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
            if (message.equilibriumPrice != null && message.hasOwnProperty("equilibriumPrice"))
                if (typeof message.equilibriumPrice === "number")
                    object.equilibriumPrice = options.longs === String ? String(message.equilibriumPrice) : message.equilibriumPrice;
                else
                    object.equilibriumPrice = options.longs === String ? $util.Long.prototype.toString.call(message.equilibriumPrice) : options.longs === Number ? new $util.LongBits(message.equilibriumPrice.low >>> 0, message.equilibriumPrice.high >>> 0).toNumber(true) : message.equilibriumPrice;
            if (message.gapSize != null && message.hasOwnProperty("gapSize"))
                if (typeof message.gapSize === "number")
                    object.gapSize = options.longs === String ? String(message.gapSize) : message.gapSize;
                else
                    object.gapSize = options.longs === String ? $util.Long.prototype.toString.call(message.gapSize) : options.longs === Number ? new $util.LongBits(message.gapSize.low >>> 0, message.gapSize.high >>> 0).toNumber(true) : message.gapSize;
            if (message.high != null && message.hasOwnProperty("high"))
                object.high = message.high;
            if (message.low != null && message.hasOwnProperty("low"))
                object.low = message.low;
            if (message.projected != null && message.hasOwnProperty("projected"))
                object.projected = message.projected;
            if (message.bias != null && message.hasOwnProperty("bias"))
                object.bias = message.bias;
            if (message.lastPrice != null && message.hasOwnProperty("lastPrice"))
                if (typeof message.lastPrice === "number")
                    object.lastPrice = options.longs === String ? String(message.lastPrice) : message.lastPrice;
                else
                    object.lastPrice = options.longs === String ? $util.Long.prototype.toString.call(message.lastPrice) : options.longs === Number ? new $util.LongBits(message.lastPrice.low >>> 0, message.lastPrice.high >>> 0).toNumber(true) : message.lastPrice;
            if (message.isDirty != null && message.hasOwnProperty("isDirty"))
                object.isDirty = message.isDirty;
            return object;
        };

        /**
         * Converts this EquilibriumUpdate to JSON.
         * @function toJSON
         * @memberof stealth.EquilibriumUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EquilibriumUpdate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for EquilibriumUpdate
         * @function getTypeUrl
         * @memberof stealth.EquilibriumUpdate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        EquilibriumUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.EquilibriumUpdate";
        };

        return EquilibriumUpdate;
    })();

    stealth.MultiframeUpdate = (function() {

        /**
         * Properties of a MultiframeUpdate.
         * @memberof stealth
         * @interface IMultiframeUpdate
         * @property {number|Long|null} [timestamp] MultiframeUpdate timestamp
         * @property {number|null} [min_5] MultiframeUpdate min_5
         * @property {number|null} [min_10] MultiframeUpdate min_10
         * @property {number|null} [min_15] MultiframeUpdate min_15
         * @property {number|null} [min_30] MultiframeUpdate min_30
         * @property {number|null} [min_45] MultiframeUpdate min_45
         * @property {number|null} [min_60] MultiframeUpdate min_60
         * @property {number|null} [min_120] MultiframeUpdate min_120
         * @property {number|null} [min_180] MultiframeUpdate min_180
         * @property {number|null} [min_240] MultiframeUpdate min_240
         * @property {number|null} [day_1] MultiframeUpdate day_1
         * @property {boolean|null} [isDirty] MultiframeUpdate isDirty
         */

        /**
         * Constructs a new MultiframeUpdate.
         * @memberof stealth
         * @classdesc Represents a MultiframeUpdate.
         * @implements IMultiframeUpdate
         * @constructor
         * @param {stealth.IMultiframeUpdate=} [properties] Properties to set
         */
        function MultiframeUpdate(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MultiframeUpdate timestamp.
         * @member {number|Long} timestamp
         * @memberof stealth.MultiframeUpdate
         * @instance
         */
        MultiframeUpdate.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * MultiframeUpdate min_5.
         * @member {number} min_5
         * @memberof stealth.MultiframeUpdate
         * @instance
         */
        MultiframeUpdate.prototype.min_5 = 0;

        /**
         * MultiframeUpdate min_10.
         * @member {number} min_10
         * @memberof stealth.MultiframeUpdate
         * @instance
         */
        MultiframeUpdate.prototype.min_10 = 0;

        /**
         * MultiframeUpdate min_15.
         * @member {number} min_15
         * @memberof stealth.MultiframeUpdate
         * @instance
         */
        MultiframeUpdate.prototype.min_15 = 0;

        /**
         * MultiframeUpdate min_30.
         * @member {number} min_30
         * @memberof stealth.MultiframeUpdate
         * @instance
         */
        MultiframeUpdate.prototype.min_30 = 0;

        /**
         * MultiframeUpdate min_45.
         * @member {number} min_45
         * @memberof stealth.MultiframeUpdate
         * @instance
         */
        MultiframeUpdate.prototype.min_45 = 0;

        /**
         * MultiframeUpdate min_60.
         * @member {number} min_60
         * @memberof stealth.MultiframeUpdate
         * @instance
         */
        MultiframeUpdate.prototype.min_60 = 0;

        /**
         * MultiframeUpdate min_120.
         * @member {number} min_120
         * @memberof stealth.MultiframeUpdate
         * @instance
         */
        MultiframeUpdate.prototype.min_120 = 0;

        /**
         * MultiframeUpdate min_180.
         * @member {number} min_180
         * @memberof stealth.MultiframeUpdate
         * @instance
         */
        MultiframeUpdate.prototype.min_180 = 0;

        /**
         * MultiframeUpdate min_240.
         * @member {number} min_240
         * @memberof stealth.MultiframeUpdate
         * @instance
         */
        MultiframeUpdate.prototype.min_240 = 0;

        /**
         * MultiframeUpdate day_1.
         * @member {number} day_1
         * @memberof stealth.MultiframeUpdate
         * @instance
         */
        MultiframeUpdate.prototype.day_1 = 0;

        /**
         * MultiframeUpdate isDirty.
         * @member {boolean} isDirty
         * @memberof stealth.MultiframeUpdate
         * @instance
         */
        MultiframeUpdate.prototype.isDirty = false;

        /**
         * Creates a new MultiframeUpdate instance using the specified properties.
         * @function create
         * @memberof stealth.MultiframeUpdate
         * @static
         * @param {stealth.IMultiframeUpdate=} [properties] Properties to set
         * @returns {stealth.MultiframeUpdate} MultiframeUpdate instance
         */
        MultiframeUpdate.create = function create(properties) {
            return new MultiframeUpdate(properties);
        };

        /**
         * Encodes the specified MultiframeUpdate message. Does not implicitly {@link stealth.MultiframeUpdate.verify|verify} messages.
         * @function encode
         * @memberof stealth.MultiframeUpdate
         * @static
         * @param {stealth.IMultiframeUpdate} message MultiframeUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MultiframeUpdate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.timestamp);
            if (message.min_5 != null && Object.hasOwnProperty.call(message, "min_5"))
                writer.uint32(/* id 2, wireType 0 =*/16).sint32(message.min_5);
            if (message.min_10 != null && Object.hasOwnProperty.call(message, "min_10"))
                writer.uint32(/* id 3, wireType 0 =*/24).sint32(message.min_10);
            if (message.min_15 != null && Object.hasOwnProperty.call(message, "min_15"))
                writer.uint32(/* id 4, wireType 0 =*/32).sint32(message.min_15);
            if (message.min_30 != null && Object.hasOwnProperty.call(message, "min_30"))
                writer.uint32(/* id 5, wireType 0 =*/40).sint32(message.min_30);
            if (message.min_45 != null && Object.hasOwnProperty.call(message, "min_45"))
                writer.uint32(/* id 6, wireType 0 =*/48).sint32(message.min_45);
            if (message.min_60 != null && Object.hasOwnProperty.call(message, "min_60"))
                writer.uint32(/* id 7, wireType 0 =*/56).sint32(message.min_60);
            if (message.min_120 != null && Object.hasOwnProperty.call(message, "min_120"))
                writer.uint32(/* id 8, wireType 0 =*/64).sint32(message.min_120);
            if (message.min_180 != null && Object.hasOwnProperty.call(message, "min_180"))
                writer.uint32(/* id 9, wireType 0 =*/72).sint32(message.min_180);
            if (message.min_240 != null && Object.hasOwnProperty.call(message, "min_240"))
                writer.uint32(/* id 10, wireType 0 =*/80).sint32(message.min_240);
            if (message.day_1 != null && Object.hasOwnProperty.call(message, "day_1"))
                writer.uint32(/* id 11, wireType 0 =*/88).sint32(message.day_1);
            if (message.isDirty != null && Object.hasOwnProperty.call(message, "isDirty"))
                writer.uint32(/* id 12, wireType 0 =*/96).bool(message.isDirty);
            return writer;
        };

        /**
         * Encodes the specified MultiframeUpdate message, length delimited. Does not implicitly {@link stealth.MultiframeUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.MultiframeUpdate
         * @static
         * @param {stealth.IMultiframeUpdate} message MultiframeUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MultiframeUpdate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MultiframeUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.MultiframeUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.MultiframeUpdate} MultiframeUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MultiframeUpdate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.MultiframeUpdate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.timestamp = reader.uint64();
                        break;
                    }
                case 2: {
                        message.min_5 = reader.sint32();
                        break;
                    }
                case 3: {
                        message.min_10 = reader.sint32();
                        break;
                    }
                case 4: {
                        message.min_15 = reader.sint32();
                        break;
                    }
                case 5: {
                        message.min_30 = reader.sint32();
                        break;
                    }
                case 6: {
                        message.min_45 = reader.sint32();
                        break;
                    }
                case 7: {
                        message.min_60 = reader.sint32();
                        break;
                    }
                case 8: {
                        message.min_120 = reader.sint32();
                        break;
                    }
                case 9: {
                        message.min_180 = reader.sint32();
                        break;
                    }
                case 10: {
                        message.min_240 = reader.sint32();
                        break;
                    }
                case 11: {
                        message.day_1 = reader.sint32();
                        break;
                    }
                case 12: {
                        message.isDirty = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MultiframeUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.MultiframeUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.MultiframeUpdate} MultiframeUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MultiframeUpdate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MultiframeUpdate message.
         * @function verify
         * @memberof stealth.MultiframeUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MultiframeUpdate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                    return "timestamp: integer|Long expected";
            if (message.min_5 != null && message.hasOwnProperty("min_5"))
                if (!$util.isInteger(message.min_5))
                    return "min_5: integer expected";
            if (message.min_10 != null && message.hasOwnProperty("min_10"))
                if (!$util.isInteger(message.min_10))
                    return "min_10: integer expected";
            if (message.min_15 != null && message.hasOwnProperty("min_15"))
                if (!$util.isInteger(message.min_15))
                    return "min_15: integer expected";
            if (message.min_30 != null && message.hasOwnProperty("min_30"))
                if (!$util.isInteger(message.min_30))
                    return "min_30: integer expected";
            if (message.min_45 != null && message.hasOwnProperty("min_45"))
                if (!$util.isInteger(message.min_45))
                    return "min_45: integer expected";
            if (message.min_60 != null && message.hasOwnProperty("min_60"))
                if (!$util.isInteger(message.min_60))
                    return "min_60: integer expected";
            if (message.min_120 != null && message.hasOwnProperty("min_120"))
                if (!$util.isInteger(message.min_120))
                    return "min_120: integer expected";
            if (message.min_180 != null && message.hasOwnProperty("min_180"))
                if (!$util.isInteger(message.min_180))
                    return "min_180: integer expected";
            if (message.min_240 != null && message.hasOwnProperty("min_240"))
                if (!$util.isInteger(message.min_240))
                    return "min_240: integer expected";
            if (message.day_1 != null && message.hasOwnProperty("day_1"))
                if (!$util.isInteger(message.day_1))
                    return "day_1: integer expected";
            if (message.isDirty != null && message.hasOwnProperty("isDirty"))
                if (typeof message.isDirty !== "boolean")
                    return "isDirty: boolean expected";
            return null;
        };

        /**
         * Creates a MultiframeUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.MultiframeUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.MultiframeUpdate} MultiframeUpdate
         */
        MultiframeUpdate.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.MultiframeUpdate)
                return object;
            let message = new $root.stealth.MultiframeUpdate();
            if (object.timestamp != null)
                if ($util.Long)
                    (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
                else if (typeof object.timestamp === "string")
                    message.timestamp = parseInt(object.timestamp, 10);
                else if (typeof object.timestamp === "number")
                    message.timestamp = object.timestamp;
                else if (typeof object.timestamp === "object")
                    message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
            if (object.min_5 != null)
                message.min_5 = object.min_5 | 0;
            if (object.min_10 != null)
                message.min_10 = object.min_10 | 0;
            if (object.min_15 != null)
                message.min_15 = object.min_15 | 0;
            if (object.min_30 != null)
                message.min_30 = object.min_30 | 0;
            if (object.min_45 != null)
                message.min_45 = object.min_45 | 0;
            if (object.min_60 != null)
                message.min_60 = object.min_60 | 0;
            if (object.min_120 != null)
                message.min_120 = object.min_120 | 0;
            if (object.min_180 != null)
                message.min_180 = object.min_180 | 0;
            if (object.min_240 != null)
                message.min_240 = object.min_240 | 0;
            if (object.day_1 != null)
                message.day_1 = object.day_1 | 0;
            if (object.isDirty != null)
                message.isDirty = Boolean(object.isDirty);
            return message;
        };

        /**
         * Creates a plain object from a MultiframeUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.MultiframeUpdate
         * @static
         * @param {stealth.MultiframeUpdate} message MultiframeUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MultiframeUpdate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.timestamp = options.longs === String ? "0" : 0;
                object.min_5 = 0;
                object.min_10 = 0;
                object.min_15 = 0;
                object.min_30 = 0;
                object.min_45 = 0;
                object.min_60 = 0;
                object.min_120 = 0;
                object.min_180 = 0;
                object.min_240 = 0;
                object.day_1 = 0;
                object.isDirty = false;
            }
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (typeof message.timestamp === "number")
                    object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                else
                    object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
            if (message.min_5 != null && message.hasOwnProperty("min_5"))
                object.min_5 = message.min_5;
            if (message.min_10 != null && message.hasOwnProperty("min_10"))
                object.min_10 = message.min_10;
            if (message.min_15 != null && message.hasOwnProperty("min_15"))
                object.min_15 = message.min_15;
            if (message.min_30 != null && message.hasOwnProperty("min_30"))
                object.min_30 = message.min_30;
            if (message.min_45 != null && message.hasOwnProperty("min_45"))
                object.min_45 = message.min_45;
            if (message.min_60 != null && message.hasOwnProperty("min_60"))
                object.min_60 = message.min_60;
            if (message.min_120 != null && message.hasOwnProperty("min_120"))
                object.min_120 = message.min_120;
            if (message.min_180 != null && message.hasOwnProperty("min_180"))
                object.min_180 = message.min_180;
            if (message.min_240 != null && message.hasOwnProperty("min_240"))
                object.min_240 = message.min_240;
            if (message.day_1 != null && message.hasOwnProperty("day_1"))
                object.day_1 = message.day_1;
            if (message.isDirty != null && message.hasOwnProperty("isDirty"))
                object.isDirty = message.isDirty;
            return object;
        };

        /**
         * Converts this MultiframeUpdate to JSON.
         * @function toJSON
         * @memberof stealth.MultiframeUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MultiframeUpdate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MultiframeUpdate
         * @function getTypeUrl
         * @memberof stealth.MultiframeUpdate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MultiframeUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.MultiframeUpdate";
        };

        return MultiframeUpdate;
    })();

    stealth.TriggerUpdate = (function() {

        /**
         * Properties of a TriggerUpdate.
         * @memberof stealth
         * @interface ITriggerUpdate
         * @property {number|Long|null} [timestamp] TriggerUpdate timestamp
         * @property {number|null} [bias] TriggerUpdate bias
         * @property {number|null} [perception] TriggerUpdate perception
         * @property {number|null} [sentiment] TriggerUpdate sentiment
         * @property {number|null} [commitment] TriggerUpdate commitment
         * @property {number|Long|null} [equilibriumPrice] TriggerUpdate equilibriumPrice
         * @property {number|Long|null} [gapSize] TriggerUpdate gapSize
         * @property {number|Long|null} [lastPrice] TriggerUpdate lastPrice
         * @property {boolean|null} [isDirty] TriggerUpdate isDirty
         */

        /**
         * Constructs a new TriggerUpdate.
         * @memberof stealth
         * @classdesc Represents a TriggerUpdate.
         * @implements ITriggerUpdate
         * @constructor
         * @param {stealth.ITriggerUpdate=} [properties] Properties to set
         */
        function TriggerUpdate(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TriggerUpdate timestamp.
         * @member {number|Long} timestamp
         * @memberof stealth.TriggerUpdate
         * @instance
         */
        TriggerUpdate.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * TriggerUpdate bias.
         * @member {number} bias
         * @memberof stealth.TriggerUpdate
         * @instance
         */
        TriggerUpdate.prototype.bias = 0;

        /**
         * TriggerUpdate perception.
         * @member {number} perception
         * @memberof stealth.TriggerUpdate
         * @instance
         */
        TriggerUpdate.prototype.perception = 0;

        /**
         * TriggerUpdate sentiment.
         * @member {number} sentiment
         * @memberof stealth.TriggerUpdate
         * @instance
         */
        TriggerUpdate.prototype.sentiment = 0;

        /**
         * TriggerUpdate commitment.
         * @member {number} commitment
         * @memberof stealth.TriggerUpdate
         * @instance
         */
        TriggerUpdate.prototype.commitment = 0;

        /**
         * TriggerUpdate equilibriumPrice.
         * @member {number|Long} equilibriumPrice
         * @memberof stealth.TriggerUpdate
         * @instance
         */
        TriggerUpdate.prototype.equilibriumPrice = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * TriggerUpdate gapSize.
         * @member {number|Long} gapSize
         * @memberof stealth.TriggerUpdate
         * @instance
         */
        TriggerUpdate.prototype.gapSize = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * TriggerUpdate lastPrice.
         * @member {number|Long} lastPrice
         * @memberof stealth.TriggerUpdate
         * @instance
         */
        TriggerUpdate.prototype.lastPrice = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * TriggerUpdate isDirty.
         * @member {boolean} isDirty
         * @memberof stealth.TriggerUpdate
         * @instance
         */
        TriggerUpdate.prototype.isDirty = false;

        /**
         * Creates a new TriggerUpdate instance using the specified properties.
         * @function create
         * @memberof stealth.TriggerUpdate
         * @static
         * @param {stealth.ITriggerUpdate=} [properties] Properties to set
         * @returns {stealth.TriggerUpdate} TriggerUpdate instance
         */
        TriggerUpdate.create = function create(properties) {
            return new TriggerUpdate(properties);
        };

        /**
         * Encodes the specified TriggerUpdate message. Does not implicitly {@link stealth.TriggerUpdate.verify|verify} messages.
         * @function encode
         * @memberof stealth.TriggerUpdate
         * @static
         * @param {stealth.ITriggerUpdate} message TriggerUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TriggerUpdate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.timestamp);
            if (message.bias != null && Object.hasOwnProperty.call(message, "bias"))
                writer.uint32(/* id 2, wireType 0 =*/16).sint32(message.bias);
            if (message.perception != null && Object.hasOwnProperty.call(message, "perception"))
                writer.uint32(/* id 3, wireType 0 =*/24).sint32(message.perception);
            if (message.sentiment != null && Object.hasOwnProperty.call(message, "sentiment"))
                writer.uint32(/* id 4, wireType 0 =*/32).sint32(message.sentiment);
            if (message.commitment != null && Object.hasOwnProperty.call(message, "commitment"))
                writer.uint32(/* id 5, wireType 0 =*/40).sint32(message.commitment);
            if (message.equilibriumPrice != null && Object.hasOwnProperty.call(message, "equilibriumPrice"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.equilibriumPrice);
            if (message.gapSize != null && Object.hasOwnProperty.call(message, "gapSize"))
                writer.uint32(/* id 7, wireType 0 =*/56).uint64(message.gapSize);
            if (message.lastPrice != null && Object.hasOwnProperty.call(message, "lastPrice"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint64(message.lastPrice);
            if (message.isDirty != null && Object.hasOwnProperty.call(message, "isDirty"))
                writer.uint32(/* id 9, wireType 0 =*/72).bool(message.isDirty);
            return writer;
        };

        /**
         * Encodes the specified TriggerUpdate message, length delimited. Does not implicitly {@link stealth.TriggerUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.TriggerUpdate
         * @static
         * @param {stealth.ITriggerUpdate} message TriggerUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TriggerUpdate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TriggerUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.TriggerUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.TriggerUpdate} TriggerUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TriggerUpdate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.TriggerUpdate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.timestamp = reader.uint64();
                        break;
                    }
                case 2: {
                        message.bias = reader.sint32();
                        break;
                    }
                case 3: {
                        message.perception = reader.sint32();
                        break;
                    }
                case 4: {
                        message.sentiment = reader.sint32();
                        break;
                    }
                case 5: {
                        message.commitment = reader.sint32();
                        break;
                    }
                case 6: {
                        message.equilibriumPrice = reader.uint64();
                        break;
                    }
                case 7: {
                        message.gapSize = reader.uint64();
                        break;
                    }
                case 8: {
                        message.lastPrice = reader.uint64();
                        break;
                    }
                case 9: {
                        message.isDirty = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TriggerUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.TriggerUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.TriggerUpdate} TriggerUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TriggerUpdate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TriggerUpdate message.
         * @function verify
         * @memberof stealth.TriggerUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TriggerUpdate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                    return "timestamp: integer|Long expected";
            if (message.bias != null && message.hasOwnProperty("bias"))
                if (!$util.isInteger(message.bias))
                    return "bias: integer expected";
            if (message.perception != null && message.hasOwnProperty("perception"))
                if (!$util.isInteger(message.perception))
                    return "perception: integer expected";
            if (message.sentiment != null && message.hasOwnProperty("sentiment"))
                if (!$util.isInteger(message.sentiment))
                    return "sentiment: integer expected";
            if (message.commitment != null && message.hasOwnProperty("commitment"))
                if (!$util.isInteger(message.commitment))
                    return "commitment: integer expected";
            if (message.equilibriumPrice != null && message.hasOwnProperty("equilibriumPrice"))
                if (!$util.isInteger(message.equilibriumPrice) && !(message.equilibriumPrice && $util.isInteger(message.equilibriumPrice.low) && $util.isInteger(message.equilibriumPrice.high)))
                    return "equilibriumPrice: integer|Long expected";
            if (message.gapSize != null && message.hasOwnProperty("gapSize"))
                if (!$util.isInteger(message.gapSize) && !(message.gapSize && $util.isInteger(message.gapSize.low) && $util.isInteger(message.gapSize.high)))
                    return "gapSize: integer|Long expected";
            if (message.lastPrice != null && message.hasOwnProperty("lastPrice"))
                if (!$util.isInteger(message.lastPrice) && !(message.lastPrice && $util.isInteger(message.lastPrice.low) && $util.isInteger(message.lastPrice.high)))
                    return "lastPrice: integer|Long expected";
            if (message.isDirty != null && message.hasOwnProperty("isDirty"))
                if (typeof message.isDirty !== "boolean")
                    return "isDirty: boolean expected";
            return null;
        };

        /**
         * Creates a TriggerUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.TriggerUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.TriggerUpdate} TriggerUpdate
         */
        TriggerUpdate.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.TriggerUpdate)
                return object;
            let message = new $root.stealth.TriggerUpdate();
            if (object.timestamp != null)
                if ($util.Long)
                    (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
                else if (typeof object.timestamp === "string")
                    message.timestamp = parseInt(object.timestamp, 10);
                else if (typeof object.timestamp === "number")
                    message.timestamp = object.timestamp;
                else if (typeof object.timestamp === "object")
                    message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
            if (object.bias != null)
                message.bias = object.bias | 0;
            if (object.perception != null)
                message.perception = object.perception | 0;
            if (object.sentiment != null)
                message.sentiment = object.sentiment | 0;
            if (object.commitment != null)
                message.commitment = object.commitment | 0;
            if (object.equilibriumPrice != null)
                if ($util.Long)
                    (message.equilibriumPrice = $util.Long.fromValue(object.equilibriumPrice)).unsigned = true;
                else if (typeof object.equilibriumPrice === "string")
                    message.equilibriumPrice = parseInt(object.equilibriumPrice, 10);
                else if (typeof object.equilibriumPrice === "number")
                    message.equilibriumPrice = object.equilibriumPrice;
                else if (typeof object.equilibriumPrice === "object")
                    message.equilibriumPrice = new $util.LongBits(object.equilibriumPrice.low >>> 0, object.equilibriumPrice.high >>> 0).toNumber(true);
            if (object.gapSize != null)
                if ($util.Long)
                    (message.gapSize = $util.Long.fromValue(object.gapSize)).unsigned = true;
                else if (typeof object.gapSize === "string")
                    message.gapSize = parseInt(object.gapSize, 10);
                else if (typeof object.gapSize === "number")
                    message.gapSize = object.gapSize;
                else if (typeof object.gapSize === "object")
                    message.gapSize = new $util.LongBits(object.gapSize.low >>> 0, object.gapSize.high >>> 0).toNumber(true);
            if (object.lastPrice != null)
                if ($util.Long)
                    (message.lastPrice = $util.Long.fromValue(object.lastPrice)).unsigned = true;
                else if (typeof object.lastPrice === "string")
                    message.lastPrice = parseInt(object.lastPrice, 10);
                else if (typeof object.lastPrice === "number")
                    message.lastPrice = object.lastPrice;
                else if (typeof object.lastPrice === "object")
                    message.lastPrice = new $util.LongBits(object.lastPrice.low >>> 0, object.lastPrice.high >>> 0).toNumber(true);
            if (object.isDirty != null)
                message.isDirty = Boolean(object.isDirty);
            return message;
        };

        /**
         * Creates a plain object from a TriggerUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.TriggerUpdate
         * @static
         * @param {stealth.TriggerUpdate} message TriggerUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TriggerUpdate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.timestamp = options.longs === String ? "0" : 0;
                object.bias = 0;
                object.perception = 0;
                object.sentiment = 0;
                object.commitment = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.equilibriumPrice = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.equilibriumPrice = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.gapSize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.gapSize = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.lastPrice = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastPrice = options.longs === String ? "0" : 0;
                object.isDirty = false;
            }
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (typeof message.timestamp === "number")
                    object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                else
                    object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
            if (message.bias != null && message.hasOwnProperty("bias"))
                object.bias = message.bias;
            if (message.perception != null && message.hasOwnProperty("perception"))
                object.perception = message.perception;
            if (message.sentiment != null && message.hasOwnProperty("sentiment"))
                object.sentiment = message.sentiment;
            if (message.commitment != null && message.hasOwnProperty("commitment"))
                object.commitment = message.commitment;
            if (message.equilibriumPrice != null && message.hasOwnProperty("equilibriumPrice"))
                if (typeof message.equilibriumPrice === "number")
                    object.equilibriumPrice = options.longs === String ? String(message.equilibriumPrice) : message.equilibriumPrice;
                else
                    object.equilibriumPrice = options.longs === String ? $util.Long.prototype.toString.call(message.equilibriumPrice) : options.longs === Number ? new $util.LongBits(message.equilibriumPrice.low >>> 0, message.equilibriumPrice.high >>> 0).toNumber(true) : message.equilibriumPrice;
            if (message.gapSize != null && message.hasOwnProperty("gapSize"))
                if (typeof message.gapSize === "number")
                    object.gapSize = options.longs === String ? String(message.gapSize) : message.gapSize;
                else
                    object.gapSize = options.longs === String ? $util.Long.prototype.toString.call(message.gapSize) : options.longs === Number ? new $util.LongBits(message.gapSize.low >>> 0, message.gapSize.high >>> 0).toNumber(true) : message.gapSize;
            if (message.lastPrice != null && message.hasOwnProperty("lastPrice"))
                if (typeof message.lastPrice === "number")
                    object.lastPrice = options.longs === String ? String(message.lastPrice) : message.lastPrice;
                else
                    object.lastPrice = options.longs === String ? $util.Long.prototype.toString.call(message.lastPrice) : options.longs === Number ? new $util.LongBits(message.lastPrice.low >>> 0, message.lastPrice.high >>> 0).toNumber(true) : message.lastPrice;
            if (message.isDirty != null && message.hasOwnProperty("isDirty"))
                object.isDirty = message.isDirty;
            return object;
        };

        /**
         * Converts this TriggerUpdate to JSON.
         * @function toJSON
         * @memberof stealth.TriggerUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TriggerUpdate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for TriggerUpdate
         * @function getTypeUrl
         * @memberof stealth.TriggerUpdate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        TriggerUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.TriggerUpdate";
        };

        return TriggerUpdate;
    })();

    stealth.SingleValueUpdate = (function() {

        /**
         * Properties of a SingleValueUpdate.
         * @memberof stealth
         * @interface ISingleValueUpdate
         * @property {number|Long|null} [timestamp] SingleValueUpdate timestamp
         * @property {number|null} [value] SingleValueUpdate value
         * @property {boolean|null} [isDirty] SingleValueUpdate isDirty
         */

        /**
         * Constructs a new SingleValueUpdate.
         * @memberof stealth
         * @classdesc Represents a SingleValueUpdate.
         * @implements ISingleValueUpdate
         * @constructor
         * @param {stealth.ISingleValueUpdate=} [properties] Properties to set
         */
        function SingleValueUpdate(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SingleValueUpdate timestamp.
         * @member {number|Long} timestamp
         * @memberof stealth.SingleValueUpdate
         * @instance
         */
        SingleValueUpdate.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SingleValueUpdate value.
         * @member {number} value
         * @memberof stealth.SingleValueUpdate
         * @instance
         */
        SingleValueUpdate.prototype.value = 0;

        /**
         * SingleValueUpdate isDirty.
         * @member {boolean} isDirty
         * @memberof stealth.SingleValueUpdate
         * @instance
         */
        SingleValueUpdate.prototype.isDirty = false;

        /**
         * Creates a new SingleValueUpdate instance using the specified properties.
         * @function create
         * @memberof stealth.SingleValueUpdate
         * @static
         * @param {stealth.ISingleValueUpdate=} [properties] Properties to set
         * @returns {stealth.SingleValueUpdate} SingleValueUpdate instance
         */
        SingleValueUpdate.create = function create(properties) {
            return new SingleValueUpdate(properties);
        };

        /**
         * Encodes the specified SingleValueUpdate message. Does not implicitly {@link stealth.SingleValueUpdate.verify|verify} messages.
         * @function encode
         * @memberof stealth.SingleValueUpdate
         * @static
         * @param {stealth.ISingleValueUpdate} message SingleValueUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SingleValueUpdate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.timestamp);
            if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                writer.uint32(/* id 2, wireType 0 =*/16).sint32(message.value);
            if (message.isDirty != null && Object.hasOwnProperty.call(message, "isDirty"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.isDirty);
            return writer;
        };

        /**
         * Encodes the specified SingleValueUpdate message, length delimited. Does not implicitly {@link stealth.SingleValueUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.SingleValueUpdate
         * @static
         * @param {stealth.ISingleValueUpdate} message SingleValueUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SingleValueUpdate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SingleValueUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.SingleValueUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.SingleValueUpdate} SingleValueUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SingleValueUpdate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.SingleValueUpdate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.timestamp = reader.uint64();
                        break;
                    }
                case 2: {
                        message.value = reader.sint32();
                        break;
                    }
                case 3: {
                        message.isDirty = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SingleValueUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.SingleValueUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.SingleValueUpdate} SingleValueUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SingleValueUpdate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SingleValueUpdate message.
         * @function verify
         * @memberof stealth.SingleValueUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SingleValueUpdate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                    return "timestamp: integer|Long expected";
            if (message.value != null && message.hasOwnProperty("value"))
                if (!$util.isInteger(message.value))
                    return "value: integer expected";
            if (message.isDirty != null && message.hasOwnProperty("isDirty"))
                if (typeof message.isDirty !== "boolean")
                    return "isDirty: boolean expected";
            return null;
        };

        /**
         * Creates a SingleValueUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.SingleValueUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.SingleValueUpdate} SingleValueUpdate
         */
        SingleValueUpdate.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.SingleValueUpdate)
                return object;
            let message = new $root.stealth.SingleValueUpdate();
            if (object.timestamp != null)
                if ($util.Long)
                    (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
                else if (typeof object.timestamp === "string")
                    message.timestamp = parseInt(object.timestamp, 10);
                else if (typeof object.timestamp === "number")
                    message.timestamp = object.timestamp;
                else if (typeof object.timestamp === "object")
                    message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
            if (object.value != null)
                message.value = object.value | 0;
            if (object.isDirty != null)
                message.isDirty = Boolean(object.isDirty);
            return message;
        };

        /**
         * Creates a plain object from a SingleValueUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.SingleValueUpdate
         * @static
         * @param {stealth.SingleValueUpdate} message SingleValueUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SingleValueUpdate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.timestamp = options.longs === String ? "0" : 0;
                object.value = 0;
                object.isDirty = false;
            }
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (typeof message.timestamp === "number")
                    object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                else
                    object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = message.value;
            if (message.isDirty != null && message.hasOwnProperty("isDirty"))
                object.isDirty = message.isDirty;
            return object;
        };

        /**
         * Converts this SingleValueUpdate to JSON.
         * @function toJSON
         * @memberof stealth.SingleValueUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SingleValueUpdate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SingleValueUpdate
         * @function getTypeUrl
         * @memberof stealth.SingleValueUpdate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SingleValueUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.SingleValueUpdate";
        };

        return SingleValueUpdate;
    })();

    stealth.StrategyUpdate = (function() {

        /**
         * Properties of a StrategyUpdate.
         * @memberof stealth
         * @interface IStrategyUpdate
         * @property {number|Long|null} [timestamp] StrategyUpdate timestamp
         * @property {number|null} [entryProgress] StrategyUpdate entryProgress
         * @property {number|null} [exitProgress] StrategyUpdate exitProgress
         * @property {stealth.StrategySignal|null} [signal] StrategyUpdate signal
         * @property {number|null} [perceptionLevel] StrategyUpdate perceptionLevel
         * @property {stealth.GaugeSignal|null} [perceptionSignal] StrategyUpdate perceptionSignal
         * @property {number|null} [commitmentLevel] StrategyUpdate commitmentLevel
         * @property {stealth.GaugeSignal|null} [commitmentSignal] StrategyUpdate commitmentSignal
         * @property {stealth.GaugeSignal|null} [sentimentSignal] StrategyUpdate sentimentSignal
         * @property {stealth.GaugeSignal|null} [equilibriumSignal] StrategyUpdate equilibriumSignal
         * @property {number|null} [sentimentLevel] StrategyUpdate sentimentLevel
         * @property {number|null} [equilibriumLevel] StrategyUpdate equilibriumLevel
         */

        /**
         * Constructs a new StrategyUpdate.
         * @memberof stealth
         * @classdesc Represents a StrategyUpdate.
         * @implements IStrategyUpdate
         * @constructor
         * @param {stealth.IStrategyUpdate=} [properties] Properties to set
         */
        function StrategyUpdate(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StrategyUpdate timestamp.
         * @member {number|Long} timestamp
         * @memberof stealth.StrategyUpdate
         * @instance
         */
        StrategyUpdate.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * StrategyUpdate entryProgress.
         * @member {number} entryProgress
         * @memberof stealth.StrategyUpdate
         * @instance
         */
        StrategyUpdate.prototype.entryProgress = 0;

        /**
         * StrategyUpdate exitProgress.
         * @member {number} exitProgress
         * @memberof stealth.StrategyUpdate
         * @instance
         */
        StrategyUpdate.prototype.exitProgress = 0;

        /**
         * StrategyUpdate signal.
         * @member {stealth.StrategySignal} signal
         * @memberof stealth.StrategyUpdate
         * @instance
         */
        StrategyUpdate.prototype.signal = 0;

        /**
         * StrategyUpdate perceptionLevel.
         * @member {number} perceptionLevel
         * @memberof stealth.StrategyUpdate
         * @instance
         */
        StrategyUpdate.prototype.perceptionLevel = 0;

        /**
         * StrategyUpdate perceptionSignal.
         * @member {stealth.GaugeSignal} perceptionSignal
         * @memberof stealth.StrategyUpdate
         * @instance
         */
        StrategyUpdate.prototype.perceptionSignal = 0;

        /**
         * StrategyUpdate commitmentLevel.
         * @member {number} commitmentLevel
         * @memberof stealth.StrategyUpdate
         * @instance
         */
        StrategyUpdate.prototype.commitmentLevel = 0;

        /**
         * StrategyUpdate commitmentSignal.
         * @member {stealth.GaugeSignal} commitmentSignal
         * @memberof stealth.StrategyUpdate
         * @instance
         */
        StrategyUpdate.prototype.commitmentSignal = 0;

        /**
         * StrategyUpdate sentimentSignal.
         * @member {stealth.GaugeSignal} sentimentSignal
         * @memberof stealth.StrategyUpdate
         * @instance
         */
        StrategyUpdate.prototype.sentimentSignal = 0;

        /**
         * StrategyUpdate equilibriumSignal.
         * @member {stealth.GaugeSignal} equilibriumSignal
         * @memberof stealth.StrategyUpdate
         * @instance
         */
        StrategyUpdate.prototype.equilibriumSignal = 0;

        /**
         * StrategyUpdate sentimentLevel.
         * @member {number} sentimentLevel
         * @memberof stealth.StrategyUpdate
         * @instance
         */
        StrategyUpdate.prototype.sentimentLevel = 0;

        /**
         * StrategyUpdate equilibriumLevel.
         * @member {number} equilibriumLevel
         * @memberof stealth.StrategyUpdate
         * @instance
         */
        StrategyUpdate.prototype.equilibriumLevel = 0;

        /**
         * Creates a new StrategyUpdate instance using the specified properties.
         * @function create
         * @memberof stealth.StrategyUpdate
         * @static
         * @param {stealth.IStrategyUpdate=} [properties] Properties to set
         * @returns {stealth.StrategyUpdate} StrategyUpdate instance
         */
        StrategyUpdate.create = function create(properties) {
            return new StrategyUpdate(properties);
        };

        /**
         * Encodes the specified StrategyUpdate message. Does not implicitly {@link stealth.StrategyUpdate.verify|verify} messages.
         * @function encode
         * @memberof stealth.StrategyUpdate
         * @static
         * @param {stealth.IStrategyUpdate} message StrategyUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StrategyUpdate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.timestamp);
            if (message.entryProgress != null && Object.hasOwnProperty.call(message, "entryProgress"))
                writer.uint32(/* id 2, wireType 0 =*/16).sint32(message.entryProgress);
            if (message.exitProgress != null && Object.hasOwnProperty.call(message, "exitProgress"))
                writer.uint32(/* id 3, wireType 0 =*/24).sint32(message.exitProgress);
            if (message.signal != null && Object.hasOwnProperty.call(message, "signal"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.signal);
            if (message.perceptionLevel != null && Object.hasOwnProperty.call(message, "perceptionLevel"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.perceptionLevel);
            if (message.perceptionSignal != null && Object.hasOwnProperty.call(message, "perceptionSignal"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.perceptionSignal);
            if (message.commitmentLevel != null && Object.hasOwnProperty.call(message, "commitmentLevel"))
                writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.commitmentLevel);
            if (message.commitmentSignal != null && Object.hasOwnProperty.call(message, "commitmentSignal"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.commitmentSignal);
            if (message.sentimentSignal != null && Object.hasOwnProperty.call(message, "sentimentSignal"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.sentimentSignal);
            if (message.equilibriumSignal != null && Object.hasOwnProperty.call(message, "equilibriumSignal"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.equilibriumSignal);
            if (message.sentimentLevel != null && Object.hasOwnProperty.call(message, "sentimentLevel"))
                writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.sentimentLevel);
            if (message.equilibriumLevel != null && Object.hasOwnProperty.call(message, "equilibriumLevel"))
                writer.uint32(/* id 12, wireType 0 =*/96).uint32(message.equilibriumLevel);
            return writer;
        };

        /**
         * Encodes the specified StrategyUpdate message, length delimited. Does not implicitly {@link stealth.StrategyUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.StrategyUpdate
         * @static
         * @param {stealth.IStrategyUpdate} message StrategyUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StrategyUpdate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a StrategyUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.StrategyUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.StrategyUpdate} StrategyUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StrategyUpdate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.StrategyUpdate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.timestamp = reader.uint64();
                        break;
                    }
                case 2: {
                        message.entryProgress = reader.sint32();
                        break;
                    }
                case 3: {
                        message.exitProgress = reader.sint32();
                        break;
                    }
                case 4: {
                        message.signal = reader.int32();
                        break;
                    }
                case 5: {
                        message.perceptionLevel = reader.uint32();
                        break;
                    }
                case 6: {
                        message.perceptionSignal = reader.int32();
                        break;
                    }
                case 7: {
                        message.commitmentLevel = reader.uint32();
                        break;
                    }
                case 8: {
                        message.commitmentSignal = reader.int32();
                        break;
                    }
                case 9: {
                        message.sentimentSignal = reader.int32();
                        break;
                    }
                case 10: {
                        message.equilibriumSignal = reader.int32();
                        break;
                    }
                case 11: {
                        message.sentimentLevel = reader.uint32();
                        break;
                    }
                case 12: {
                        message.equilibriumLevel = reader.uint32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a StrategyUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.StrategyUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.StrategyUpdate} StrategyUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StrategyUpdate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a StrategyUpdate message.
         * @function verify
         * @memberof stealth.StrategyUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        StrategyUpdate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                    return "timestamp: integer|Long expected";
            if (message.entryProgress != null && message.hasOwnProperty("entryProgress"))
                if (!$util.isInteger(message.entryProgress))
                    return "entryProgress: integer expected";
            if (message.exitProgress != null && message.hasOwnProperty("exitProgress"))
                if (!$util.isInteger(message.exitProgress))
                    return "exitProgress: integer expected";
            if (message.signal != null && message.hasOwnProperty("signal"))
                switch (message.signal) {
                default:
                    return "signal: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.perceptionLevel != null && message.hasOwnProperty("perceptionLevel"))
                if (!$util.isInteger(message.perceptionLevel))
                    return "perceptionLevel: integer expected";
            if (message.perceptionSignal != null && message.hasOwnProperty("perceptionSignal"))
                switch (message.perceptionSignal) {
                default:
                    return "perceptionSignal: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.commitmentLevel != null && message.hasOwnProperty("commitmentLevel"))
                if (!$util.isInteger(message.commitmentLevel))
                    return "commitmentLevel: integer expected";
            if (message.commitmentSignal != null && message.hasOwnProperty("commitmentSignal"))
                switch (message.commitmentSignal) {
                default:
                    return "commitmentSignal: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.sentimentSignal != null && message.hasOwnProperty("sentimentSignal"))
                switch (message.sentimentSignal) {
                default:
                    return "sentimentSignal: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.equilibriumSignal != null && message.hasOwnProperty("equilibriumSignal"))
                switch (message.equilibriumSignal) {
                default:
                    return "equilibriumSignal: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.sentimentLevel != null && message.hasOwnProperty("sentimentLevel"))
                if (!$util.isInteger(message.sentimentLevel))
                    return "sentimentLevel: integer expected";
            if (message.equilibriumLevel != null && message.hasOwnProperty("equilibriumLevel"))
                if (!$util.isInteger(message.equilibriumLevel))
                    return "equilibriumLevel: integer expected";
            return null;
        };

        /**
         * Creates a StrategyUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.StrategyUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.StrategyUpdate} StrategyUpdate
         */
        StrategyUpdate.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.StrategyUpdate)
                return object;
            let message = new $root.stealth.StrategyUpdate();
            if (object.timestamp != null)
                if ($util.Long)
                    (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
                else if (typeof object.timestamp === "string")
                    message.timestamp = parseInt(object.timestamp, 10);
                else if (typeof object.timestamp === "number")
                    message.timestamp = object.timestamp;
                else if (typeof object.timestamp === "object")
                    message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
            if (object.entryProgress != null)
                message.entryProgress = object.entryProgress | 0;
            if (object.exitProgress != null)
                message.exitProgress = object.exitProgress | 0;
            switch (object.signal) {
            default:
                if (typeof object.signal === "number") {
                    message.signal = object.signal;
                    break;
                }
                break;
            case "None":
            case 0:
                message.signal = 0;
                break;
            case "LongSignal":
            case 1:
                message.signal = 1;
                break;
            case "ShortSignal":
            case 2:
                message.signal = 2;
                break;
            }
            if (object.perceptionLevel != null)
                message.perceptionLevel = object.perceptionLevel >>> 0;
            switch (object.perceptionSignal) {
            default:
                if (typeof object.perceptionSignal === "number") {
                    message.perceptionSignal = object.perceptionSignal;
                    break;
                }
                break;
            case "Unknown":
            case 0:
                message.perceptionSignal = 0;
                break;
            case "Short":
            case 1:
                message.perceptionSignal = 1;
                break;
            case "Flat":
            case 2:
                message.perceptionSignal = 2;
                break;
            case "Long":
            case 3:
                message.perceptionSignal = 3;
                break;
            case "Dual":
            case 4:
                message.perceptionSignal = 4;
                break;
            }
            if (object.commitmentLevel != null)
                message.commitmentLevel = object.commitmentLevel >>> 0;
            switch (object.commitmentSignal) {
            default:
                if (typeof object.commitmentSignal === "number") {
                    message.commitmentSignal = object.commitmentSignal;
                    break;
                }
                break;
            case "Unknown":
            case 0:
                message.commitmentSignal = 0;
                break;
            case "Short":
            case 1:
                message.commitmentSignal = 1;
                break;
            case "Flat":
            case 2:
                message.commitmentSignal = 2;
                break;
            case "Long":
            case 3:
                message.commitmentSignal = 3;
                break;
            case "Dual":
            case 4:
                message.commitmentSignal = 4;
                break;
            }
            switch (object.sentimentSignal) {
            default:
                if (typeof object.sentimentSignal === "number") {
                    message.sentimentSignal = object.sentimentSignal;
                    break;
                }
                break;
            case "Unknown":
            case 0:
                message.sentimentSignal = 0;
                break;
            case "Short":
            case 1:
                message.sentimentSignal = 1;
                break;
            case "Flat":
            case 2:
                message.sentimentSignal = 2;
                break;
            case "Long":
            case 3:
                message.sentimentSignal = 3;
                break;
            case "Dual":
            case 4:
                message.sentimentSignal = 4;
                break;
            }
            switch (object.equilibriumSignal) {
            default:
                if (typeof object.equilibriumSignal === "number") {
                    message.equilibriumSignal = object.equilibriumSignal;
                    break;
                }
                break;
            case "Unknown":
            case 0:
                message.equilibriumSignal = 0;
                break;
            case "Short":
            case 1:
                message.equilibriumSignal = 1;
                break;
            case "Flat":
            case 2:
                message.equilibriumSignal = 2;
                break;
            case "Long":
            case 3:
                message.equilibriumSignal = 3;
                break;
            case "Dual":
            case 4:
                message.equilibriumSignal = 4;
                break;
            }
            if (object.sentimentLevel != null)
                message.sentimentLevel = object.sentimentLevel >>> 0;
            if (object.equilibriumLevel != null)
                message.equilibriumLevel = object.equilibriumLevel >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a StrategyUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.StrategyUpdate
         * @static
         * @param {stealth.StrategyUpdate} message StrategyUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StrategyUpdate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.timestamp = options.longs === String ? "0" : 0;
                object.entryProgress = 0;
                object.exitProgress = 0;
                object.signal = options.enums === String ? "None" : 0;
                object.perceptionLevel = 0;
                object.perceptionSignal = options.enums === String ? "Unknown" : 0;
                object.commitmentLevel = 0;
                object.commitmentSignal = options.enums === String ? "Unknown" : 0;
                object.sentimentSignal = options.enums === String ? "Unknown" : 0;
                object.equilibriumSignal = options.enums === String ? "Unknown" : 0;
                object.sentimentLevel = 0;
                object.equilibriumLevel = 0;
            }
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (typeof message.timestamp === "number")
                    object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                else
                    object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
            if (message.entryProgress != null && message.hasOwnProperty("entryProgress"))
                object.entryProgress = message.entryProgress;
            if (message.exitProgress != null && message.hasOwnProperty("exitProgress"))
                object.exitProgress = message.exitProgress;
            if (message.signal != null && message.hasOwnProperty("signal"))
                object.signal = options.enums === String ? $root.stealth.StrategySignal[message.signal] === undefined ? message.signal : $root.stealth.StrategySignal[message.signal] : message.signal;
            if (message.perceptionLevel != null && message.hasOwnProperty("perceptionLevel"))
                object.perceptionLevel = message.perceptionLevel;
            if (message.perceptionSignal != null && message.hasOwnProperty("perceptionSignal"))
                object.perceptionSignal = options.enums === String ? $root.stealth.GaugeSignal[message.perceptionSignal] === undefined ? message.perceptionSignal : $root.stealth.GaugeSignal[message.perceptionSignal] : message.perceptionSignal;
            if (message.commitmentLevel != null && message.hasOwnProperty("commitmentLevel"))
                object.commitmentLevel = message.commitmentLevel;
            if (message.commitmentSignal != null && message.hasOwnProperty("commitmentSignal"))
                object.commitmentSignal = options.enums === String ? $root.stealth.GaugeSignal[message.commitmentSignal] === undefined ? message.commitmentSignal : $root.stealth.GaugeSignal[message.commitmentSignal] : message.commitmentSignal;
            if (message.sentimentSignal != null && message.hasOwnProperty("sentimentSignal"))
                object.sentimentSignal = options.enums === String ? $root.stealth.GaugeSignal[message.sentimentSignal] === undefined ? message.sentimentSignal : $root.stealth.GaugeSignal[message.sentimentSignal] : message.sentimentSignal;
            if (message.equilibriumSignal != null && message.hasOwnProperty("equilibriumSignal"))
                object.equilibriumSignal = options.enums === String ? $root.stealth.GaugeSignal[message.equilibriumSignal] === undefined ? message.equilibriumSignal : $root.stealth.GaugeSignal[message.equilibriumSignal] : message.equilibriumSignal;
            if (message.sentimentLevel != null && message.hasOwnProperty("sentimentLevel"))
                object.sentimentLevel = message.sentimentLevel;
            if (message.equilibriumLevel != null && message.hasOwnProperty("equilibriumLevel"))
                object.equilibriumLevel = message.equilibriumLevel;
            return object;
        };

        /**
         * Converts this StrategyUpdate to JSON.
         * @function toJSON
         * @memberof stealth.StrategyUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StrategyUpdate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for StrategyUpdate
         * @function getTypeUrl
         * @memberof stealth.StrategyUpdate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        StrategyUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.StrategyUpdate";
        };

        return StrategyUpdate;
    })();

    stealth.SinglePriceUpdate = (function() {

        /**
         * Properties of a SinglePriceUpdate.
         * @memberof stealth
         * @interface ISinglePriceUpdate
         * @property {number|Long|null} [timestamp] SinglePriceUpdate timestamp
         * @property {number|Long|null} [value] SinglePriceUpdate value
         * @property {boolean|null} [isDirty] SinglePriceUpdate isDirty
         */

        /**
         * Constructs a new SinglePriceUpdate.
         * @memberof stealth
         * @classdesc Represents a SinglePriceUpdate.
         * @implements ISinglePriceUpdate
         * @constructor
         * @param {stealth.ISinglePriceUpdate=} [properties] Properties to set
         */
        function SinglePriceUpdate(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SinglePriceUpdate timestamp.
         * @member {number|Long} timestamp
         * @memberof stealth.SinglePriceUpdate
         * @instance
         */
        SinglePriceUpdate.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SinglePriceUpdate value.
         * @member {number|Long} value
         * @memberof stealth.SinglePriceUpdate
         * @instance
         */
        SinglePriceUpdate.prototype.value = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SinglePriceUpdate isDirty.
         * @member {boolean} isDirty
         * @memberof stealth.SinglePriceUpdate
         * @instance
         */
        SinglePriceUpdate.prototype.isDirty = false;

        /**
         * Creates a new SinglePriceUpdate instance using the specified properties.
         * @function create
         * @memberof stealth.SinglePriceUpdate
         * @static
         * @param {stealth.ISinglePriceUpdate=} [properties] Properties to set
         * @returns {stealth.SinglePriceUpdate} SinglePriceUpdate instance
         */
        SinglePriceUpdate.create = function create(properties) {
            return new SinglePriceUpdate(properties);
        };

        /**
         * Encodes the specified SinglePriceUpdate message. Does not implicitly {@link stealth.SinglePriceUpdate.verify|verify} messages.
         * @function encode
         * @memberof stealth.SinglePriceUpdate
         * @static
         * @param {stealth.ISinglePriceUpdate} message SinglePriceUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SinglePriceUpdate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.timestamp);
            if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.value);
            if (message.isDirty != null && Object.hasOwnProperty.call(message, "isDirty"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.isDirty);
            return writer;
        };

        /**
         * Encodes the specified SinglePriceUpdate message, length delimited. Does not implicitly {@link stealth.SinglePriceUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.SinglePriceUpdate
         * @static
         * @param {stealth.ISinglePriceUpdate} message SinglePriceUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SinglePriceUpdate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SinglePriceUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.SinglePriceUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.SinglePriceUpdate} SinglePriceUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SinglePriceUpdate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.SinglePriceUpdate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.timestamp = reader.uint64();
                        break;
                    }
                case 2: {
                        message.value = reader.uint64();
                        break;
                    }
                case 3: {
                        message.isDirty = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SinglePriceUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.SinglePriceUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.SinglePriceUpdate} SinglePriceUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SinglePriceUpdate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SinglePriceUpdate message.
         * @function verify
         * @memberof stealth.SinglePriceUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SinglePriceUpdate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                    return "timestamp: integer|Long expected";
            if (message.value != null && message.hasOwnProperty("value"))
                if (!$util.isInteger(message.value) && !(message.value && $util.isInteger(message.value.low) && $util.isInteger(message.value.high)))
                    return "value: integer|Long expected";
            if (message.isDirty != null && message.hasOwnProperty("isDirty"))
                if (typeof message.isDirty !== "boolean")
                    return "isDirty: boolean expected";
            return null;
        };

        /**
         * Creates a SinglePriceUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.SinglePriceUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.SinglePriceUpdate} SinglePriceUpdate
         */
        SinglePriceUpdate.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.SinglePriceUpdate)
                return object;
            let message = new $root.stealth.SinglePriceUpdate();
            if (object.timestamp != null)
                if ($util.Long)
                    (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
                else if (typeof object.timestamp === "string")
                    message.timestamp = parseInt(object.timestamp, 10);
                else if (typeof object.timestamp === "number")
                    message.timestamp = object.timestamp;
                else if (typeof object.timestamp === "object")
                    message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
            if (object.value != null)
                if ($util.Long)
                    (message.value = $util.Long.fromValue(object.value)).unsigned = true;
                else if (typeof object.value === "string")
                    message.value = parseInt(object.value, 10);
                else if (typeof object.value === "number")
                    message.value = object.value;
                else if (typeof object.value === "object")
                    message.value = new $util.LongBits(object.value.low >>> 0, object.value.high >>> 0).toNumber(true);
            if (object.isDirty != null)
                message.isDirty = Boolean(object.isDirty);
            return message;
        };

        /**
         * Creates a plain object from a SinglePriceUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.SinglePriceUpdate
         * @static
         * @param {stealth.SinglePriceUpdate} message SinglePriceUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SinglePriceUpdate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.timestamp = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.value = options.longs === String ? "0" : 0;
                object.isDirty = false;
            }
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (typeof message.timestamp === "number")
                    object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                else
                    object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
            if (message.value != null && message.hasOwnProperty("value"))
                if (typeof message.value === "number")
                    object.value = options.longs === String ? String(message.value) : message.value;
                else
                    object.value = options.longs === String ? $util.Long.prototype.toString.call(message.value) : options.longs === Number ? new $util.LongBits(message.value.low >>> 0, message.value.high >>> 0).toNumber(true) : message.value;
            if (message.isDirty != null && message.hasOwnProperty("isDirty"))
                object.isDirty = message.isDirty;
            return object;
        };

        /**
         * Converts this SinglePriceUpdate to JSON.
         * @function toJSON
         * @memberof stealth.SinglePriceUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SinglePriceUpdate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SinglePriceUpdate
         * @function getTypeUrl
         * @memberof stealth.SinglePriceUpdate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SinglePriceUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.SinglePriceUpdate";
        };

        return SinglePriceUpdate;
    })();

    stealth.BuildUpdate = (function() {

        /**
         * Properties of a BuildUpdate.
         * @memberof stealth
         * @interface IBuildUpdate
         * @property {number|null} [current] BuildUpdate current
         * @property {number|null} [mandatory] BuildUpdate mandatory
         * @property {string|null} [path] BuildUpdate path
         * @property {string|null} [product] BuildUpdate product
         */

        /**
         * Constructs a new BuildUpdate.
         * @memberof stealth
         * @classdesc Represents a BuildUpdate.
         * @implements IBuildUpdate
         * @constructor
         * @param {stealth.IBuildUpdate=} [properties] Properties to set
         */
        function BuildUpdate(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BuildUpdate current.
         * @member {number} current
         * @memberof stealth.BuildUpdate
         * @instance
         */
        BuildUpdate.prototype.current = 0;

        /**
         * BuildUpdate mandatory.
         * @member {number} mandatory
         * @memberof stealth.BuildUpdate
         * @instance
         */
        BuildUpdate.prototype.mandatory = 0;

        /**
         * BuildUpdate path.
         * @member {string} path
         * @memberof stealth.BuildUpdate
         * @instance
         */
        BuildUpdate.prototype.path = "";

        /**
         * BuildUpdate product.
         * @member {string} product
         * @memberof stealth.BuildUpdate
         * @instance
         */
        BuildUpdate.prototype.product = "";

        /**
         * Creates a new BuildUpdate instance using the specified properties.
         * @function create
         * @memberof stealth.BuildUpdate
         * @static
         * @param {stealth.IBuildUpdate=} [properties] Properties to set
         * @returns {stealth.BuildUpdate} BuildUpdate instance
         */
        BuildUpdate.create = function create(properties) {
            return new BuildUpdate(properties);
        };

        /**
         * Encodes the specified BuildUpdate message. Does not implicitly {@link stealth.BuildUpdate.verify|verify} messages.
         * @function encode
         * @memberof stealth.BuildUpdate
         * @static
         * @param {stealth.IBuildUpdate} message BuildUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BuildUpdate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.current != null && Object.hasOwnProperty.call(message, "current"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.current);
            if (message.mandatory != null && Object.hasOwnProperty.call(message, "mandatory"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.mandatory);
            if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.path);
            if (message.product != null && Object.hasOwnProperty.call(message, "product"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.product);
            return writer;
        };

        /**
         * Encodes the specified BuildUpdate message, length delimited. Does not implicitly {@link stealth.BuildUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.BuildUpdate
         * @static
         * @param {stealth.IBuildUpdate} message BuildUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BuildUpdate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BuildUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.BuildUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.BuildUpdate} BuildUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BuildUpdate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.BuildUpdate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.current = reader.uint32();
                        break;
                    }
                case 2: {
                        message.mandatory = reader.uint32();
                        break;
                    }
                case 3: {
                        message.path = reader.string();
                        break;
                    }
                case 4: {
                        message.product = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BuildUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.BuildUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.BuildUpdate} BuildUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BuildUpdate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BuildUpdate message.
         * @function verify
         * @memberof stealth.BuildUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BuildUpdate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.current != null && message.hasOwnProperty("current"))
                if (!$util.isInteger(message.current))
                    return "current: integer expected";
            if (message.mandatory != null && message.hasOwnProperty("mandatory"))
                if (!$util.isInteger(message.mandatory))
                    return "mandatory: integer expected";
            if (message.path != null && message.hasOwnProperty("path"))
                if (!$util.isString(message.path))
                    return "path: string expected";
            if (message.product != null && message.hasOwnProperty("product"))
                if (!$util.isString(message.product))
                    return "product: string expected";
            return null;
        };

        /**
         * Creates a BuildUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.BuildUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.BuildUpdate} BuildUpdate
         */
        BuildUpdate.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.BuildUpdate)
                return object;
            let message = new $root.stealth.BuildUpdate();
            if (object.current != null)
                message.current = object.current >>> 0;
            if (object.mandatory != null)
                message.mandatory = object.mandatory >>> 0;
            if (object.path != null)
                message.path = String(object.path);
            if (object.product != null)
                message.product = String(object.product);
            return message;
        };

        /**
         * Creates a plain object from a BuildUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.BuildUpdate
         * @static
         * @param {stealth.BuildUpdate} message BuildUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BuildUpdate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.current = 0;
                object.mandatory = 0;
                object.path = "";
                object.product = "";
            }
            if (message.current != null && message.hasOwnProperty("current"))
                object.current = message.current;
            if (message.mandatory != null && message.hasOwnProperty("mandatory"))
                object.mandatory = message.mandatory;
            if (message.path != null && message.hasOwnProperty("path"))
                object.path = message.path;
            if (message.product != null && message.hasOwnProperty("product"))
                object.product = message.product;
            return object;
        };

        /**
         * Converts this BuildUpdate to JSON.
         * @function toJSON
         * @memberof stealth.BuildUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BuildUpdate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for BuildUpdate
         * @function getTypeUrl
         * @memberof stealth.BuildUpdate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        BuildUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.BuildUpdate";
        };

        return BuildUpdate;
    })();

    stealth.TickValue = (function() {

        /**
         * Properties of a TickValue.
         * @memberof stealth
         * @interface ITickValue
         * @property {number|null} [start] TickValue start
         * @property {number|null} [tick] TickValue tick
         * @property {number|null} [denominator] TickValue denominator
         * @property {number|null} [decimals] TickValue decimals
         * @property {stealth.TickValue.TickFormat|null} [format] TickValue format
         */

        /**
         * Constructs a new TickValue.
         * @memberof stealth
         * @classdesc Represents a TickValue.
         * @implements ITickValue
         * @constructor
         * @param {stealth.ITickValue=} [properties] Properties to set
         */
        function TickValue(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TickValue start.
         * @member {number} start
         * @memberof stealth.TickValue
         * @instance
         */
        TickValue.prototype.start = 0;

        /**
         * TickValue tick.
         * @member {number} tick
         * @memberof stealth.TickValue
         * @instance
         */
        TickValue.prototype.tick = 0;

        /**
         * TickValue denominator.
         * @member {number} denominator
         * @memberof stealth.TickValue
         * @instance
         */
        TickValue.prototype.denominator = 0;

        /**
         * TickValue decimals.
         * @member {number} decimals
         * @memberof stealth.TickValue
         * @instance
         */
        TickValue.prototype.decimals = 0;

        /**
         * TickValue format.
         * @member {stealth.TickValue.TickFormat} format
         * @memberof stealth.TickValue
         * @instance
         */
        TickValue.prototype.format = 0;

        /**
         * Creates a new TickValue instance using the specified properties.
         * @function create
         * @memberof stealth.TickValue
         * @static
         * @param {stealth.ITickValue=} [properties] Properties to set
         * @returns {stealth.TickValue} TickValue instance
         */
        TickValue.create = function create(properties) {
            return new TickValue(properties);
        };

        /**
         * Encodes the specified TickValue message. Does not implicitly {@link stealth.TickValue.verify|verify} messages.
         * @function encode
         * @memberof stealth.TickValue
         * @static
         * @param {stealth.ITickValue} message TickValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TickValue.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.start != null && Object.hasOwnProperty.call(message, "start"))
                writer.uint32(/* id 1, wireType 1 =*/9).double(message.start);
            if (message.tick != null && Object.hasOwnProperty.call(message, "tick"))
                writer.uint32(/* id 2, wireType 1 =*/17).double(message.tick);
            if (message.denominator != null && Object.hasOwnProperty.call(message, "denominator"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.denominator);
            if (message.decimals != null && Object.hasOwnProperty.call(message, "decimals"))
                writer.uint32(/* id 4, wireType 0 =*/32).sint32(message.decimals);
            if (message.format != null && Object.hasOwnProperty.call(message, "format"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.format);
            return writer;
        };

        /**
         * Encodes the specified TickValue message, length delimited. Does not implicitly {@link stealth.TickValue.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.TickValue
         * @static
         * @param {stealth.ITickValue} message TickValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TickValue.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TickValue message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.TickValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.TickValue} TickValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TickValue.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.TickValue();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.start = reader.double();
                        break;
                    }
                case 2: {
                        message.tick = reader.double();
                        break;
                    }
                case 3: {
                        message.denominator = reader.uint32();
                        break;
                    }
                case 4: {
                        message.decimals = reader.sint32();
                        break;
                    }
                case 5: {
                        message.format = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TickValue message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.TickValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.TickValue} TickValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TickValue.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TickValue message.
         * @function verify
         * @memberof stealth.TickValue
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TickValue.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.start != null && message.hasOwnProperty("start"))
                if (typeof message.start !== "number")
                    return "start: number expected";
            if (message.tick != null && message.hasOwnProperty("tick"))
                if (typeof message.tick !== "number")
                    return "tick: number expected";
            if (message.denominator != null && message.hasOwnProperty("denominator"))
                if (!$util.isInteger(message.denominator))
                    return "denominator: integer expected";
            if (message.decimals != null && message.hasOwnProperty("decimals"))
                if (!$util.isInteger(message.decimals))
                    return "decimals: integer expected";
            if (message.format != null && message.hasOwnProperty("format"))
                switch (message.format) {
                default:
                    return "format: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            return null;
        };

        /**
         * Creates a TickValue message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.TickValue
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.TickValue} TickValue
         */
        TickValue.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.TickValue)
                return object;
            let message = new $root.stealth.TickValue();
            if (object.start != null)
                message.start = Number(object.start);
            if (object.tick != null)
                message.tick = Number(object.tick);
            if (object.denominator != null)
                message.denominator = object.denominator >>> 0;
            if (object.decimals != null)
                message.decimals = object.decimals | 0;
            switch (object.format) {
            default:
                if (typeof object.format === "number") {
                    message.format = object.format;
                    break;
                }
                break;
            case "Decimal":
            case 0:
                message.format = 0;
                break;
            case "Fraction":
            case 1:
                message.format = 1;
                break;
            case "Tick":
            case 2:
                message.format = 2;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a TickValue message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.TickValue
         * @static
         * @param {stealth.TickValue} message TickValue
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TickValue.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.start = 0;
                object.tick = 0;
                object.denominator = 0;
                object.decimals = 0;
                object.format = options.enums === String ? "Decimal" : 0;
            }
            if (message.start != null && message.hasOwnProperty("start"))
                object.start = options.json && !isFinite(message.start) ? String(message.start) : message.start;
            if (message.tick != null && message.hasOwnProperty("tick"))
                object.tick = options.json && !isFinite(message.tick) ? String(message.tick) : message.tick;
            if (message.denominator != null && message.hasOwnProperty("denominator"))
                object.denominator = message.denominator;
            if (message.decimals != null && message.hasOwnProperty("decimals"))
                object.decimals = message.decimals;
            if (message.format != null && message.hasOwnProperty("format"))
                object.format = options.enums === String ? $root.stealth.TickValue.TickFormat[message.format] === undefined ? message.format : $root.stealth.TickValue.TickFormat[message.format] : message.format;
            return object;
        };

        /**
         * Converts this TickValue to JSON.
         * @function toJSON
         * @memberof stealth.TickValue
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TickValue.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for TickValue
         * @function getTypeUrl
         * @memberof stealth.TickValue
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        TickValue.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.TickValue";
        };

        /**
         * TickFormat enum.
         * @name stealth.TickValue.TickFormat
         * @enum {number}
         * @property {number} Decimal=0 Decimal value
         * @property {number} Fraction=1 Fraction value
         * @property {number} Tick=2 Tick value
         */
        TickValue.TickFormat = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Decimal"] = 0;
            values[valuesById[1] = "Fraction"] = 1;
            values[valuesById[2] = "Tick"] = 2;
            return values;
        })();

        return TickValue;
    })();

    stealth.TradingSession = (function() {

        /**
         * Properties of a TradingSession.
         * @memberof stealth
         * @interface ITradingSession
         * @property {number|null} [close] TradingSession close
         * @property {number|null} [length] TradingSession length
         */

        /**
         * Constructs a new TradingSession.
         * @memberof stealth
         * @classdesc Represents a TradingSession.
         * @implements ITradingSession
         * @constructor
         * @param {stealth.ITradingSession=} [properties] Properties to set
         */
        function TradingSession(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TradingSession close.
         * @member {number} close
         * @memberof stealth.TradingSession
         * @instance
         */
        TradingSession.prototype.close = 0;

        /**
         * TradingSession length.
         * @member {number} length
         * @memberof stealth.TradingSession
         * @instance
         */
        TradingSession.prototype.length = 0;

        /**
         * Creates a new TradingSession instance using the specified properties.
         * @function create
         * @memberof stealth.TradingSession
         * @static
         * @param {stealth.ITradingSession=} [properties] Properties to set
         * @returns {stealth.TradingSession} TradingSession instance
         */
        TradingSession.create = function create(properties) {
            return new TradingSession(properties);
        };

        /**
         * Encodes the specified TradingSession message. Does not implicitly {@link stealth.TradingSession.verify|verify} messages.
         * @function encode
         * @memberof stealth.TradingSession
         * @static
         * @param {stealth.ITradingSession} message TradingSession message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TradingSession.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.close != null && Object.hasOwnProperty.call(message, "close"))
                writer.uint32(/* id 1, wireType 0 =*/8).sint32(message.close);
            if (message.length != null && Object.hasOwnProperty.call(message, "length"))
                writer.uint32(/* id 2, wireType 0 =*/16).sint32(message.length);
            return writer;
        };

        /**
         * Encodes the specified TradingSession message, length delimited. Does not implicitly {@link stealth.TradingSession.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.TradingSession
         * @static
         * @param {stealth.ITradingSession} message TradingSession message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TradingSession.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TradingSession message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.TradingSession
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.TradingSession} TradingSession
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TradingSession.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.TradingSession();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.close = reader.sint32();
                        break;
                    }
                case 2: {
                        message.length = reader.sint32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TradingSession message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.TradingSession
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.TradingSession} TradingSession
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TradingSession.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TradingSession message.
         * @function verify
         * @memberof stealth.TradingSession
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TradingSession.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.close != null && message.hasOwnProperty("close"))
                if (!$util.isInteger(message.close))
                    return "close: integer expected";
            if (message.length != null && message.hasOwnProperty("length"))
                if (!$util.isInteger(message.length))
                    return "length: integer expected";
            return null;
        };

        /**
         * Creates a TradingSession message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.TradingSession
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.TradingSession} TradingSession
         */
        TradingSession.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.TradingSession)
                return object;
            let message = new $root.stealth.TradingSession();
            if (object.close != null)
                message.close = object.close | 0;
            if (object.length != null)
                message.length = object.length | 0;
            return message;
        };

        /**
         * Creates a plain object from a TradingSession message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.TradingSession
         * @static
         * @param {stealth.TradingSession} message TradingSession
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TradingSession.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.close = 0;
                object.length = 0;
            }
            if (message.close != null && message.hasOwnProperty("close"))
                object.close = message.close;
            if (message.length != null && message.hasOwnProperty("length"))
                object.length = message.length;
            return object;
        };

        /**
         * Converts this TradingSession to JSON.
         * @function toJSON
         * @memberof stealth.TradingSession
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TradingSession.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for TradingSession
         * @function getTypeUrl
         * @memberof stealth.TradingSession
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        TradingSession.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.TradingSession";
        };

        return TradingSession;
    })();

    stealth.InstrumentUpdate = (function() {

        /**
         * Properties of an InstrumentUpdate.
         * @memberof stealth
         * @interface IInstrumentUpdate
         * @property {string|null} [symbol] InstrumentUpdate symbol
         * @property {string|null} [underlying] InstrumentUpdate underlying
         * @property {string|null} [currency] InstrumentUpdate currency
         * @property {string|null} [exchange] InstrumentUpdate exchange
         * @property {stealth.InstrumentType|null} [instrumentType] InstrumentUpdate instrumentType
         * @property {stealth.PutOrCall|null} [putOrCall] InstrumentUpdate putOrCall
         * @property {number|null} [strike] InstrumentUpdate strike
         * @property {number|Long|null} [expiryDate] InstrumentUpdate expiryDate
         * @property {number|null} [multiplier] InstrumentUpdate multiplier
         * @property {string|null} [displayName] InstrumentUpdate displayName
         * @property {string|null} [timeZone] InstrumentUpdate timeZone
         * @property {Array.<stealth.ITickValue>|null} [tickValues] InstrumentUpdate tickValues
         * @property {Array.<stealth.ITradingSession>|null} [tradingSessions] InstrumentUpdate tradingSessions
         * @property {Object.<string,string>|null} [brokerSymbols] InstrumentUpdate brokerSymbols
         */

        /**
         * Constructs a new InstrumentUpdate.
         * @memberof stealth
         * @classdesc Represents an InstrumentUpdate.
         * @implements IInstrumentUpdate
         * @constructor
         * @param {stealth.IInstrumentUpdate=} [properties] Properties to set
         */
        function InstrumentUpdate(properties) {
            this.tickValues = [];
            this.tradingSessions = [];
            this.brokerSymbols = {};
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InstrumentUpdate symbol.
         * @member {string} symbol
         * @memberof stealth.InstrumentUpdate
         * @instance
         */
        InstrumentUpdate.prototype.symbol = "";

        /**
         * InstrumentUpdate underlying.
         * @member {string} underlying
         * @memberof stealth.InstrumentUpdate
         * @instance
         */
        InstrumentUpdate.prototype.underlying = "";

        /**
         * InstrumentUpdate currency.
         * @member {string} currency
         * @memberof stealth.InstrumentUpdate
         * @instance
         */
        InstrumentUpdate.prototype.currency = "";

        /**
         * InstrumentUpdate exchange.
         * @member {string} exchange
         * @memberof stealth.InstrumentUpdate
         * @instance
         */
        InstrumentUpdate.prototype.exchange = "";

        /**
         * InstrumentUpdate instrumentType.
         * @member {stealth.InstrumentType} instrumentType
         * @memberof stealth.InstrumentUpdate
         * @instance
         */
        InstrumentUpdate.prototype.instrumentType = 0;

        /**
         * InstrumentUpdate putOrCall.
         * @member {stealth.PutOrCall} putOrCall
         * @memberof stealth.InstrumentUpdate
         * @instance
         */
        InstrumentUpdate.prototype.putOrCall = 0;

        /**
         * InstrumentUpdate strike.
         * @member {number} strike
         * @memberof stealth.InstrumentUpdate
         * @instance
         */
        InstrumentUpdate.prototype.strike = 0;

        /**
         * InstrumentUpdate expiryDate.
         * @member {number|Long} expiryDate
         * @memberof stealth.InstrumentUpdate
         * @instance
         */
        InstrumentUpdate.prototype.expiryDate = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * InstrumentUpdate multiplier.
         * @member {number} multiplier
         * @memberof stealth.InstrumentUpdate
         * @instance
         */
        InstrumentUpdate.prototype.multiplier = 0;

        /**
         * InstrumentUpdate displayName.
         * @member {string} displayName
         * @memberof stealth.InstrumentUpdate
         * @instance
         */
        InstrumentUpdate.prototype.displayName = "";

        /**
         * InstrumentUpdate timeZone.
         * @member {string} timeZone
         * @memberof stealth.InstrumentUpdate
         * @instance
         */
        InstrumentUpdate.prototype.timeZone = "";

        /**
         * InstrumentUpdate tickValues.
         * @member {Array.<stealth.ITickValue>} tickValues
         * @memberof stealth.InstrumentUpdate
         * @instance
         */
        InstrumentUpdate.prototype.tickValues = $util.emptyArray;

        /**
         * InstrumentUpdate tradingSessions.
         * @member {Array.<stealth.ITradingSession>} tradingSessions
         * @memberof stealth.InstrumentUpdate
         * @instance
         */
        InstrumentUpdate.prototype.tradingSessions = $util.emptyArray;

        /**
         * InstrumentUpdate brokerSymbols.
         * @member {Object.<string,string>} brokerSymbols
         * @memberof stealth.InstrumentUpdate
         * @instance
         */
        InstrumentUpdate.prototype.brokerSymbols = $util.emptyObject;

        /**
         * Creates a new InstrumentUpdate instance using the specified properties.
         * @function create
         * @memberof stealth.InstrumentUpdate
         * @static
         * @param {stealth.IInstrumentUpdate=} [properties] Properties to set
         * @returns {stealth.InstrumentUpdate} InstrumentUpdate instance
         */
        InstrumentUpdate.create = function create(properties) {
            return new InstrumentUpdate(properties);
        };

        /**
         * Encodes the specified InstrumentUpdate message. Does not implicitly {@link stealth.InstrumentUpdate.verify|verify} messages.
         * @function encode
         * @memberof stealth.InstrumentUpdate
         * @static
         * @param {stealth.IInstrumentUpdate} message InstrumentUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InstrumentUpdate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.symbol);
            if (message.underlying != null && Object.hasOwnProperty.call(message, "underlying"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.underlying);
            if (message.currency != null && Object.hasOwnProperty.call(message, "currency"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.currency);
            if (message.exchange != null && Object.hasOwnProperty.call(message, "exchange"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.exchange);
            if (message.instrumentType != null && Object.hasOwnProperty.call(message, "instrumentType"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.instrumentType);
            if (message.putOrCall != null && Object.hasOwnProperty.call(message, "putOrCall"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.putOrCall);
            if (message.strike != null && Object.hasOwnProperty.call(message, "strike"))
                writer.uint32(/* id 7, wireType 1 =*/57).double(message.strike);
            if (message.expiryDate != null && Object.hasOwnProperty.call(message, "expiryDate"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint64(message.expiryDate);
            if (message.multiplier != null && Object.hasOwnProperty.call(message, "multiplier"))
                writer.uint32(/* id 9, wireType 1 =*/73).double(message.multiplier);
            if (message.displayName != null && Object.hasOwnProperty.call(message, "displayName"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.displayName);
            if (message.timeZone != null && Object.hasOwnProperty.call(message, "timeZone"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.timeZone);
            if (message.tickValues != null && message.tickValues.length)
                for (let i = 0; i < message.tickValues.length; ++i)
                    $root.stealth.TickValue.encode(message.tickValues[i], writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
            if (message.tradingSessions != null && message.tradingSessions.length)
                for (let i = 0; i < message.tradingSessions.length; ++i)
                    $root.stealth.TradingSession.encode(message.tradingSessions[i], writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
            if (message.brokerSymbols != null && Object.hasOwnProperty.call(message, "brokerSymbols"))
                for (let keys = Object.keys(message.brokerSymbols), i = 0; i < keys.length; ++i)
                    writer.uint32(/* id 14, wireType 2 =*/114).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.brokerSymbols[keys[i]]).ldelim();
            return writer;
        };

        /**
         * Encodes the specified InstrumentUpdate message, length delimited. Does not implicitly {@link stealth.InstrumentUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.InstrumentUpdate
         * @static
         * @param {stealth.IInstrumentUpdate} message InstrumentUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InstrumentUpdate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an InstrumentUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.InstrumentUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.InstrumentUpdate} InstrumentUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InstrumentUpdate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.InstrumentUpdate(), key, value;
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.symbol = reader.string();
                        break;
                    }
                case 2: {
                        message.underlying = reader.string();
                        break;
                    }
                case 3: {
                        message.currency = reader.string();
                        break;
                    }
                case 4: {
                        message.exchange = reader.string();
                        break;
                    }
                case 5: {
                        message.instrumentType = reader.int32();
                        break;
                    }
                case 6: {
                        message.putOrCall = reader.int32();
                        break;
                    }
                case 7: {
                        message.strike = reader.double();
                        break;
                    }
                case 8: {
                        message.expiryDate = reader.uint64();
                        break;
                    }
                case 9: {
                        message.multiplier = reader.double();
                        break;
                    }
                case 10: {
                        message.displayName = reader.string();
                        break;
                    }
                case 11: {
                        message.timeZone = reader.string();
                        break;
                    }
                case 12: {
                        if (!(message.tickValues && message.tickValues.length))
                            message.tickValues = [];
                        message.tickValues.push($root.stealth.TickValue.decode(reader, reader.uint32()));
                        break;
                    }
                case 13: {
                        if (!(message.tradingSessions && message.tradingSessions.length))
                            message.tradingSessions = [];
                        message.tradingSessions.push($root.stealth.TradingSession.decode(reader, reader.uint32()));
                        break;
                    }
                case 14: {
                        if (message.brokerSymbols === $util.emptyObject)
                            message.brokerSymbols = {};
                        let end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = "";
                        while (reader.pos < end2) {
                            let tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = reader.string();
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.brokerSymbols[key] = value;
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an InstrumentUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.InstrumentUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.InstrumentUpdate} InstrumentUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InstrumentUpdate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an InstrumentUpdate message.
         * @function verify
         * @memberof stealth.InstrumentUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        InstrumentUpdate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                if (!$util.isString(message.symbol))
                    return "symbol: string expected";
            if (message.underlying != null && message.hasOwnProperty("underlying"))
                if (!$util.isString(message.underlying))
                    return "underlying: string expected";
            if (message.currency != null && message.hasOwnProperty("currency"))
                if (!$util.isString(message.currency))
                    return "currency: string expected";
            if (message.exchange != null && message.hasOwnProperty("exchange"))
                if (!$util.isString(message.exchange))
                    return "exchange: string expected";
            if (message.instrumentType != null && message.hasOwnProperty("instrumentType"))
                switch (message.instrumentType) {
                default:
                    return "instrumentType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                    break;
                }
            if (message.putOrCall != null && message.hasOwnProperty("putOrCall"))
                switch (message.putOrCall) {
                default:
                    return "putOrCall: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.strike != null && message.hasOwnProperty("strike"))
                if (typeof message.strike !== "number")
                    return "strike: number expected";
            if (message.expiryDate != null && message.hasOwnProperty("expiryDate"))
                if (!$util.isInteger(message.expiryDate) && !(message.expiryDate && $util.isInteger(message.expiryDate.low) && $util.isInteger(message.expiryDate.high)))
                    return "expiryDate: integer|Long expected";
            if (message.multiplier != null && message.hasOwnProperty("multiplier"))
                if (typeof message.multiplier !== "number")
                    return "multiplier: number expected";
            if (message.displayName != null && message.hasOwnProperty("displayName"))
                if (!$util.isString(message.displayName))
                    return "displayName: string expected";
            if (message.timeZone != null && message.hasOwnProperty("timeZone"))
                if (!$util.isString(message.timeZone))
                    return "timeZone: string expected";
            if (message.tickValues != null && message.hasOwnProperty("tickValues")) {
                if (!Array.isArray(message.tickValues))
                    return "tickValues: array expected";
                for (let i = 0; i < message.tickValues.length; ++i) {
                    let error = $root.stealth.TickValue.verify(message.tickValues[i]);
                    if (error)
                        return "tickValues." + error;
                }
            }
            if (message.tradingSessions != null && message.hasOwnProperty("tradingSessions")) {
                if (!Array.isArray(message.tradingSessions))
                    return "tradingSessions: array expected";
                for (let i = 0; i < message.tradingSessions.length; ++i) {
                    let error = $root.stealth.TradingSession.verify(message.tradingSessions[i]);
                    if (error)
                        return "tradingSessions." + error;
                }
            }
            if (message.brokerSymbols != null && message.hasOwnProperty("brokerSymbols")) {
                if (!$util.isObject(message.brokerSymbols))
                    return "brokerSymbols: object expected";
                let key = Object.keys(message.brokerSymbols);
                for (let i = 0; i < key.length; ++i)
                    if (!$util.isString(message.brokerSymbols[key[i]]))
                        return "brokerSymbols: string{k:string} expected";
            }
            return null;
        };

        /**
         * Creates an InstrumentUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.InstrumentUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.InstrumentUpdate} InstrumentUpdate
         */
        InstrumentUpdate.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.InstrumentUpdate)
                return object;
            let message = new $root.stealth.InstrumentUpdate();
            if (object.symbol != null)
                message.symbol = String(object.symbol);
            if (object.underlying != null)
                message.underlying = String(object.underlying);
            if (object.currency != null)
                message.currency = String(object.currency);
            if (object.exchange != null)
                message.exchange = String(object.exchange);
            switch (object.instrumentType) {
            default:
                if (typeof object.instrumentType === "number") {
                    message.instrumentType = object.instrumentType;
                    break;
                }
                break;
            case "NoInstrument":
            case 0:
                message.instrumentType = 0;
                break;
            case "CommonStock":
            case 1:
                message.instrumentType = 1;
                break;
            case "StockOption":
            case 2:
                message.instrumentType = 2;
                break;
            case "Future":
            case 3:
                message.instrumentType = 3;
                break;
            case "Index":
            case 4:
                message.instrumentType = 4;
                break;
            case "ForexContract":
            case 5:
                message.instrumentType = 5;
                break;
            case "FutureOption":
            case 6:
                message.instrumentType = 6;
                break;
            case "FutureInstrument":
            case 7:
                message.instrumentType = 7;
                break;
            case "Combo":
            case 8:
                message.instrumentType = 8;
                break;
            case "ComboInstrument":
            case 9:
                message.instrumentType = 9;
                break;
            case "CryptoCurrency":
            case 10:
                message.instrumentType = 10;
                break;
            case "PerpetualCrypto":
            case 11:
                message.instrumentType = 11;
                break;
            }
            switch (object.putOrCall) {
            default:
                if (typeof object.putOrCall === "number") {
                    message.putOrCall = object.putOrCall;
                    break;
                }
                break;
            case "NoPutCall":
            case 0:
                message.putOrCall = 0;
                break;
            case "Put":
            case 1:
                message.putOrCall = 1;
                break;
            case "Call":
            case 2:
                message.putOrCall = 2;
                break;
            }
            if (object.strike != null)
                message.strike = Number(object.strike);
            if (object.expiryDate != null)
                if ($util.Long)
                    (message.expiryDate = $util.Long.fromValue(object.expiryDate)).unsigned = true;
                else if (typeof object.expiryDate === "string")
                    message.expiryDate = parseInt(object.expiryDate, 10);
                else if (typeof object.expiryDate === "number")
                    message.expiryDate = object.expiryDate;
                else if (typeof object.expiryDate === "object")
                    message.expiryDate = new $util.LongBits(object.expiryDate.low >>> 0, object.expiryDate.high >>> 0).toNumber(true);
            if (object.multiplier != null)
                message.multiplier = Number(object.multiplier);
            if (object.displayName != null)
                message.displayName = String(object.displayName);
            if (object.timeZone != null)
                message.timeZone = String(object.timeZone);
            if (object.tickValues) {
                if (!Array.isArray(object.tickValues))
                    throw TypeError(".stealth.InstrumentUpdate.tickValues: array expected");
                message.tickValues = [];
                for (let i = 0; i < object.tickValues.length; ++i) {
                    if (typeof object.tickValues[i] !== "object")
                        throw TypeError(".stealth.InstrumentUpdate.tickValues: object expected");
                    message.tickValues[i] = $root.stealth.TickValue.fromObject(object.tickValues[i]);
                }
            }
            if (object.tradingSessions) {
                if (!Array.isArray(object.tradingSessions))
                    throw TypeError(".stealth.InstrumentUpdate.tradingSessions: array expected");
                message.tradingSessions = [];
                for (let i = 0; i < object.tradingSessions.length; ++i) {
                    if (typeof object.tradingSessions[i] !== "object")
                        throw TypeError(".stealth.InstrumentUpdate.tradingSessions: object expected");
                    message.tradingSessions[i] = $root.stealth.TradingSession.fromObject(object.tradingSessions[i]);
                }
            }
            if (object.brokerSymbols) {
                if (typeof object.brokerSymbols !== "object")
                    throw TypeError(".stealth.InstrumentUpdate.brokerSymbols: object expected");
                message.brokerSymbols = {};
                for (let keys = Object.keys(object.brokerSymbols), i = 0; i < keys.length; ++i)
                    message.brokerSymbols[keys[i]] = String(object.brokerSymbols[keys[i]]);
            }
            return message;
        };

        /**
         * Creates a plain object from an InstrumentUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.InstrumentUpdate
         * @static
         * @param {stealth.InstrumentUpdate} message InstrumentUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InstrumentUpdate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.tickValues = [];
                object.tradingSessions = [];
            }
            if (options.objects || options.defaults)
                object.brokerSymbols = {};
            if (options.defaults) {
                object.symbol = "";
                object.underlying = "";
                object.currency = "";
                object.exchange = "";
                object.instrumentType = options.enums === String ? "NoInstrument" : 0;
                object.putOrCall = options.enums === String ? "NoPutCall" : 0;
                object.strike = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.expiryDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.expiryDate = options.longs === String ? "0" : 0;
                object.multiplier = 0;
                object.displayName = "";
                object.timeZone = "";
            }
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                object.symbol = message.symbol;
            if (message.underlying != null && message.hasOwnProperty("underlying"))
                object.underlying = message.underlying;
            if (message.currency != null && message.hasOwnProperty("currency"))
                object.currency = message.currency;
            if (message.exchange != null && message.hasOwnProperty("exchange"))
                object.exchange = message.exchange;
            if (message.instrumentType != null && message.hasOwnProperty("instrumentType"))
                object.instrumentType = options.enums === String ? $root.stealth.InstrumentType[message.instrumentType] === undefined ? message.instrumentType : $root.stealth.InstrumentType[message.instrumentType] : message.instrumentType;
            if (message.putOrCall != null && message.hasOwnProperty("putOrCall"))
                object.putOrCall = options.enums === String ? $root.stealth.PutOrCall[message.putOrCall] === undefined ? message.putOrCall : $root.stealth.PutOrCall[message.putOrCall] : message.putOrCall;
            if (message.strike != null && message.hasOwnProperty("strike"))
                object.strike = options.json && !isFinite(message.strike) ? String(message.strike) : message.strike;
            if (message.expiryDate != null && message.hasOwnProperty("expiryDate"))
                if (typeof message.expiryDate === "number")
                    object.expiryDate = options.longs === String ? String(message.expiryDate) : message.expiryDate;
                else
                    object.expiryDate = options.longs === String ? $util.Long.prototype.toString.call(message.expiryDate) : options.longs === Number ? new $util.LongBits(message.expiryDate.low >>> 0, message.expiryDate.high >>> 0).toNumber(true) : message.expiryDate;
            if (message.multiplier != null && message.hasOwnProperty("multiplier"))
                object.multiplier = options.json && !isFinite(message.multiplier) ? String(message.multiplier) : message.multiplier;
            if (message.displayName != null && message.hasOwnProperty("displayName"))
                object.displayName = message.displayName;
            if (message.timeZone != null && message.hasOwnProperty("timeZone"))
                object.timeZone = message.timeZone;
            if (message.tickValues && message.tickValues.length) {
                object.tickValues = [];
                for (let j = 0; j < message.tickValues.length; ++j)
                    object.tickValues[j] = $root.stealth.TickValue.toObject(message.tickValues[j], options);
            }
            if (message.tradingSessions && message.tradingSessions.length) {
                object.tradingSessions = [];
                for (let j = 0; j < message.tradingSessions.length; ++j)
                    object.tradingSessions[j] = $root.stealth.TradingSession.toObject(message.tradingSessions[j], options);
            }
            let keys2;
            if (message.brokerSymbols && (keys2 = Object.keys(message.brokerSymbols)).length) {
                object.brokerSymbols = {};
                for (let j = 0; j < keys2.length; ++j)
                    object.brokerSymbols[keys2[j]] = message.brokerSymbols[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this InstrumentUpdate to JSON.
         * @function toJSON
         * @memberof stealth.InstrumentUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InstrumentUpdate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for InstrumentUpdate
         * @function getTypeUrl
         * @memberof stealth.InstrumentUpdate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        InstrumentUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.InstrumentUpdate";
        };

        return InstrumentUpdate;
    })();

    stealth.SymbolSearchResult = (function() {

        /**
         * Properties of a SymbolSearchResult.
         * @memberof stealth
         * @interface ISymbolSearchResult
         * @property {string|null} [symbol] SymbolSearchResult symbol
         * @property {string|null} [underlying] SymbolSearchResult underlying
         * @property {string|null} [currency] SymbolSearchResult currency
         * @property {stealth.InstrumentType|null} [instrumentType] SymbolSearchResult instrumentType
         * @property {string|null} [exchange] SymbolSearchResult exchange
         * @property {string|null} [displayName] SymbolSearchResult displayName
         */

        /**
         * Constructs a new SymbolSearchResult.
         * @memberof stealth
         * @classdesc Represents a SymbolSearchResult.
         * @implements ISymbolSearchResult
         * @constructor
         * @param {stealth.ISymbolSearchResult=} [properties] Properties to set
         */
        function SymbolSearchResult(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SymbolSearchResult symbol.
         * @member {string} symbol
         * @memberof stealth.SymbolSearchResult
         * @instance
         */
        SymbolSearchResult.prototype.symbol = "";

        /**
         * SymbolSearchResult underlying.
         * @member {string} underlying
         * @memberof stealth.SymbolSearchResult
         * @instance
         */
        SymbolSearchResult.prototype.underlying = "";

        /**
         * SymbolSearchResult currency.
         * @member {string} currency
         * @memberof stealth.SymbolSearchResult
         * @instance
         */
        SymbolSearchResult.prototype.currency = "";

        /**
         * SymbolSearchResult instrumentType.
         * @member {stealth.InstrumentType} instrumentType
         * @memberof stealth.SymbolSearchResult
         * @instance
         */
        SymbolSearchResult.prototype.instrumentType = 0;

        /**
         * SymbolSearchResult exchange.
         * @member {string} exchange
         * @memberof stealth.SymbolSearchResult
         * @instance
         */
        SymbolSearchResult.prototype.exchange = "";

        /**
         * SymbolSearchResult displayName.
         * @member {string} displayName
         * @memberof stealth.SymbolSearchResult
         * @instance
         */
        SymbolSearchResult.prototype.displayName = "";

        /**
         * Creates a new SymbolSearchResult instance using the specified properties.
         * @function create
         * @memberof stealth.SymbolSearchResult
         * @static
         * @param {stealth.ISymbolSearchResult=} [properties] Properties to set
         * @returns {stealth.SymbolSearchResult} SymbolSearchResult instance
         */
        SymbolSearchResult.create = function create(properties) {
            return new SymbolSearchResult(properties);
        };

        /**
         * Encodes the specified SymbolSearchResult message. Does not implicitly {@link stealth.SymbolSearchResult.verify|verify} messages.
         * @function encode
         * @memberof stealth.SymbolSearchResult
         * @static
         * @param {stealth.ISymbolSearchResult} message SymbolSearchResult message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SymbolSearchResult.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.symbol);
            if (message.underlying != null && Object.hasOwnProperty.call(message, "underlying"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.underlying);
            if (message.currency != null && Object.hasOwnProperty.call(message, "currency"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.currency);
            if (message.instrumentType != null && Object.hasOwnProperty.call(message, "instrumentType"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.instrumentType);
            if (message.exchange != null && Object.hasOwnProperty.call(message, "exchange"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.exchange);
            if (message.displayName != null && Object.hasOwnProperty.call(message, "displayName"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.displayName);
            return writer;
        };

        /**
         * Encodes the specified SymbolSearchResult message, length delimited. Does not implicitly {@link stealth.SymbolSearchResult.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.SymbolSearchResult
         * @static
         * @param {stealth.ISymbolSearchResult} message SymbolSearchResult message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SymbolSearchResult.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SymbolSearchResult message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.SymbolSearchResult
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.SymbolSearchResult} SymbolSearchResult
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SymbolSearchResult.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.SymbolSearchResult();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.symbol = reader.string();
                        break;
                    }
                case 2: {
                        message.underlying = reader.string();
                        break;
                    }
                case 3: {
                        message.currency = reader.string();
                        break;
                    }
                case 4: {
                        message.instrumentType = reader.int32();
                        break;
                    }
                case 5: {
                        message.exchange = reader.string();
                        break;
                    }
                case 6: {
                        message.displayName = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SymbolSearchResult message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.SymbolSearchResult
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.SymbolSearchResult} SymbolSearchResult
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SymbolSearchResult.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SymbolSearchResult message.
         * @function verify
         * @memberof stealth.SymbolSearchResult
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SymbolSearchResult.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                if (!$util.isString(message.symbol))
                    return "symbol: string expected";
            if (message.underlying != null && message.hasOwnProperty("underlying"))
                if (!$util.isString(message.underlying))
                    return "underlying: string expected";
            if (message.currency != null && message.hasOwnProperty("currency"))
                if (!$util.isString(message.currency))
                    return "currency: string expected";
            if (message.instrumentType != null && message.hasOwnProperty("instrumentType"))
                switch (message.instrumentType) {
                default:
                    return "instrumentType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                    break;
                }
            if (message.exchange != null && message.hasOwnProperty("exchange"))
                if (!$util.isString(message.exchange))
                    return "exchange: string expected";
            if (message.displayName != null && message.hasOwnProperty("displayName"))
                if (!$util.isString(message.displayName))
                    return "displayName: string expected";
            return null;
        };

        /**
         * Creates a SymbolSearchResult message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.SymbolSearchResult
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.SymbolSearchResult} SymbolSearchResult
         */
        SymbolSearchResult.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.SymbolSearchResult)
                return object;
            let message = new $root.stealth.SymbolSearchResult();
            if (object.symbol != null)
                message.symbol = String(object.symbol);
            if (object.underlying != null)
                message.underlying = String(object.underlying);
            if (object.currency != null)
                message.currency = String(object.currency);
            switch (object.instrumentType) {
            default:
                if (typeof object.instrumentType === "number") {
                    message.instrumentType = object.instrumentType;
                    break;
                }
                break;
            case "NoInstrument":
            case 0:
                message.instrumentType = 0;
                break;
            case "CommonStock":
            case 1:
                message.instrumentType = 1;
                break;
            case "StockOption":
            case 2:
                message.instrumentType = 2;
                break;
            case "Future":
            case 3:
                message.instrumentType = 3;
                break;
            case "Index":
            case 4:
                message.instrumentType = 4;
                break;
            case "ForexContract":
            case 5:
                message.instrumentType = 5;
                break;
            case "FutureOption":
            case 6:
                message.instrumentType = 6;
                break;
            case "FutureInstrument":
            case 7:
                message.instrumentType = 7;
                break;
            case "Combo":
            case 8:
                message.instrumentType = 8;
                break;
            case "ComboInstrument":
            case 9:
                message.instrumentType = 9;
                break;
            case "CryptoCurrency":
            case 10:
                message.instrumentType = 10;
                break;
            case "PerpetualCrypto":
            case 11:
                message.instrumentType = 11;
                break;
            }
            if (object.exchange != null)
                message.exchange = String(object.exchange);
            if (object.displayName != null)
                message.displayName = String(object.displayName);
            return message;
        };

        /**
         * Creates a plain object from a SymbolSearchResult message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.SymbolSearchResult
         * @static
         * @param {stealth.SymbolSearchResult} message SymbolSearchResult
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SymbolSearchResult.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.symbol = "";
                object.underlying = "";
                object.currency = "";
                object.instrumentType = options.enums === String ? "NoInstrument" : 0;
                object.exchange = "";
                object.displayName = "";
            }
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                object.symbol = message.symbol;
            if (message.underlying != null && message.hasOwnProperty("underlying"))
                object.underlying = message.underlying;
            if (message.currency != null && message.hasOwnProperty("currency"))
                object.currency = message.currency;
            if (message.instrumentType != null && message.hasOwnProperty("instrumentType"))
                object.instrumentType = options.enums === String ? $root.stealth.InstrumentType[message.instrumentType] === undefined ? message.instrumentType : $root.stealth.InstrumentType[message.instrumentType] : message.instrumentType;
            if (message.exchange != null && message.hasOwnProperty("exchange"))
                object.exchange = message.exchange;
            if (message.displayName != null && message.hasOwnProperty("displayName"))
                object.displayName = message.displayName;
            return object;
        };

        /**
         * Converts this SymbolSearchResult to JSON.
         * @function toJSON
         * @memberof stealth.SymbolSearchResult
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SymbolSearchResult.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SymbolSearchResult
         * @function getTypeUrl
         * @memberof stealth.SymbolSearchResult
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SymbolSearchResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.SymbolSearchResult";
        };

        return SymbolSearchResult;
    })();

    stealth.SymbolSearchUpdate = (function() {

        /**
         * Properties of a SymbolSearchUpdate.
         * @memberof stealth
         * @interface ISymbolSearchUpdate
         * @property {string|null} [searchTerm] SymbolSearchUpdate searchTerm
         * @property {Array.<stealth.ISymbolSearchResult>|null} [results] SymbolSearchUpdate results
         */

        /**
         * Constructs a new SymbolSearchUpdate.
         * @memberof stealth
         * @classdesc Represents a SymbolSearchUpdate.
         * @implements ISymbolSearchUpdate
         * @constructor
         * @param {stealth.ISymbolSearchUpdate=} [properties] Properties to set
         */
        function SymbolSearchUpdate(properties) {
            this.results = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SymbolSearchUpdate searchTerm.
         * @member {string} searchTerm
         * @memberof stealth.SymbolSearchUpdate
         * @instance
         */
        SymbolSearchUpdate.prototype.searchTerm = "";

        /**
         * SymbolSearchUpdate results.
         * @member {Array.<stealth.ISymbolSearchResult>} results
         * @memberof stealth.SymbolSearchUpdate
         * @instance
         */
        SymbolSearchUpdate.prototype.results = $util.emptyArray;

        /**
         * Creates a new SymbolSearchUpdate instance using the specified properties.
         * @function create
         * @memberof stealth.SymbolSearchUpdate
         * @static
         * @param {stealth.ISymbolSearchUpdate=} [properties] Properties to set
         * @returns {stealth.SymbolSearchUpdate} SymbolSearchUpdate instance
         */
        SymbolSearchUpdate.create = function create(properties) {
            return new SymbolSearchUpdate(properties);
        };

        /**
         * Encodes the specified SymbolSearchUpdate message. Does not implicitly {@link stealth.SymbolSearchUpdate.verify|verify} messages.
         * @function encode
         * @memberof stealth.SymbolSearchUpdate
         * @static
         * @param {stealth.ISymbolSearchUpdate} message SymbolSearchUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SymbolSearchUpdate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.searchTerm != null && Object.hasOwnProperty.call(message, "searchTerm"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.searchTerm);
            if (message.results != null && message.results.length)
                for (let i = 0; i < message.results.length; ++i)
                    $root.stealth.SymbolSearchResult.encode(message.results[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SymbolSearchUpdate message, length delimited. Does not implicitly {@link stealth.SymbolSearchUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.SymbolSearchUpdate
         * @static
         * @param {stealth.ISymbolSearchUpdate} message SymbolSearchUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SymbolSearchUpdate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SymbolSearchUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.SymbolSearchUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.SymbolSearchUpdate} SymbolSearchUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SymbolSearchUpdate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.SymbolSearchUpdate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.searchTerm = reader.string();
                        break;
                    }
                case 2: {
                        if (!(message.results && message.results.length))
                            message.results = [];
                        message.results.push($root.stealth.SymbolSearchResult.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SymbolSearchUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.SymbolSearchUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.SymbolSearchUpdate} SymbolSearchUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SymbolSearchUpdate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SymbolSearchUpdate message.
         * @function verify
         * @memberof stealth.SymbolSearchUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SymbolSearchUpdate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.searchTerm != null && message.hasOwnProperty("searchTerm"))
                if (!$util.isString(message.searchTerm))
                    return "searchTerm: string expected";
            if (message.results != null && message.hasOwnProperty("results")) {
                if (!Array.isArray(message.results))
                    return "results: array expected";
                for (let i = 0; i < message.results.length; ++i) {
                    let error = $root.stealth.SymbolSearchResult.verify(message.results[i]);
                    if (error)
                        return "results." + error;
                }
            }
            return null;
        };

        /**
         * Creates a SymbolSearchUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.SymbolSearchUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.SymbolSearchUpdate} SymbolSearchUpdate
         */
        SymbolSearchUpdate.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.SymbolSearchUpdate)
                return object;
            let message = new $root.stealth.SymbolSearchUpdate();
            if (object.searchTerm != null)
                message.searchTerm = String(object.searchTerm);
            if (object.results) {
                if (!Array.isArray(object.results))
                    throw TypeError(".stealth.SymbolSearchUpdate.results: array expected");
                message.results = [];
                for (let i = 0; i < object.results.length; ++i) {
                    if (typeof object.results[i] !== "object")
                        throw TypeError(".stealth.SymbolSearchUpdate.results: object expected");
                    message.results[i] = $root.stealth.SymbolSearchResult.fromObject(object.results[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a SymbolSearchUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.SymbolSearchUpdate
         * @static
         * @param {stealth.SymbolSearchUpdate} message SymbolSearchUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SymbolSearchUpdate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.results = [];
            if (options.defaults)
                object.searchTerm = "";
            if (message.searchTerm != null && message.hasOwnProperty("searchTerm"))
                object.searchTerm = message.searchTerm;
            if (message.results && message.results.length) {
                object.results = [];
                for (let j = 0; j < message.results.length; ++j)
                    object.results[j] = $root.stealth.SymbolSearchResult.toObject(message.results[j], options);
            }
            return object;
        };

        /**
         * Converts this SymbolSearchUpdate to JSON.
         * @function toJSON
         * @memberof stealth.SymbolSearchUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SymbolSearchUpdate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SymbolSearchUpdate
         * @function getTypeUrl
         * @memberof stealth.SymbolSearchUpdate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SymbolSearchUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.SymbolSearchUpdate";
        };

        return SymbolSearchUpdate;
    })();

    stealth.TopSymbolItem = (function() {

        /**
         * Properties of a TopSymbolItem.
         * @memberof stealth
         * @interface ITopSymbolItem
         * @property {number|Long|null} [timestamp] TopSymbolItem timestamp
         * @property {string|null} [symbol] TopSymbolItem symbol
         * @property {string|null} [underlying] TopSymbolItem underlying
         * @property {string|null} [currency] TopSymbolItem currency
         * @property {stealth.InstrumentType|null} [instrumentType] TopSymbolItem instrumentType
         * @property {string|null} [exchange] TopSymbolItem exchange
         * @property {string|null} [displayName] TopSymbolItem displayName
         * @property {number|null} [entryProgress] TopSymbolItem entryProgress
         * @property {stealth.StrategySignal|null} [signal] TopSymbolItem signal
         * @property {stealth.GaugeSignal|null} [perceptionSignal] TopSymbolItem perceptionSignal
         * @property {stealth.GaugeSignal|null} [commitmentSignal] TopSymbolItem commitmentSignal
         * @property {stealth.GaugeSignal|null} [sentimentSignal] TopSymbolItem sentimentSignal
         * @property {stealth.GaugeSignal|null} [equilibriumSignal] TopSymbolItem equilibriumSignal
         */

        /**
         * Constructs a new TopSymbolItem.
         * @memberof stealth
         * @classdesc Represents a TopSymbolItem.
         * @implements ITopSymbolItem
         * @constructor
         * @param {stealth.ITopSymbolItem=} [properties] Properties to set
         */
        function TopSymbolItem(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TopSymbolItem timestamp.
         * @member {number|Long} timestamp
         * @memberof stealth.TopSymbolItem
         * @instance
         */
        TopSymbolItem.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * TopSymbolItem symbol.
         * @member {string} symbol
         * @memberof stealth.TopSymbolItem
         * @instance
         */
        TopSymbolItem.prototype.symbol = "";

        /**
         * TopSymbolItem underlying.
         * @member {string} underlying
         * @memberof stealth.TopSymbolItem
         * @instance
         */
        TopSymbolItem.prototype.underlying = "";

        /**
         * TopSymbolItem currency.
         * @member {string} currency
         * @memberof stealth.TopSymbolItem
         * @instance
         */
        TopSymbolItem.prototype.currency = "";

        /**
         * TopSymbolItem instrumentType.
         * @member {stealth.InstrumentType} instrumentType
         * @memberof stealth.TopSymbolItem
         * @instance
         */
        TopSymbolItem.prototype.instrumentType = 0;

        /**
         * TopSymbolItem exchange.
         * @member {string} exchange
         * @memberof stealth.TopSymbolItem
         * @instance
         */
        TopSymbolItem.prototype.exchange = "";

        /**
         * TopSymbolItem displayName.
         * @member {string} displayName
         * @memberof stealth.TopSymbolItem
         * @instance
         */
        TopSymbolItem.prototype.displayName = "";

        /**
         * TopSymbolItem entryProgress.
         * @member {number} entryProgress
         * @memberof stealth.TopSymbolItem
         * @instance
         */
        TopSymbolItem.prototype.entryProgress = 0;

        /**
         * TopSymbolItem signal.
         * @member {stealth.StrategySignal} signal
         * @memberof stealth.TopSymbolItem
         * @instance
         */
        TopSymbolItem.prototype.signal = 0;

        /**
         * TopSymbolItem perceptionSignal.
         * @member {stealth.GaugeSignal} perceptionSignal
         * @memberof stealth.TopSymbolItem
         * @instance
         */
        TopSymbolItem.prototype.perceptionSignal = 0;

        /**
         * TopSymbolItem commitmentSignal.
         * @member {stealth.GaugeSignal} commitmentSignal
         * @memberof stealth.TopSymbolItem
         * @instance
         */
        TopSymbolItem.prototype.commitmentSignal = 0;

        /**
         * TopSymbolItem sentimentSignal.
         * @member {stealth.GaugeSignal} sentimentSignal
         * @memberof stealth.TopSymbolItem
         * @instance
         */
        TopSymbolItem.prototype.sentimentSignal = 0;

        /**
         * TopSymbolItem equilibriumSignal.
         * @member {stealth.GaugeSignal} equilibriumSignal
         * @memberof stealth.TopSymbolItem
         * @instance
         */
        TopSymbolItem.prototype.equilibriumSignal = 0;

        /**
         * Creates a new TopSymbolItem instance using the specified properties.
         * @function create
         * @memberof stealth.TopSymbolItem
         * @static
         * @param {stealth.ITopSymbolItem=} [properties] Properties to set
         * @returns {stealth.TopSymbolItem} TopSymbolItem instance
         */
        TopSymbolItem.create = function create(properties) {
            return new TopSymbolItem(properties);
        };

        /**
         * Encodes the specified TopSymbolItem message. Does not implicitly {@link stealth.TopSymbolItem.verify|verify} messages.
         * @function encode
         * @memberof stealth.TopSymbolItem
         * @static
         * @param {stealth.ITopSymbolItem} message TopSymbolItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TopSymbolItem.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.timestamp);
            if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.symbol);
            if (message.underlying != null && Object.hasOwnProperty.call(message, "underlying"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.underlying);
            if (message.currency != null && Object.hasOwnProperty.call(message, "currency"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.currency);
            if (message.instrumentType != null && Object.hasOwnProperty.call(message, "instrumentType"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.instrumentType);
            if (message.exchange != null && Object.hasOwnProperty.call(message, "exchange"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.exchange);
            if (message.displayName != null && Object.hasOwnProperty.call(message, "displayName"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.displayName);
            if (message.entryProgress != null && Object.hasOwnProperty.call(message, "entryProgress"))
                writer.uint32(/* id 8, wireType 0 =*/64).sint32(message.entryProgress);
            if (message.signal != null && Object.hasOwnProperty.call(message, "signal"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.signal);
            if (message.perceptionSignal != null && Object.hasOwnProperty.call(message, "perceptionSignal"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.perceptionSignal);
            if (message.commitmentSignal != null && Object.hasOwnProperty.call(message, "commitmentSignal"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.commitmentSignal);
            if (message.sentimentSignal != null && Object.hasOwnProperty.call(message, "sentimentSignal"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.sentimentSignal);
            if (message.equilibriumSignal != null && Object.hasOwnProperty.call(message, "equilibriumSignal"))
                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.equilibriumSignal);
            return writer;
        };

        /**
         * Encodes the specified TopSymbolItem message, length delimited. Does not implicitly {@link stealth.TopSymbolItem.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.TopSymbolItem
         * @static
         * @param {stealth.ITopSymbolItem} message TopSymbolItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TopSymbolItem.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TopSymbolItem message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.TopSymbolItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.TopSymbolItem} TopSymbolItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TopSymbolItem.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.TopSymbolItem();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.timestamp = reader.uint64();
                        break;
                    }
                case 2: {
                        message.symbol = reader.string();
                        break;
                    }
                case 3: {
                        message.underlying = reader.string();
                        break;
                    }
                case 4: {
                        message.currency = reader.string();
                        break;
                    }
                case 5: {
                        message.instrumentType = reader.int32();
                        break;
                    }
                case 6: {
                        message.exchange = reader.string();
                        break;
                    }
                case 7: {
                        message.displayName = reader.string();
                        break;
                    }
                case 8: {
                        message.entryProgress = reader.sint32();
                        break;
                    }
                case 9: {
                        message.signal = reader.int32();
                        break;
                    }
                case 10: {
                        message.perceptionSignal = reader.int32();
                        break;
                    }
                case 11: {
                        message.commitmentSignal = reader.int32();
                        break;
                    }
                case 12: {
                        message.sentimentSignal = reader.int32();
                        break;
                    }
                case 13: {
                        message.equilibriumSignal = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TopSymbolItem message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.TopSymbolItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.TopSymbolItem} TopSymbolItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TopSymbolItem.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TopSymbolItem message.
         * @function verify
         * @memberof stealth.TopSymbolItem
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TopSymbolItem.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                    return "timestamp: integer|Long expected";
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                if (!$util.isString(message.symbol))
                    return "symbol: string expected";
            if (message.underlying != null && message.hasOwnProperty("underlying"))
                if (!$util.isString(message.underlying))
                    return "underlying: string expected";
            if (message.currency != null && message.hasOwnProperty("currency"))
                if (!$util.isString(message.currency))
                    return "currency: string expected";
            if (message.instrumentType != null && message.hasOwnProperty("instrumentType"))
                switch (message.instrumentType) {
                default:
                    return "instrumentType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                    break;
                }
            if (message.exchange != null && message.hasOwnProperty("exchange"))
                if (!$util.isString(message.exchange))
                    return "exchange: string expected";
            if (message.displayName != null && message.hasOwnProperty("displayName"))
                if (!$util.isString(message.displayName))
                    return "displayName: string expected";
            if (message.entryProgress != null && message.hasOwnProperty("entryProgress"))
                if (!$util.isInteger(message.entryProgress))
                    return "entryProgress: integer expected";
            if (message.signal != null && message.hasOwnProperty("signal"))
                switch (message.signal) {
                default:
                    return "signal: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.perceptionSignal != null && message.hasOwnProperty("perceptionSignal"))
                switch (message.perceptionSignal) {
                default:
                    return "perceptionSignal: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.commitmentSignal != null && message.hasOwnProperty("commitmentSignal"))
                switch (message.commitmentSignal) {
                default:
                    return "commitmentSignal: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.sentimentSignal != null && message.hasOwnProperty("sentimentSignal"))
                switch (message.sentimentSignal) {
                default:
                    return "sentimentSignal: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.equilibriumSignal != null && message.hasOwnProperty("equilibriumSignal"))
                switch (message.equilibriumSignal) {
                default:
                    return "equilibriumSignal: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            return null;
        };

        /**
         * Creates a TopSymbolItem message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.TopSymbolItem
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.TopSymbolItem} TopSymbolItem
         */
        TopSymbolItem.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.TopSymbolItem)
                return object;
            let message = new $root.stealth.TopSymbolItem();
            if (object.timestamp != null)
                if ($util.Long)
                    (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
                else if (typeof object.timestamp === "string")
                    message.timestamp = parseInt(object.timestamp, 10);
                else if (typeof object.timestamp === "number")
                    message.timestamp = object.timestamp;
                else if (typeof object.timestamp === "object")
                    message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
            if (object.symbol != null)
                message.symbol = String(object.symbol);
            if (object.underlying != null)
                message.underlying = String(object.underlying);
            if (object.currency != null)
                message.currency = String(object.currency);
            switch (object.instrumentType) {
            default:
                if (typeof object.instrumentType === "number") {
                    message.instrumentType = object.instrumentType;
                    break;
                }
                break;
            case "NoInstrument":
            case 0:
                message.instrumentType = 0;
                break;
            case "CommonStock":
            case 1:
                message.instrumentType = 1;
                break;
            case "StockOption":
            case 2:
                message.instrumentType = 2;
                break;
            case "Future":
            case 3:
                message.instrumentType = 3;
                break;
            case "Index":
            case 4:
                message.instrumentType = 4;
                break;
            case "ForexContract":
            case 5:
                message.instrumentType = 5;
                break;
            case "FutureOption":
            case 6:
                message.instrumentType = 6;
                break;
            case "FutureInstrument":
            case 7:
                message.instrumentType = 7;
                break;
            case "Combo":
            case 8:
                message.instrumentType = 8;
                break;
            case "ComboInstrument":
            case 9:
                message.instrumentType = 9;
                break;
            case "CryptoCurrency":
            case 10:
                message.instrumentType = 10;
                break;
            case "PerpetualCrypto":
            case 11:
                message.instrumentType = 11;
                break;
            }
            if (object.exchange != null)
                message.exchange = String(object.exchange);
            if (object.displayName != null)
                message.displayName = String(object.displayName);
            if (object.entryProgress != null)
                message.entryProgress = object.entryProgress | 0;
            switch (object.signal) {
            default:
                if (typeof object.signal === "number") {
                    message.signal = object.signal;
                    break;
                }
                break;
            case "None":
            case 0:
                message.signal = 0;
                break;
            case "LongSignal":
            case 1:
                message.signal = 1;
                break;
            case "ShortSignal":
            case 2:
                message.signal = 2;
                break;
            }
            switch (object.perceptionSignal) {
            default:
                if (typeof object.perceptionSignal === "number") {
                    message.perceptionSignal = object.perceptionSignal;
                    break;
                }
                break;
            case "Unknown":
            case 0:
                message.perceptionSignal = 0;
                break;
            case "Short":
            case 1:
                message.perceptionSignal = 1;
                break;
            case "Flat":
            case 2:
                message.perceptionSignal = 2;
                break;
            case "Long":
            case 3:
                message.perceptionSignal = 3;
                break;
            case "Dual":
            case 4:
                message.perceptionSignal = 4;
                break;
            }
            switch (object.commitmentSignal) {
            default:
                if (typeof object.commitmentSignal === "number") {
                    message.commitmentSignal = object.commitmentSignal;
                    break;
                }
                break;
            case "Unknown":
            case 0:
                message.commitmentSignal = 0;
                break;
            case "Short":
            case 1:
                message.commitmentSignal = 1;
                break;
            case "Flat":
            case 2:
                message.commitmentSignal = 2;
                break;
            case "Long":
            case 3:
                message.commitmentSignal = 3;
                break;
            case "Dual":
            case 4:
                message.commitmentSignal = 4;
                break;
            }
            switch (object.sentimentSignal) {
            default:
                if (typeof object.sentimentSignal === "number") {
                    message.sentimentSignal = object.sentimentSignal;
                    break;
                }
                break;
            case "Unknown":
            case 0:
                message.sentimentSignal = 0;
                break;
            case "Short":
            case 1:
                message.sentimentSignal = 1;
                break;
            case "Flat":
            case 2:
                message.sentimentSignal = 2;
                break;
            case "Long":
            case 3:
                message.sentimentSignal = 3;
                break;
            case "Dual":
            case 4:
                message.sentimentSignal = 4;
                break;
            }
            switch (object.equilibriumSignal) {
            default:
                if (typeof object.equilibriumSignal === "number") {
                    message.equilibriumSignal = object.equilibriumSignal;
                    break;
                }
                break;
            case "Unknown":
            case 0:
                message.equilibriumSignal = 0;
                break;
            case "Short":
            case 1:
                message.equilibriumSignal = 1;
                break;
            case "Flat":
            case 2:
                message.equilibriumSignal = 2;
                break;
            case "Long":
            case 3:
                message.equilibriumSignal = 3;
                break;
            case "Dual":
            case 4:
                message.equilibriumSignal = 4;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a TopSymbolItem message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.TopSymbolItem
         * @static
         * @param {stealth.TopSymbolItem} message TopSymbolItem
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TopSymbolItem.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.timestamp = options.longs === String ? "0" : 0;
                object.symbol = "";
                object.underlying = "";
                object.currency = "";
                object.instrumentType = options.enums === String ? "NoInstrument" : 0;
                object.exchange = "";
                object.displayName = "";
                object.entryProgress = 0;
                object.signal = options.enums === String ? "None" : 0;
                object.perceptionSignal = options.enums === String ? "Unknown" : 0;
                object.commitmentSignal = options.enums === String ? "Unknown" : 0;
                object.sentimentSignal = options.enums === String ? "Unknown" : 0;
                object.equilibriumSignal = options.enums === String ? "Unknown" : 0;
            }
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (typeof message.timestamp === "number")
                    object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                else
                    object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                object.symbol = message.symbol;
            if (message.underlying != null && message.hasOwnProperty("underlying"))
                object.underlying = message.underlying;
            if (message.currency != null && message.hasOwnProperty("currency"))
                object.currency = message.currency;
            if (message.instrumentType != null && message.hasOwnProperty("instrumentType"))
                object.instrumentType = options.enums === String ? $root.stealth.InstrumentType[message.instrumentType] === undefined ? message.instrumentType : $root.stealth.InstrumentType[message.instrumentType] : message.instrumentType;
            if (message.exchange != null && message.hasOwnProperty("exchange"))
                object.exchange = message.exchange;
            if (message.displayName != null && message.hasOwnProperty("displayName"))
                object.displayName = message.displayName;
            if (message.entryProgress != null && message.hasOwnProperty("entryProgress"))
                object.entryProgress = message.entryProgress;
            if (message.signal != null && message.hasOwnProperty("signal"))
                object.signal = options.enums === String ? $root.stealth.StrategySignal[message.signal] === undefined ? message.signal : $root.stealth.StrategySignal[message.signal] : message.signal;
            if (message.perceptionSignal != null && message.hasOwnProperty("perceptionSignal"))
                object.perceptionSignal = options.enums === String ? $root.stealth.GaugeSignal[message.perceptionSignal] === undefined ? message.perceptionSignal : $root.stealth.GaugeSignal[message.perceptionSignal] : message.perceptionSignal;
            if (message.commitmentSignal != null && message.hasOwnProperty("commitmentSignal"))
                object.commitmentSignal = options.enums === String ? $root.stealth.GaugeSignal[message.commitmentSignal] === undefined ? message.commitmentSignal : $root.stealth.GaugeSignal[message.commitmentSignal] : message.commitmentSignal;
            if (message.sentimentSignal != null && message.hasOwnProperty("sentimentSignal"))
                object.sentimentSignal = options.enums === String ? $root.stealth.GaugeSignal[message.sentimentSignal] === undefined ? message.sentimentSignal : $root.stealth.GaugeSignal[message.sentimentSignal] : message.sentimentSignal;
            if (message.equilibriumSignal != null && message.hasOwnProperty("equilibriumSignal"))
                object.equilibriumSignal = options.enums === String ? $root.stealth.GaugeSignal[message.equilibriumSignal] === undefined ? message.equilibriumSignal : $root.stealth.GaugeSignal[message.equilibriumSignal] : message.equilibriumSignal;
            return object;
        };

        /**
         * Converts this TopSymbolItem to JSON.
         * @function toJSON
         * @memberof stealth.TopSymbolItem
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TopSymbolItem.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for TopSymbolItem
         * @function getTypeUrl
         * @memberof stealth.TopSymbolItem
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        TopSymbolItem.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.TopSymbolItem";
        };

        return TopSymbolItem;
    })();

    stealth.TopSymbolsUpdate = (function() {

        /**
         * Properties of a TopSymbolsUpdate.
         * @memberof stealth
         * @interface ITopSymbolsUpdate
         * @property {Array.<stealth.ITopSymbolItem>|null} [symbols] TopSymbolsUpdate symbols
         */

        /**
         * Constructs a new TopSymbolsUpdate.
         * @memberof stealth
         * @classdesc Represents a TopSymbolsUpdate.
         * @implements ITopSymbolsUpdate
         * @constructor
         * @param {stealth.ITopSymbolsUpdate=} [properties] Properties to set
         */
        function TopSymbolsUpdate(properties) {
            this.symbols = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TopSymbolsUpdate symbols.
         * @member {Array.<stealth.ITopSymbolItem>} symbols
         * @memberof stealth.TopSymbolsUpdate
         * @instance
         */
        TopSymbolsUpdate.prototype.symbols = $util.emptyArray;

        /**
         * Creates a new TopSymbolsUpdate instance using the specified properties.
         * @function create
         * @memberof stealth.TopSymbolsUpdate
         * @static
         * @param {stealth.ITopSymbolsUpdate=} [properties] Properties to set
         * @returns {stealth.TopSymbolsUpdate} TopSymbolsUpdate instance
         */
        TopSymbolsUpdate.create = function create(properties) {
            return new TopSymbolsUpdate(properties);
        };

        /**
         * Encodes the specified TopSymbolsUpdate message. Does not implicitly {@link stealth.TopSymbolsUpdate.verify|verify} messages.
         * @function encode
         * @memberof stealth.TopSymbolsUpdate
         * @static
         * @param {stealth.ITopSymbolsUpdate} message TopSymbolsUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TopSymbolsUpdate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.symbols != null && message.symbols.length)
                for (let i = 0; i < message.symbols.length; ++i)
                    $root.stealth.TopSymbolItem.encode(message.symbols[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified TopSymbolsUpdate message, length delimited. Does not implicitly {@link stealth.TopSymbolsUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.TopSymbolsUpdate
         * @static
         * @param {stealth.ITopSymbolsUpdate} message TopSymbolsUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TopSymbolsUpdate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TopSymbolsUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.TopSymbolsUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.TopSymbolsUpdate} TopSymbolsUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TopSymbolsUpdate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.TopSymbolsUpdate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.symbols && message.symbols.length))
                            message.symbols = [];
                        message.symbols.push($root.stealth.TopSymbolItem.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TopSymbolsUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.TopSymbolsUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.TopSymbolsUpdate} TopSymbolsUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TopSymbolsUpdate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TopSymbolsUpdate message.
         * @function verify
         * @memberof stealth.TopSymbolsUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TopSymbolsUpdate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.symbols != null && message.hasOwnProperty("symbols")) {
                if (!Array.isArray(message.symbols))
                    return "symbols: array expected";
                for (let i = 0; i < message.symbols.length; ++i) {
                    let error = $root.stealth.TopSymbolItem.verify(message.symbols[i]);
                    if (error)
                        return "symbols." + error;
                }
            }
            return null;
        };

        /**
         * Creates a TopSymbolsUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.TopSymbolsUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.TopSymbolsUpdate} TopSymbolsUpdate
         */
        TopSymbolsUpdate.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.TopSymbolsUpdate)
                return object;
            let message = new $root.stealth.TopSymbolsUpdate();
            if (object.symbols) {
                if (!Array.isArray(object.symbols))
                    throw TypeError(".stealth.TopSymbolsUpdate.symbols: array expected");
                message.symbols = [];
                for (let i = 0; i < object.symbols.length; ++i) {
                    if (typeof object.symbols[i] !== "object")
                        throw TypeError(".stealth.TopSymbolsUpdate.symbols: object expected");
                    message.symbols[i] = $root.stealth.TopSymbolItem.fromObject(object.symbols[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a TopSymbolsUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.TopSymbolsUpdate
         * @static
         * @param {stealth.TopSymbolsUpdate} message TopSymbolsUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TopSymbolsUpdate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.symbols = [];
            if (message.symbols && message.symbols.length) {
                object.symbols = [];
                for (let j = 0; j < message.symbols.length; ++j)
                    object.symbols[j] = $root.stealth.TopSymbolItem.toObject(message.symbols[j], options);
            }
            return object;
        };

        /**
         * Converts this TopSymbolsUpdate to JSON.
         * @function toJSON
         * @memberof stealth.TopSymbolsUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TopSymbolsUpdate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for TopSymbolsUpdate
         * @function getTypeUrl
         * @memberof stealth.TopSymbolsUpdate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        TopSymbolsUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.TopSymbolsUpdate";
        };

        return TopSymbolsUpdate;
    })();

    stealth.ChartSeries = (function() {

        /**
         * Properties of a ChartSeries.
         * @memberof stealth
         * @interface IChartSeries
         * @property {string|null} [title] ChartSeries title
         * @property {stealth.ChartSeries.ChartSeriesType|null} [type] ChartSeries type
         */

        /**
         * Constructs a new ChartSeries.
         * @memberof stealth
         * @classdesc Represents a ChartSeries.
         * @implements IChartSeries
         * @constructor
         * @param {stealth.IChartSeries=} [properties] Properties to set
         */
        function ChartSeries(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ChartSeries title.
         * @member {string} title
         * @memberof stealth.ChartSeries
         * @instance
         */
        ChartSeries.prototype.title = "";

        /**
         * ChartSeries type.
         * @member {stealth.ChartSeries.ChartSeriesType} type
         * @memberof stealth.ChartSeries
         * @instance
         */
        ChartSeries.prototype.type = 0;

        /**
         * Creates a new ChartSeries instance using the specified properties.
         * @function create
         * @memberof stealth.ChartSeries
         * @static
         * @param {stealth.IChartSeries=} [properties] Properties to set
         * @returns {stealth.ChartSeries} ChartSeries instance
         */
        ChartSeries.create = function create(properties) {
            return new ChartSeries(properties);
        };

        /**
         * Encodes the specified ChartSeries message. Does not implicitly {@link stealth.ChartSeries.verify|verify} messages.
         * @function encode
         * @memberof stealth.ChartSeries
         * @static
         * @param {stealth.IChartSeries} message ChartSeries message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChartSeries.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.title);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.type);
            return writer;
        };

        /**
         * Encodes the specified ChartSeries message, length delimited. Does not implicitly {@link stealth.ChartSeries.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.ChartSeries
         * @static
         * @param {stealth.IChartSeries} message ChartSeries message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChartSeries.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ChartSeries message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.ChartSeries
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.ChartSeries} ChartSeries
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChartSeries.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.ChartSeries();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.title = reader.string();
                        break;
                    }
                case 2: {
                        message.type = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ChartSeries message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.ChartSeries
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.ChartSeries} ChartSeries
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChartSeries.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ChartSeries message.
         * @function verify
         * @memberof stealth.ChartSeries
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ChartSeries.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.type != null && message.hasOwnProperty("type"))
                switch (message.type) {
                default:
                    return "type: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            return null;
        };

        /**
         * Creates a ChartSeries message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.ChartSeries
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.ChartSeries} ChartSeries
         */
        ChartSeries.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.ChartSeries)
                return object;
            let message = new $root.stealth.ChartSeries();
            if (object.title != null)
                message.title = String(object.title);
            switch (object.type) {
            default:
                if (typeof object.type === "number") {
                    message.type = object.type;
                    break;
                }
                break;
            case "None":
            case 0:
                message.type = 0;
                break;
            case "UnixTime":
            case 1:
                message.type = 1;
                break;
            case "Price":
            case 2:
                message.type = 2;
                break;
            case "Volume":
            case 3:
                message.type = 3;
                break;
            case "Value":
            case 4:
                message.type = 4;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a ChartSeries message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.ChartSeries
         * @static
         * @param {stealth.ChartSeries} message ChartSeries
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ChartSeries.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.title = "";
                object.type = options.enums === String ? "None" : 0;
            }
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.stealth.ChartSeries.ChartSeriesType[message.type] === undefined ? message.type : $root.stealth.ChartSeries.ChartSeriesType[message.type] : message.type;
            return object;
        };

        /**
         * Converts this ChartSeries to JSON.
         * @function toJSON
         * @memberof stealth.ChartSeries
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ChartSeries.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ChartSeries
         * @function getTypeUrl
         * @memberof stealth.ChartSeries
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ChartSeries.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.ChartSeries";
        };

        /**
         * ChartSeriesType enum.
         * @name stealth.ChartSeries.ChartSeriesType
         * @enum {number}
         * @property {number} None=0 None value
         * @property {number} UnixTime=1 UnixTime value
         * @property {number} Price=2 Price value
         * @property {number} Volume=3 Volume value
         * @property {number} Value=4 Value value
         */
        ChartSeries.ChartSeriesType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "None"] = 0;
            values[valuesById[1] = "UnixTime"] = 1;
            values[valuesById[2] = "Price"] = 2;
            values[valuesById[3] = "Volume"] = 3;
            values[valuesById[4] = "Value"] = 4;
            return values;
        })();

        return ChartSeries;
    })();

    stealth.ChartValues = (function() {

        /**
         * Properties of a ChartValues.
         * @memberof stealth
         * @interface IChartValues
         * @property {Array.<number>|null} [value] ChartValues value
         */

        /**
         * Constructs a new ChartValues.
         * @memberof stealth
         * @classdesc Represents a ChartValues.
         * @implements IChartValues
         * @constructor
         * @param {stealth.IChartValues=} [properties] Properties to set
         */
        function ChartValues(properties) {
            this.value = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ChartValues value.
         * @member {Array.<number>} value
         * @memberof stealth.ChartValues
         * @instance
         */
        ChartValues.prototype.value = $util.emptyArray;

        /**
         * Creates a new ChartValues instance using the specified properties.
         * @function create
         * @memberof stealth.ChartValues
         * @static
         * @param {stealth.IChartValues=} [properties] Properties to set
         * @returns {stealth.ChartValues} ChartValues instance
         */
        ChartValues.create = function create(properties) {
            return new ChartValues(properties);
        };

        /**
         * Encodes the specified ChartValues message. Does not implicitly {@link stealth.ChartValues.verify|verify} messages.
         * @function encode
         * @memberof stealth.ChartValues
         * @static
         * @param {stealth.IChartValues} message ChartValues message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChartValues.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.value != null && message.value.length) {
                writer.uint32(/* id 1, wireType 2 =*/10).fork();
                for (let i = 0; i < message.value.length; ++i)
                    writer.double(message.value[i]);
                writer.ldelim();
            }
            return writer;
        };

        /**
         * Encodes the specified ChartValues message, length delimited. Does not implicitly {@link stealth.ChartValues.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.ChartValues
         * @static
         * @param {stealth.IChartValues} message ChartValues message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChartValues.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ChartValues message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.ChartValues
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.ChartValues} ChartValues
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChartValues.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.ChartValues();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.value && message.value.length))
                            message.value = [];
                        if ((tag & 7) === 2) {
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.value.push(reader.double());
                        } else
                            message.value.push(reader.double());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ChartValues message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.ChartValues
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.ChartValues} ChartValues
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChartValues.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ChartValues message.
         * @function verify
         * @memberof stealth.ChartValues
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ChartValues.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.value != null && message.hasOwnProperty("value")) {
                if (!Array.isArray(message.value))
                    return "value: array expected";
                for (let i = 0; i < message.value.length; ++i)
                    if (typeof message.value[i] !== "number")
                        return "value: number[] expected";
            }
            return null;
        };

        /**
         * Creates a ChartValues message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.ChartValues
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.ChartValues} ChartValues
         */
        ChartValues.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.ChartValues)
                return object;
            let message = new $root.stealth.ChartValues();
            if (object.value) {
                if (!Array.isArray(object.value))
                    throw TypeError(".stealth.ChartValues.value: array expected");
                message.value = [];
                for (let i = 0; i < object.value.length; ++i)
                    message.value[i] = Number(object.value[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ChartValues message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.ChartValues
         * @static
         * @param {stealth.ChartValues} message ChartValues
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ChartValues.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.value = [];
            if (message.value && message.value.length) {
                object.value = [];
                for (let j = 0; j < message.value.length; ++j)
                    object.value[j] = options.json && !isFinite(message.value[j]) ? String(message.value[j]) : message.value[j];
            }
            return object;
        };

        /**
         * Converts this ChartValues to JSON.
         * @function toJSON
         * @memberof stealth.ChartValues
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ChartValues.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ChartValues
         * @function getTypeUrl
         * @memberof stealth.ChartValues
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ChartValues.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.ChartValues";
        };

        return ChartValues;
    })();

    stealth.ChartUpdate = (function() {

        /**
         * Properties of a ChartUpdate.
         * @memberof stealth
         * @interface IChartUpdate
         * @property {Array.<stealth.IChartSeries>|null} [series] ChartUpdate series
         * @property {Array.<stealth.IChartValues>|null} [values] ChartUpdate values
         */

        /**
         * Constructs a new ChartUpdate.
         * @memberof stealth
         * @classdesc Represents a ChartUpdate.
         * @implements IChartUpdate
         * @constructor
         * @param {stealth.IChartUpdate=} [properties] Properties to set
         */
        function ChartUpdate(properties) {
            this.series = [];
            this.values = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ChartUpdate series.
         * @member {Array.<stealth.IChartSeries>} series
         * @memberof stealth.ChartUpdate
         * @instance
         */
        ChartUpdate.prototype.series = $util.emptyArray;

        /**
         * ChartUpdate values.
         * @member {Array.<stealth.IChartValues>} values
         * @memberof stealth.ChartUpdate
         * @instance
         */
        ChartUpdate.prototype.values = $util.emptyArray;

        /**
         * Creates a new ChartUpdate instance using the specified properties.
         * @function create
         * @memberof stealth.ChartUpdate
         * @static
         * @param {stealth.IChartUpdate=} [properties] Properties to set
         * @returns {stealth.ChartUpdate} ChartUpdate instance
         */
        ChartUpdate.create = function create(properties) {
            return new ChartUpdate(properties);
        };

        /**
         * Encodes the specified ChartUpdate message. Does not implicitly {@link stealth.ChartUpdate.verify|verify} messages.
         * @function encode
         * @memberof stealth.ChartUpdate
         * @static
         * @param {stealth.IChartUpdate} message ChartUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChartUpdate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.series != null && message.series.length)
                for (let i = 0; i < message.series.length; ++i)
                    $root.stealth.ChartSeries.encode(message.series[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.values != null && message.values.length)
                for (let i = 0; i < message.values.length; ++i)
                    $root.stealth.ChartValues.encode(message.values[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ChartUpdate message, length delimited. Does not implicitly {@link stealth.ChartUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.ChartUpdate
         * @static
         * @param {stealth.IChartUpdate} message ChartUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChartUpdate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ChartUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.ChartUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.ChartUpdate} ChartUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChartUpdate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.ChartUpdate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.series && message.series.length))
                            message.series = [];
                        message.series.push($root.stealth.ChartSeries.decode(reader, reader.uint32()));
                        break;
                    }
                case 2: {
                        if (!(message.values && message.values.length))
                            message.values = [];
                        message.values.push($root.stealth.ChartValues.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ChartUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.ChartUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.ChartUpdate} ChartUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChartUpdate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ChartUpdate message.
         * @function verify
         * @memberof stealth.ChartUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ChartUpdate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.series != null && message.hasOwnProperty("series")) {
                if (!Array.isArray(message.series))
                    return "series: array expected";
                for (let i = 0; i < message.series.length; ++i) {
                    let error = $root.stealth.ChartSeries.verify(message.series[i]);
                    if (error)
                        return "series." + error;
                }
            }
            if (message.values != null && message.hasOwnProperty("values")) {
                if (!Array.isArray(message.values))
                    return "values: array expected";
                for (let i = 0; i < message.values.length; ++i) {
                    let error = $root.stealth.ChartValues.verify(message.values[i]);
                    if (error)
                        return "values." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ChartUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.ChartUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.ChartUpdate} ChartUpdate
         */
        ChartUpdate.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.ChartUpdate)
                return object;
            let message = new $root.stealth.ChartUpdate();
            if (object.series) {
                if (!Array.isArray(object.series))
                    throw TypeError(".stealth.ChartUpdate.series: array expected");
                message.series = [];
                for (let i = 0; i < object.series.length; ++i) {
                    if (typeof object.series[i] !== "object")
                        throw TypeError(".stealth.ChartUpdate.series: object expected");
                    message.series[i] = $root.stealth.ChartSeries.fromObject(object.series[i]);
                }
            }
            if (object.values) {
                if (!Array.isArray(object.values))
                    throw TypeError(".stealth.ChartUpdate.values: array expected");
                message.values = [];
                for (let i = 0; i < object.values.length; ++i) {
                    if (typeof object.values[i] !== "object")
                        throw TypeError(".stealth.ChartUpdate.values: object expected");
                    message.values[i] = $root.stealth.ChartValues.fromObject(object.values[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ChartUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.ChartUpdate
         * @static
         * @param {stealth.ChartUpdate} message ChartUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ChartUpdate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.series = [];
                object.values = [];
            }
            if (message.series && message.series.length) {
                object.series = [];
                for (let j = 0; j < message.series.length; ++j)
                    object.series[j] = $root.stealth.ChartSeries.toObject(message.series[j], options);
            }
            if (message.values && message.values.length) {
                object.values = [];
                for (let j = 0; j < message.values.length; ++j)
                    object.values[j] = $root.stealth.ChartValues.toObject(message.values[j], options);
            }
            return object;
        };

        /**
         * Converts this ChartUpdate to JSON.
         * @function toJSON
         * @memberof stealth.ChartUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ChartUpdate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ChartUpdate
         * @function getTypeUrl
         * @memberof stealth.ChartUpdate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ChartUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.ChartUpdate";
        };

        return ChartUpdate;
    })();

    stealth.PortfolioItem = (function() {

        /**
         * Properties of a PortfolioItem.
         * @memberof stealth
         * @interface IPortfolioItem
         * @property {number|null} [index] PortfolioItem index
         * @property {string|null} [symbol] PortfolioItem symbol
         * @property {number|null} [bias] PortfolioItem bias
         * @property {number|Long|null} [baseSize] PortfolioItem baseSize
         * @property {number|Long|null} [optionSize] PortfolioItem optionSize
         * @property {string|null} [baseExch] PortfolioItem baseExch
         * @property {string|null} [optionExch] PortfolioItem optionExch
         */

        /**
         * Constructs a new PortfolioItem.
         * @memberof stealth
         * @classdesc Represents a PortfolioItem.
         * @implements IPortfolioItem
         * @constructor
         * @param {stealth.IPortfolioItem=} [properties] Properties to set
         */
        function PortfolioItem(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PortfolioItem index.
         * @member {number} index
         * @memberof stealth.PortfolioItem
         * @instance
         */
        PortfolioItem.prototype.index = 0;

        /**
         * PortfolioItem symbol.
         * @member {string} symbol
         * @memberof stealth.PortfolioItem
         * @instance
         */
        PortfolioItem.prototype.symbol = "";

        /**
         * PortfolioItem bias.
         * @member {number} bias
         * @memberof stealth.PortfolioItem
         * @instance
         */
        PortfolioItem.prototype.bias = 0;

        /**
         * PortfolioItem baseSize.
         * @member {number|Long} baseSize
         * @memberof stealth.PortfolioItem
         * @instance
         */
        PortfolioItem.prototype.baseSize = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * PortfolioItem optionSize.
         * @member {number|Long} optionSize
         * @memberof stealth.PortfolioItem
         * @instance
         */
        PortfolioItem.prototype.optionSize = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * PortfolioItem baseExch.
         * @member {string} baseExch
         * @memberof stealth.PortfolioItem
         * @instance
         */
        PortfolioItem.prototype.baseExch = "";

        /**
         * PortfolioItem optionExch.
         * @member {string} optionExch
         * @memberof stealth.PortfolioItem
         * @instance
         */
        PortfolioItem.prototype.optionExch = "";

        /**
         * Creates a new PortfolioItem instance using the specified properties.
         * @function create
         * @memberof stealth.PortfolioItem
         * @static
         * @param {stealth.IPortfolioItem=} [properties] Properties to set
         * @returns {stealth.PortfolioItem} PortfolioItem instance
         */
        PortfolioItem.create = function create(properties) {
            return new PortfolioItem(properties);
        };

        /**
         * Encodes the specified PortfolioItem message. Does not implicitly {@link stealth.PortfolioItem.verify|verify} messages.
         * @function encode
         * @memberof stealth.PortfolioItem
         * @static
         * @param {stealth.IPortfolioItem} message PortfolioItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PortfolioItem.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                writer.uint32(/* id 1, wireType 0 =*/8).sint32(message.index);
            if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.symbol);
            if (message.bias != null && Object.hasOwnProperty.call(message, "bias"))
                writer.uint32(/* id 3, wireType 0 =*/24).sint32(message.bias);
            if (message.baseSize != null && Object.hasOwnProperty.call(message, "baseSize"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.baseSize);
            if (message.optionSize != null && Object.hasOwnProperty.call(message, "optionSize"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.optionSize);
            if (message.baseExch != null && Object.hasOwnProperty.call(message, "baseExch"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.baseExch);
            if (message.optionExch != null && Object.hasOwnProperty.call(message, "optionExch"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.optionExch);
            return writer;
        };

        /**
         * Encodes the specified PortfolioItem message, length delimited. Does not implicitly {@link stealth.PortfolioItem.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.PortfolioItem
         * @static
         * @param {stealth.IPortfolioItem} message PortfolioItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PortfolioItem.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PortfolioItem message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.PortfolioItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.PortfolioItem} PortfolioItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PortfolioItem.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.PortfolioItem();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.index = reader.sint32();
                        break;
                    }
                case 2: {
                        message.symbol = reader.string();
                        break;
                    }
                case 3: {
                        message.bias = reader.sint32();
                        break;
                    }
                case 4: {
                        message.baseSize = reader.uint64();
                        break;
                    }
                case 5: {
                        message.optionSize = reader.uint64();
                        break;
                    }
                case 6: {
                        message.baseExch = reader.string();
                        break;
                    }
                case 7: {
                        message.optionExch = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PortfolioItem message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.PortfolioItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.PortfolioItem} PortfolioItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PortfolioItem.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PortfolioItem message.
         * @function verify
         * @memberof stealth.PortfolioItem
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PortfolioItem.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.index != null && message.hasOwnProperty("index"))
                if (!$util.isInteger(message.index))
                    return "index: integer expected";
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                if (!$util.isString(message.symbol))
                    return "symbol: string expected";
            if (message.bias != null && message.hasOwnProperty("bias"))
                if (!$util.isInteger(message.bias))
                    return "bias: integer expected";
            if (message.baseSize != null && message.hasOwnProperty("baseSize"))
                if (!$util.isInteger(message.baseSize) && !(message.baseSize && $util.isInteger(message.baseSize.low) && $util.isInteger(message.baseSize.high)))
                    return "baseSize: integer|Long expected";
            if (message.optionSize != null && message.hasOwnProperty("optionSize"))
                if (!$util.isInteger(message.optionSize) && !(message.optionSize && $util.isInteger(message.optionSize.low) && $util.isInteger(message.optionSize.high)))
                    return "optionSize: integer|Long expected";
            if (message.baseExch != null && message.hasOwnProperty("baseExch"))
                if (!$util.isString(message.baseExch))
                    return "baseExch: string expected";
            if (message.optionExch != null && message.hasOwnProperty("optionExch"))
                if (!$util.isString(message.optionExch))
                    return "optionExch: string expected";
            return null;
        };

        /**
         * Creates a PortfolioItem message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.PortfolioItem
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.PortfolioItem} PortfolioItem
         */
        PortfolioItem.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.PortfolioItem)
                return object;
            let message = new $root.stealth.PortfolioItem();
            if (object.index != null)
                message.index = object.index | 0;
            if (object.symbol != null)
                message.symbol = String(object.symbol);
            if (object.bias != null)
                message.bias = object.bias | 0;
            if (object.baseSize != null)
                if ($util.Long)
                    (message.baseSize = $util.Long.fromValue(object.baseSize)).unsigned = true;
                else if (typeof object.baseSize === "string")
                    message.baseSize = parseInt(object.baseSize, 10);
                else if (typeof object.baseSize === "number")
                    message.baseSize = object.baseSize;
                else if (typeof object.baseSize === "object")
                    message.baseSize = new $util.LongBits(object.baseSize.low >>> 0, object.baseSize.high >>> 0).toNumber(true);
            if (object.optionSize != null)
                if ($util.Long)
                    (message.optionSize = $util.Long.fromValue(object.optionSize)).unsigned = true;
                else if (typeof object.optionSize === "string")
                    message.optionSize = parseInt(object.optionSize, 10);
                else if (typeof object.optionSize === "number")
                    message.optionSize = object.optionSize;
                else if (typeof object.optionSize === "object")
                    message.optionSize = new $util.LongBits(object.optionSize.low >>> 0, object.optionSize.high >>> 0).toNumber(true);
            if (object.baseExch != null)
                message.baseExch = String(object.baseExch);
            if (object.optionExch != null)
                message.optionExch = String(object.optionExch);
            return message;
        };

        /**
         * Creates a plain object from a PortfolioItem message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.PortfolioItem
         * @static
         * @param {stealth.PortfolioItem} message PortfolioItem
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PortfolioItem.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.index = 0;
                object.symbol = "";
                object.bias = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.baseSize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.baseSize = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.optionSize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.optionSize = options.longs === String ? "0" : 0;
                object.baseExch = "";
                object.optionExch = "";
            }
            if (message.index != null && message.hasOwnProperty("index"))
                object.index = message.index;
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                object.symbol = message.symbol;
            if (message.bias != null && message.hasOwnProperty("bias"))
                object.bias = message.bias;
            if (message.baseSize != null && message.hasOwnProperty("baseSize"))
                if (typeof message.baseSize === "number")
                    object.baseSize = options.longs === String ? String(message.baseSize) : message.baseSize;
                else
                    object.baseSize = options.longs === String ? $util.Long.prototype.toString.call(message.baseSize) : options.longs === Number ? new $util.LongBits(message.baseSize.low >>> 0, message.baseSize.high >>> 0).toNumber(true) : message.baseSize;
            if (message.optionSize != null && message.hasOwnProperty("optionSize"))
                if (typeof message.optionSize === "number")
                    object.optionSize = options.longs === String ? String(message.optionSize) : message.optionSize;
                else
                    object.optionSize = options.longs === String ? $util.Long.prototype.toString.call(message.optionSize) : options.longs === Number ? new $util.LongBits(message.optionSize.low >>> 0, message.optionSize.high >>> 0).toNumber(true) : message.optionSize;
            if (message.baseExch != null && message.hasOwnProperty("baseExch"))
                object.baseExch = message.baseExch;
            if (message.optionExch != null && message.hasOwnProperty("optionExch"))
                object.optionExch = message.optionExch;
            return object;
        };

        /**
         * Converts this PortfolioItem to JSON.
         * @function toJSON
         * @memberof stealth.PortfolioItem
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PortfolioItem.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PortfolioItem
         * @function getTypeUrl
         * @memberof stealth.PortfolioItem
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PortfolioItem.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.PortfolioItem";
        };

        return PortfolioItem;
    })();

    stealth.OptionUpdate = (function() {

        /**
         * Properties of an OptionUpdate.
         * @memberof stealth
         * @interface IOptionUpdate
         * @property {string|null} [symbol] OptionUpdate symbol
         */

        /**
         * Constructs a new OptionUpdate.
         * @memberof stealth
         * @classdesc Represents an OptionUpdate.
         * @implements IOptionUpdate
         * @constructor
         * @param {stealth.IOptionUpdate=} [properties] Properties to set
         */
        function OptionUpdate(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OptionUpdate symbol.
         * @member {string} symbol
         * @memberof stealth.OptionUpdate
         * @instance
         */
        OptionUpdate.prototype.symbol = "";

        /**
         * Creates a new OptionUpdate instance using the specified properties.
         * @function create
         * @memberof stealth.OptionUpdate
         * @static
         * @param {stealth.IOptionUpdate=} [properties] Properties to set
         * @returns {stealth.OptionUpdate} OptionUpdate instance
         */
        OptionUpdate.create = function create(properties) {
            return new OptionUpdate(properties);
        };

        /**
         * Encodes the specified OptionUpdate message. Does not implicitly {@link stealth.OptionUpdate.verify|verify} messages.
         * @function encode
         * @memberof stealth.OptionUpdate
         * @static
         * @param {stealth.IOptionUpdate} message OptionUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OptionUpdate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.symbol);
            return writer;
        };

        /**
         * Encodes the specified OptionUpdate message, length delimited. Does not implicitly {@link stealth.OptionUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.OptionUpdate
         * @static
         * @param {stealth.IOptionUpdate} message OptionUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OptionUpdate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OptionUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.OptionUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.OptionUpdate} OptionUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OptionUpdate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.OptionUpdate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.symbol = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OptionUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.OptionUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.OptionUpdate} OptionUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OptionUpdate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OptionUpdate message.
         * @function verify
         * @memberof stealth.OptionUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OptionUpdate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                if (!$util.isString(message.symbol))
                    return "symbol: string expected";
            return null;
        };

        /**
         * Creates an OptionUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.OptionUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.OptionUpdate} OptionUpdate
         */
        OptionUpdate.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.OptionUpdate)
                return object;
            let message = new $root.stealth.OptionUpdate();
            if (object.symbol != null)
                message.symbol = String(object.symbol);
            return message;
        };

        /**
         * Creates a plain object from an OptionUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.OptionUpdate
         * @static
         * @param {stealth.OptionUpdate} message OptionUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OptionUpdate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.symbol = "";
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                object.symbol = message.symbol;
            return object;
        };

        /**
         * Converts this OptionUpdate to JSON.
         * @function toJSON
         * @memberof stealth.OptionUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OptionUpdate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for OptionUpdate
         * @function getTypeUrl
         * @memberof stealth.OptionUpdate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        OptionUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.OptionUpdate";
        };

        return OptionUpdate;
    })();

    stealth.PortfolioUpdate = (function() {

        /**
         * Properties of a PortfolioUpdate.
         * @memberof stealth
         * @interface IPortfolioUpdate
         * @property {string|null} [id] PortfolioUpdate id
         * @property {number|null} [watching] PortfolioUpdate watching
         * @property {Array.<stealth.IPortfolioItem>|null} [items] PortfolioUpdate items
         * @property {Array.<string>|null} [options] PortfolioUpdate options
         * @property {string|null} [error] PortfolioUpdate error
         */

        /**
         * Constructs a new PortfolioUpdate.
         * @memberof stealth
         * @classdesc Represents a PortfolioUpdate.
         * @implements IPortfolioUpdate
         * @constructor
         * @param {stealth.IPortfolioUpdate=} [properties] Properties to set
         */
        function PortfolioUpdate(properties) {
            this.items = [];
            this.options = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PortfolioUpdate id.
         * @member {string} id
         * @memberof stealth.PortfolioUpdate
         * @instance
         */
        PortfolioUpdate.prototype.id = "";

        /**
         * PortfolioUpdate watching.
         * @member {number} watching
         * @memberof stealth.PortfolioUpdate
         * @instance
         */
        PortfolioUpdate.prototype.watching = 0;

        /**
         * PortfolioUpdate items.
         * @member {Array.<stealth.IPortfolioItem>} items
         * @memberof stealth.PortfolioUpdate
         * @instance
         */
        PortfolioUpdate.prototype.items = $util.emptyArray;

        /**
         * PortfolioUpdate options.
         * @member {Array.<string>} options
         * @memberof stealth.PortfolioUpdate
         * @instance
         */
        PortfolioUpdate.prototype.options = $util.emptyArray;

        /**
         * PortfolioUpdate error.
         * @member {string} error
         * @memberof stealth.PortfolioUpdate
         * @instance
         */
        PortfolioUpdate.prototype.error = "";

        /**
         * Creates a new PortfolioUpdate instance using the specified properties.
         * @function create
         * @memberof stealth.PortfolioUpdate
         * @static
         * @param {stealth.IPortfolioUpdate=} [properties] Properties to set
         * @returns {stealth.PortfolioUpdate} PortfolioUpdate instance
         */
        PortfolioUpdate.create = function create(properties) {
            return new PortfolioUpdate(properties);
        };

        /**
         * Encodes the specified PortfolioUpdate message. Does not implicitly {@link stealth.PortfolioUpdate.verify|verify} messages.
         * @function encode
         * @memberof stealth.PortfolioUpdate
         * @static
         * @param {stealth.IPortfolioUpdate} message PortfolioUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PortfolioUpdate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.watching != null && Object.hasOwnProperty.call(message, "watching"))
                writer.uint32(/* id 2, wireType 0 =*/16).sint32(message.watching);
            if (message.items != null && message.items.length)
                for (let i = 0; i < message.items.length; ++i)
                    $root.stealth.PortfolioItem.encode(message.items[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.options != null && message.options.length)
                for (let i = 0; i < message.options.length; ++i)
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.options[i]);
            if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.error);
            return writer;
        };

        /**
         * Encodes the specified PortfolioUpdate message, length delimited. Does not implicitly {@link stealth.PortfolioUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.PortfolioUpdate
         * @static
         * @param {stealth.IPortfolioUpdate} message PortfolioUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PortfolioUpdate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PortfolioUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.PortfolioUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.PortfolioUpdate} PortfolioUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PortfolioUpdate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.PortfolioUpdate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        message.watching = reader.sint32();
                        break;
                    }
                case 3: {
                        if (!(message.items && message.items.length))
                            message.items = [];
                        message.items.push($root.stealth.PortfolioItem.decode(reader, reader.uint32()));
                        break;
                    }
                case 4: {
                        if (!(message.options && message.options.length))
                            message.options = [];
                        message.options.push(reader.string());
                        break;
                    }
                case 5: {
                        message.error = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PortfolioUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.PortfolioUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.PortfolioUpdate} PortfolioUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PortfolioUpdate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PortfolioUpdate message.
         * @function verify
         * @memberof stealth.PortfolioUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PortfolioUpdate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.watching != null && message.hasOwnProperty("watching"))
                if (!$util.isInteger(message.watching))
                    return "watching: integer expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (let i = 0; i < message.items.length; ++i) {
                    let error = $root.stealth.PortfolioItem.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            if (message.options != null && message.hasOwnProperty("options")) {
                if (!Array.isArray(message.options))
                    return "options: array expected";
                for (let i = 0; i < message.options.length; ++i)
                    if (!$util.isString(message.options[i]))
                        return "options: string[] expected";
            }
            if (message.error != null && message.hasOwnProperty("error"))
                if (!$util.isString(message.error))
                    return "error: string expected";
            return null;
        };

        /**
         * Creates a PortfolioUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.PortfolioUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.PortfolioUpdate} PortfolioUpdate
         */
        PortfolioUpdate.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.PortfolioUpdate)
                return object;
            let message = new $root.stealth.PortfolioUpdate();
            if (object.id != null)
                message.id = String(object.id);
            if (object.watching != null)
                message.watching = object.watching | 0;
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".stealth.PortfolioUpdate.items: array expected");
                message.items = [];
                for (let i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".stealth.PortfolioUpdate.items: object expected");
                    message.items[i] = $root.stealth.PortfolioItem.fromObject(object.items[i]);
                }
            }
            if (object.options) {
                if (!Array.isArray(object.options))
                    throw TypeError(".stealth.PortfolioUpdate.options: array expected");
                message.options = [];
                for (let i = 0; i < object.options.length; ++i)
                    message.options[i] = String(object.options[i]);
            }
            if (object.error != null)
                message.error = String(object.error);
            return message;
        };

        /**
         * Creates a plain object from a PortfolioUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.PortfolioUpdate
         * @static
         * @param {stealth.PortfolioUpdate} message PortfolioUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PortfolioUpdate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.items = [];
                object.options = [];
            }
            if (options.defaults) {
                object.id = "";
                object.watching = 0;
                object.error = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.watching != null && message.hasOwnProperty("watching"))
                object.watching = message.watching;
            if (message.items && message.items.length) {
                object.items = [];
                for (let j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.stealth.PortfolioItem.toObject(message.items[j], options);
            }
            if (message.options && message.options.length) {
                object.options = [];
                for (let j = 0; j < message.options.length; ++j)
                    object.options[j] = message.options[j];
            }
            if (message.error != null && message.hasOwnProperty("error"))
                object.error = message.error;
            return object;
        };

        /**
         * Converts this PortfolioUpdate to JSON.
         * @function toJSON
         * @memberof stealth.PortfolioUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PortfolioUpdate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PortfolioUpdate
         * @function getTypeUrl
         * @memberof stealth.PortfolioUpdate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PortfolioUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.PortfolioUpdate";
        };

        return PortfolioUpdate;
    })();

    stealth.SingleDefinitionUpdate = (function() {

        /**
         * Properties of a SingleDefinitionUpdate.
         * @memberof stealth
         * @interface ISingleDefinitionUpdate
         * @property {string|null} [definition] SingleDefinitionUpdate definition
         */

        /**
         * Constructs a new SingleDefinitionUpdate.
         * @memberof stealth
         * @classdesc Represents a SingleDefinitionUpdate.
         * @implements ISingleDefinitionUpdate
         * @constructor
         * @param {stealth.ISingleDefinitionUpdate=} [properties] Properties to set
         */
        function SingleDefinitionUpdate(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SingleDefinitionUpdate definition.
         * @member {string} definition
         * @memberof stealth.SingleDefinitionUpdate
         * @instance
         */
        SingleDefinitionUpdate.prototype.definition = "";

        /**
         * Creates a new SingleDefinitionUpdate instance using the specified properties.
         * @function create
         * @memberof stealth.SingleDefinitionUpdate
         * @static
         * @param {stealth.ISingleDefinitionUpdate=} [properties] Properties to set
         * @returns {stealth.SingleDefinitionUpdate} SingleDefinitionUpdate instance
         */
        SingleDefinitionUpdate.create = function create(properties) {
            return new SingleDefinitionUpdate(properties);
        };

        /**
         * Encodes the specified SingleDefinitionUpdate message. Does not implicitly {@link stealth.SingleDefinitionUpdate.verify|verify} messages.
         * @function encode
         * @memberof stealth.SingleDefinitionUpdate
         * @static
         * @param {stealth.ISingleDefinitionUpdate} message SingleDefinitionUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SingleDefinitionUpdate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.definition != null && Object.hasOwnProperty.call(message, "definition"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.definition);
            return writer;
        };

        /**
         * Encodes the specified SingleDefinitionUpdate message, length delimited. Does not implicitly {@link stealth.SingleDefinitionUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.SingleDefinitionUpdate
         * @static
         * @param {stealth.ISingleDefinitionUpdate} message SingleDefinitionUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SingleDefinitionUpdate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SingleDefinitionUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.SingleDefinitionUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.SingleDefinitionUpdate} SingleDefinitionUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SingleDefinitionUpdate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.SingleDefinitionUpdate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.definition = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SingleDefinitionUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.SingleDefinitionUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.SingleDefinitionUpdate} SingleDefinitionUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SingleDefinitionUpdate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SingleDefinitionUpdate message.
         * @function verify
         * @memberof stealth.SingleDefinitionUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SingleDefinitionUpdate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.definition != null && message.hasOwnProperty("definition"))
                if (!$util.isString(message.definition))
                    return "definition: string expected";
            return null;
        };

        /**
         * Creates a SingleDefinitionUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.SingleDefinitionUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.SingleDefinitionUpdate} SingleDefinitionUpdate
         */
        SingleDefinitionUpdate.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.SingleDefinitionUpdate)
                return object;
            let message = new $root.stealth.SingleDefinitionUpdate();
            if (object.definition != null)
                message.definition = String(object.definition);
            return message;
        };

        /**
         * Creates a plain object from a SingleDefinitionUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.SingleDefinitionUpdate
         * @static
         * @param {stealth.SingleDefinitionUpdate} message SingleDefinitionUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SingleDefinitionUpdate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.definition = "";
            if (message.definition != null && message.hasOwnProperty("definition"))
                object.definition = message.definition;
            return object;
        };

        /**
         * Converts this SingleDefinitionUpdate to JSON.
         * @function toJSON
         * @memberof stealth.SingleDefinitionUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SingleDefinitionUpdate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SingleDefinitionUpdate
         * @function getTypeUrl
         * @memberof stealth.SingleDefinitionUpdate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SingleDefinitionUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.SingleDefinitionUpdate";
        };

        return SingleDefinitionUpdate;
    })();

    stealth.PlaybackStreamUpdate = (function() {

        /**
         * Properties of a PlaybackStreamUpdate.
         * @memberof stealth
         * @interface IPlaybackStreamUpdate
         * @property {string|null} [streamId] PlaybackStreamUpdate streamId
         * @property {string|null} [packageId] PlaybackStreamUpdate packageId
         * @property {Array.<stealth.IPlaybackSymbol>|null} [symbols] PlaybackStreamUpdate symbols
         */

        /**
         * Constructs a new PlaybackStreamUpdate.
         * @memberof stealth
         * @classdesc Represents a PlaybackStreamUpdate.
         * @implements IPlaybackStreamUpdate
         * @constructor
         * @param {stealth.IPlaybackStreamUpdate=} [properties] Properties to set
         */
        function PlaybackStreamUpdate(properties) {
            this.symbols = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PlaybackStreamUpdate streamId.
         * @member {string} streamId
         * @memberof stealth.PlaybackStreamUpdate
         * @instance
         */
        PlaybackStreamUpdate.prototype.streamId = "";

        /**
         * PlaybackStreamUpdate packageId.
         * @member {string} packageId
         * @memberof stealth.PlaybackStreamUpdate
         * @instance
         */
        PlaybackStreamUpdate.prototype.packageId = "";

        /**
         * PlaybackStreamUpdate symbols.
         * @member {Array.<stealth.IPlaybackSymbol>} symbols
         * @memberof stealth.PlaybackStreamUpdate
         * @instance
         */
        PlaybackStreamUpdate.prototype.symbols = $util.emptyArray;

        /**
         * Creates a new PlaybackStreamUpdate instance using the specified properties.
         * @function create
         * @memberof stealth.PlaybackStreamUpdate
         * @static
         * @param {stealth.IPlaybackStreamUpdate=} [properties] Properties to set
         * @returns {stealth.PlaybackStreamUpdate} PlaybackStreamUpdate instance
         */
        PlaybackStreamUpdate.create = function create(properties) {
            return new PlaybackStreamUpdate(properties);
        };

        /**
         * Encodes the specified PlaybackStreamUpdate message. Does not implicitly {@link stealth.PlaybackStreamUpdate.verify|verify} messages.
         * @function encode
         * @memberof stealth.PlaybackStreamUpdate
         * @static
         * @param {stealth.IPlaybackStreamUpdate} message PlaybackStreamUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PlaybackStreamUpdate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.streamId != null && Object.hasOwnProperty.call(message, "streamId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.streamId);
            if (message.packageId != null && Object.hasOwnProperty.call(message, "packageId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.packageId);
            if (message.symbols != null && message.symbols.length)
                for (let i = 0; i < message.symbols.length; ++i)
                    $root.stealth.PlaybackSymbol.encode(message.symbols[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified PlaybackStreamUpdate message, length delimited. Does not implicitly {@link stealth.PlaybackStreamUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.PlaybackStreamUpdate
         * @static
         * @param {stealth.IPlaybackStreamUpdate} message PlaybackStreamUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PlaybackStreamUpdate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PlaybackStreamUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.PlaybackStreamUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.PlaybackStreamUpdate} PlaybackStreamUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PlaybackStreamUpdate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.PlaybackStreamUpdate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.streamId = reader.string();
                        break;
                    }
                case 2: {
                        message.packageId = reader.string();
                        break;
                    }
                case 3: {
                        if (!(message.symbols && message.symbols.length))
                            message.symbols = [];
                        message.symbols.push($root.stealth.PlaybackSymbol.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PlaybackStreamUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.PlaybackStreamUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.PlaybackStreamUpdate} PlaybackStreamUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PlaybackStreamUpdate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PlaybackStreamUpdate message.
         * @function verify
         * @memberof stealth.PlaybackStreamUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PlaybackStreamUpdate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.streamId != null && message.hasOwnProperty("streamId"))
                if (!$util.isString(message.streamId))
                    return "streamId: string expected";
            if (message.packageId != null && message.hasOwnProperty("packageId"))
                if (!$util.isString(message.packageId))
                    return "packageId: string expected";
            if (message.symbols != null && message.hasOwnProperty("symbols")) {
                if (!Array.isArray(message.symbols))
                    return "symbols: array expected";
                for (let i = 0; i < message.symbols.length; ++i) {
                    let error = $root.stealth.PlaybackSymbol.verify(message.symbols[i]);
                    if (error)
                        return "symbols." + error;
                }
            }
            return null;
        };

        /**
         * Creates a PlaybackStreamUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.PlaybackStreamUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.PlaybackStreamUpdate} PlaybackStreamUpdate
         */
        PlaybackStreamUpdate.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.PlaybackStreamUpdate)
                return object;
            let message = new $root.stealth.PlaybackStreamUpdate();
            if (object.streamId != null)
                message.streamId = String(object.streamId);
            if (object.packageId != null)
                message.packageId = String(object.packageId);
            if (object.symbols) {
                if (!Array.isArray(object.symbols))
                    throw TypeError(".stealth.PlaybackStreamUpdate.symbols: array expected");
                message.symbols = [];
                for (let i = 0; i < object.symbols.length; ++i) {
                    if (typeof object.symbols[i] !== "object")
                        throw TypeError(".stealth.PlaybackStreamUpdate.symbols: object expected");
                    message.symbols[i] = $root.stealth.PlaybackSymbol.fromObject(object.symbols[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a PlaybackStreamUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.PlaybackStreamUpdate
         * @static
         * @param {stealth.PlaybackStreamUpdate} message PlaybackStreamUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PlaybackStreamUpdate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.symbols = [];
            if (options.defaults) {
                object.streamId = "";
                object.packageId = "";
            }
            if (message.streamId != null && message.hasOwnProperty("streamId"))
                object.streamId = message.streamId;
            if (message.packageId != null && message.hasOwnProperty("packageId"))
                object.packageId = message.packageId;
            if (message.symbols && message.symbols.length) {
                object.symbols = [];
                for (let j = 0; j < message.symbols.length; ++j)
                    object.symbols[j] = $root.stealth.PlaybackSymbol.toObject(message.symbols[j], options);
            }
            return object;
        };

        /**
         * Converts this PlaybackStreamUpdate to JSON.
         * @function toJSON
         * @memberof stealth.PlaybackStreamUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PlaybackStreamUpdate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PlaybackStreamUpdate
         * @function getTypeUrl
         * @memberof stealth.PlaybackStreamUpdate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PlaybackStreamUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.PlaybackStreamUpdate";
        };

        return PlaybackStreamUpdate;
    })();

    stealth.PlaybackSymbol = (function() {

        /**
         * Properties of a PlaybackSymbol.
         * @memberof stealth
         * @interface IPlaybackSymbol
         * @property {string|null} [symbol] PlaybackSymbol symbol
         * @property {string|null} [definition] PlaybackSymbol definition
         */

        /**
         * Constructs a new PlaybackSymbol.
         * @memberof stealth
         * @classdesc Represents a PlaybackSymbol.
         * @implements IPlaybackSymbol
         * @constructor
         * @param {stealth.IPlaybackSymbol=} [properties] Properties to set
         */
        function PlaybackSymbol(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PlaybackSymbol symbol.
         * @member {string} symbol
         * @memberof stealth.PlaybackSymbol
         * @instance
         */
        PlaybackSymbol.prototype.symbol = "";

        /**
         * PlaybackSymbol definition.
         * @member {string} definition
         * @memberof stealth.PlaybackSymbol
         * @instance
         */
        PlaybackSymbol.prototype.definition = "";

        /**
         * Creates a new PlaybackSymbol instance using the specified properties.
         * @function create
         * @memberof stealth.PlaybackSymbol
         * @static
         * @param {stealth.IPlaybackSymbol=} [properties] Properties to set
         * @returns {stealth.PlaybackSymbol} PlaybackSymbol instance
         */
        PlaybackSymbol.create = function create(properties) {
            return new PlaybackSymbol(properties);
        };

        /**
         * Encodes the specified PlaybackSymbol message. Does not implicitly {@link stealth.PlaybackSymbol.verify|verify} messages.
         * @function encode
         * @memberof stealth.PlaybackSymbol
         * @static
         * @param {stealth.IPlaybackSymbol} message PlaybackSymbol message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PlaybackSymbol.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.symbol);
            if (message.definition != null && Object.hasOwnProperty.call(message, "definition"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.definition);
            return writer;
        };

        /**
         * Encodes the specified PlaybackSymbol message, length delimited. Does not implicitly {@link stealth.PlaybackSymbol.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.PlaybackSymbol
         * @static
         * @param {stealth.IPlaybackSymbol} message PlaybackSymbol message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PlaybackSymbol.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PlaybackSymbol message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.PlaybackSymbol
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.PlaybackSymbol} PlaybackSymbol
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PlaybackSymbol.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.PlaybackSymbol();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.symbol = reader.string();
                        break;
                    }
                case 2: {
                        message.definition = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PlaybackSymbol message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.PlaybackSymbol
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.PlaybackSymbol} PlaybackSymbol
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PlaybackSymbol.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PlaybackSymbol message.
         * @function verify
         * @memberof stealth.PlaybackSymbol
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PlaybackSymbol.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                if (!$util.isString(message.symbol))
                    return "symbol: string expected";
            if (message.definition != null && message.hasOwnProperty("definition"))
                if (!$util.isString(message.definition))
                    return "definition: string expected";
            return null;
        };

        /**
         * Creates a PlaybackSymbol message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.PlaybackSymbol
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.PlaybackSymbol} PlaybackSymbol
         */
        PlaybackSymbol.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.PlaybackSymbol)
                return object;
            let message = new $root.stealth.PlaybackSymbol();
            if (object.symbol != null)
                message.symbol = String(object.symbol);
            if (object.definition != null)
                message.definition = String(object.definition);
            return message;
        };

        /**
         * Creates a plain object from a PlaybackSymbol message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.PlaybackSymbol
         * @static
         * @param {stealth.PlaybackSymbol} message PlaybackSymbol
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PlaybackSymbol.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.symbol = "";
                object.definition = "";
            }
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                object.symbol = message.symbol;
            if (message.definition != null && message.hasOwnProperty("definition"))
                object.definition = message.definition;
            return object;
        };

        /**
         * Converts this PlaybackSymbol to JSON.
         * @function toJSON
         * @memberof stealth.PlaybackSymbol
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PlaybackSymbol.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PlaybackSymbol
         * @function getTypeUrl
         * @memberof stealth.PlaybackSymbol
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PlaybackSymbol.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.PlaybackSymbol";
        };

        return PlaybackSymbol;
    })();

    stealth.PlaybackPackageDefinition = (function() {

        /**
         * Properties of a PlaybackPackageDefinition.
         * @memberof stealth
         * @interface IPlaybackPackageDefinition
         * @property {string|null} [id] PlaybackPackageDefinition id
         * @property {string|null} [title] PlaybackPackageDefinition title
         * @property {string|null} [description] PlaybackPackageDefinition description
         * @property {string|null} [start] PlaybackPackageDefinition start
         * @property {string|null} [end] PlaybackPackageDefinition end
         * @property {Array.<stealth.IPlaybackSymbol>|null} [symbols] PlaybackPackageDefinition symbols
         */

        /**
         * Constructs a new PlaybackPackageDefinition.
         * @memberof stealth
         * @classdesc Represents a PlaybackPackageDefinition.
         * @implements IPlaybackPackageDefinition
         * @constructor
         * @param {stealth.IPlaybackPackageDefinition=} [properties] Properties to set
         */
        function PlaybackPackageDefinition(properties) {
            this.symbols = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PlaybackPackageDefinition id.
         * @member {string} id
         * @memberof stealth.PlaybackPackageDefinition
         * @instance
         */
        PlaybackPackageDefinition.prototype.id = "";

        /**
         * PlaybackPackageDefinition title.
         * @member {string} title
         * @memberof stealth.PlaybackPackageDefinition
         * @instance
         */
        PlaybackPackageDefinition.prototype.title = "";

        /**
         * PlaybackPackageDefinition description.
         * @member {string} description
         * @memberof stealth.PlaybackPackageDefinition
         * @instance
         */
        PlaybackPackageDefinition.prototype.description = "";

        /**
         * PlaybackPackageDefinition start.
         * @member {string} start
         * @memberof stealth.PlaybackPackageDefinition
         * @instance
         */
        PlaybackPackageDefinition.prototype.start = "";

        /**
         * PlaybackPackageDefinition end.
         * @member {string} end
         * @memberof stealth.PlaybackPackageDefinition
         * @instance
         */
        PlaybackPackageDefinition.prototype.end = "";

        /**
         * PlaybackPackageDefinition symbols.
         * @member {Array.<stealth.IPlaybackSymbol>} symbols
         * @memberof stealth.PlaybackPackageDefinition
         * @instance
         */
        PlaybackPackageDefinition.prototype.symbols = $util.emptyArray;

        /**
         * Creates a new PlaybackPackageDefinition instance using the specified properties.
         * @function create
         * @memberof stealth.PlaybackPackageDefinition
         * @static
         * @param {stealth.IPlaybackPackageDefinition=} [properties] Properties to set
         * @returns {stealth.PlaybackPackageDefinition} PlaybackPackageDefinition instance
         */
        PlaybackPackageDefinition.create = function create(properties) {
            return new PlaybackPackageDefinition(properties);
        };

        /**
         * Encodes the specified PlaybackPackageDefinition message. Does not implicitly {@link stealth.PlaybackPackageDefinition.verify|verify} messages.
         * @function encode
         * @memberof stealth.PlaybackPackageDefinition
         * @static
         * @param {stealth.IPlaybackPackageDefinition} message PlaybackPackageDefinition message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PlaybackPackageDefinition.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.title);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
            if (message.start != null && Object.hasOwnProperty.call(message, "start"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.start);
            if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.end);
            if (message.symbols != null && message.symbols.length)
                for (let i = 0; i < message.symbols.length; ++i)
                    $root.stealth.PlaybackSymbol.encode(message.symbols[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified PlaybackPackageDefinition message, length delimited. Does not implicitly {@link stealth.PlaybackPackageDefinition.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.PlaybackPackageDefinition
         * @static
         * @param {stealth.IPlaybackPackageDefinition} message PlaybackPackageDefinition message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PlaybackPackageDefinition.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PlaybackPackageDefinition message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.PlaybackPackageDefinition
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.PlaybackPackageDefinition} PlaybackPackageDefinition
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PlaybackPackageDefinition.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.PlaybackPackageDefinition();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        message.title = reader.string();
                        break;
                    }
                case 3: {
                        message.description = reader.string();
                        break;
                    }
                case 4: {
                        message.start = reader.string();
                        break;
                    }
                case 5: {
                        message.end = reader.string();
                        break;
                    }
                case 6: {
                        if (!(message.symbols && message.symbols.length))
                            message.symbols = [];
                        message.symbols.push($root.stealth.PlaybackSymbol.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PlaybackPackageDefinition message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.PlaybackPackageDefinition
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.PlaybackPackageDefinition} PlaybackPackageDefinition
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PlaybackPackageDefinition.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PlaybackPackageDefinition message.
         * @function verify
         * @memberof stealth.PlaybackPackageDefinition
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PlaybackPackageDefinition.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.start != null && message.hasOwnProperty("start"))
                if (!$util.isString(message.start))
                    return "start: string expected";
            if (message.end != null && message.hasOwnProperty("end"))
                if (!$util.isString(message.end))
                    return "end: string expected";
            if (message.symbols != null && message.hasOwnProperty("symbols")) {
                if (!Array.isArray(message.symbols))
                    return "symbols: array expected";
                for (let i = 0; i < message.symbols.length; ++i) {
                    let error = $root.stealth.PlaybackSymbol.verify(message.symbols[i]);
                    if (error)
                        return "symbols." + error;
                }
            }
            return null;
        };

        /**
         * Creates a PlaybackPackageDefinition message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.PlaybackPackageDefinition
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.PlaybackPackageDefinition} PlaybackPackageDefinition
         */
        PlaybackPackageDefinition.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.PlaybackPackageDefinition)
                return object;
            let message = new $root.stealth.PlaybackPackageDefinition();
            if (object.id != null)
                message.id = String(object.id);
            if (object.title != null)
                message.title = String(object.title);
            if (object.description != null)
                message.description = String(object.description);
            if (object.start != null)
                message.start = String(object.start);
            if (object.end != null)
                message.end = String(object.end);
            if (object.symbols) {
                if (!Array.isArray(object.symbols))
                    throw TypeError(".stealth.PlaybackPackageDefinition.symbols: array expected");
                message.symbols = [];
                for (let i = 0; i < object.symbols.length; ++i) {
                    if (typeof object.symbols[i] !== "object")
                        throw TypeError(".stealth.PlaybackPackageDefinition.symbols: object expected");
                    message.symbols[i] = $root.stealth.PlaybackSymbol.fromObject(object.symbols[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a PlaybackPackageDefinition message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.PlaybackPackageDefinition
         * @static
         * @param {stealth.PlaybackPackageDefinition} message PlaybackPackageDefinition
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PlaybackPackageDefinition.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.symbols = [];
            if (options.defaults) {
                object.id = "";
                object.title = "";
                object.description = "";
                object.start = "";
                object.end = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.start != null && message.hasOwnProperty("start"))
                object.start = message.start;
            if (message.end != null && message.hasOwnProperty("end"))
                object.end = message.end;
            if (message.symbols && message.symbols.length) {
                object.symbols = [];
                for (let j = 0; j < message.symbols.length; ++j)
                    object.symbols[j] = $root.stealth.PlaybackSymbol.toObject(message.symbols[j], options);
            }
            return object;
        };

        /**
         * Converts this PlaybackPackageDefinition to JSON.
         * @function toJSON
         * @memberof stealth.PlaybackPackageDefinition
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PlaybackPackageDefinition.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PlaybackPackageDefinition
         * @function getTypeUrl
         * @memberof stealth.PlaybackPackageDefinition
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PlaybackPackageDefinition.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.PlaybackPackageDefinition";
        };

        return PlaybackPackageDefinition;
    })();

    stealth.PlaybackPackageListUpdate = (function() {

        /**
         * Properties of a PlaybackPackageListUpdate.
         * @memberof stealth
         * @interface IPlaybackPackageListUpdate
         * @property {Array.<stealth.IPlaybackPackageDefinition>|null} [packages] PlaybackPackageListUpdate packages
         */

        /**
         * Constructs a new PlaybackPackageListUpdate.
         * @memberof stealth
         * @classdesc Represents a PlaybackPackageListUpdate.
         * @implements IPlaybackPackageListUpdate
         * @constructor
         * @param {stealth.IPlaybackPackageListUpdate=} [properties] Properties to set
         */
        function PlaybackPackageListUpdate(properties) {
            this.packages = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PlaybackPackageListUpdate packages.
         * @member {Array.<stealth.IPlaybackPackageDefinition>} packages
         * @memberof stealth.PlaybackPackageListUpdate
         * @instance
         */
        PlaybackPackageListUpdate.prototype.packages = $util.emptyArray;

        /**
         * Creates a new PlaybackPackageListUpdate instance using the specified properties.
         * @function create
         * @memberof stealth.PlaybackPackageListUpdate
         * @static
         * @param {stealth.IPlaybackPackageListUpdate=} [properties] Properties to set
         * @returns {stealth.PlaybackPackageListUpdate} PlaybackPackageListUpdate instance
         */
        PlaybackPackageListUpdate.create = function create(properties) {
            return new PlaybackPackageListUpdate(properties);
        };

        /**
         * Encodes the specified PlaybackPackageListUpdate message. Does not implicitly {@link stealth.PlaybackPackageListUpdate.verify|verify} messages.
         * @function encode
         * @memberof stealth.PlaybackPackageListUpdate
         * @static
         * @param {stealth.IPlaybackPackageListUpdate} message PlaybackPackageListUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PlaybackPackageListUpdate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.packages != null && message.packages.length)
                for (let i = 0; i < message.packages.length; ++i)
                    $root.stealth.PlaybackPackageDefinition.encode(message.packages[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified PlaybackPackageListUpdate message, length delimited. Does not implicitly {@link stealth.PlaybackPackageListUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.PlaybackPackageListUpdate
         * @static
         * @param {stealth.IPlaybackPackageListUpdate} message PlaybackPackageListUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PlaybackPackageListUpdate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PlaybackPackageListUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.PlaybackPackageListUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.PlaybackPackageListUpdate} PlaybackPackageListUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PlaybackPackageListUpdate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.PlaybackPackageListUpdate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.packages && message.packages.length))
                            message.packages = [];
                        message.packages.push($root.stealth.PlaybackPackageDefinition.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PlaybackPackageListUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.PlaybackPackageListUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.PlaybackPackageListUpdate} PlaybackPackageListUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PlaybackPackageListUpdate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PlaybackPackageListUpdate message.
         * @function verify
         * @memberof stealth.PlaybackPackageListUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PlaybackPackageListUpdate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.packages != null && message.hasOwnProperty("packages")) {
                if (!Array.isArray(message.packages))
                    return "packages: array expected";
                for (let i = 0; i < message.packages.length; ++i) {
                    let error = $root.stealth.PlaybackPackageDefinition.verify(message.packages[i]);
                    if (error)
                        return "packages." + error;
                }
            }
            return null;
        };

        /**
         * Creates a PlaybackPackageListUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.PlaybackPackageListUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.PlaybackPackageListUpdate} PlaybackPackageListUpdate
         */
        PlaybackPackageListUpdate.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.PlaybackPackageListUpdate)
                return object;
            let message = new $root.stealth.PlaybackPackageListUpdate();
            if (object.packages) {
                if (!Array.isArray(object.packages))
                    throw TypeError(".stealth.PlaybackPackageListUpdate.packages: array expected");
                message.packages = [];
                for (let i = 0; i < object.packages.length; ++i) {
                    if (typeof object.packages[i] !== "object")
                        throw TypeError(".stealth.PlaybackPackageListUpdate.packages: object expected");
                    message.packages[i] = $root.stealth.PlaybackPackageDefinition.fromObject(object.packages[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a PlaybackPackageListUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.PlaybackPackageListUpdate
         * @static
         * @param {stealth.PlaybackPackageListUpdate} message PlaybackPackageListUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PlaybackPackageListUpdate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.packages = [];
            if (message.packages && message.packages.length) {
                object.packages = [];
                for (let j = 0; j < message.packages.length; ++j)
                    object.packages[j] = $root.stealth.PlaybackPackageDefinition.toObject(message.packages[j], options);
            }
            return object;
        };

        /**
         * Converts this PlaybackPackageListUpdate to JSON.
         * @function toJSON
         * @memberof stealth.PlaybackPackageListUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PlaybackPackageListUpdate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PlaybackPackageListUpdate
         * @function getTypeUrl
         * @memberof stealth.PlaybackPackageListUpdate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PlaybackPackageListUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.PlaybackPackageListUpdate";
        };

        return PlaybackPackageListUpdate;
    })();

    stealth.EconomicEventDetails = (function() {

        /**
         * Properties of an EconomicEventDetails.
         * @memberof stealth
         * @interface IEconomicEventDetails
         * @property {string|null} [eventId] EconomicEventDetails eventId
         * @property {number|Long|null} [timestamp] EconomicEventDetails timestamp
         * @property {string|null} [name] EconomicEventDetails name
         * @property {string|null} [country] EconomicEventDetails country
         * @property {stealth.EconomicEventDetails.Volatility|null} [volatility] EconomicEventDetails volatility
         * @property {string|null} [Actual] EconomicEventDetails Actual
         * @property {string|null} [Previous] EconomicEventDetails Previous
         * @property {string|null} [Consensus] EconomicEventDetails Consensus
         */

        /**
         * Constructs a new EconomicEventDetails.
         * @memberof stealth
         * @classdesc Represents an EconomicEventDetails.
         * @implements IEconomicEventDetails
         * @constructor
         * @param {stealth.IEconomicEventDetails=} [properties] Properties to set
         */
        function EconomicEventDetails(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EconomicEventDetails eventId.
         * @member {string} eventId
         * @memberof stealth.EconomicEventDetails
         * @instance
         */
        EconomicEventDetails.prototype.eventId = "";

        /**
         * EconomicEventDetails timestamp.
         * @member {number|Long} timestamp
         * @memberof stealth.EconomicEventDetails
         * @instance
         */
        EconomicEventDetails.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * EconomicEventDetails name.
         * @member {string} name
         * @memberof stealth.EconomicEventDetails
         * @instance
         */
        EconomicEventDetails.prototype.name = "";

        /**
         * EconomicEventDetails country.
         * @member {string} country
         * @memberof stealth.EconomicEventDetails
         * @instance
         */
        EconomicEventDetails.prototype.country = "";

        /**
         * EconomicEventDetails volatility.
         * @member {stealth.EconomicEventDetails.Volatility} volatility
         * @memberof stealth.EconomicEventDetails
         * @instance
         */
        EconomicEventDetails.prototype.volatility = 0;

        /**
         * EconomicEventDetails Actual.
         * @member {string} Actual
         * @memberof stealth.EconomicEventDetails
         * @instance
         */
        EconomicEventDetails.prototype.Actual = "";

        /**
         * EconomicEventDetails Previous.
         * @member {string} Previous
         * @memberof stealth.EconomicEventDetails
         * @instance
         */
        EconomicEventDetails.prototype.Previous = "";

        /**
         * EconomicEventDetails Consensus.
         * @member {string} Consensus
         * @memberof stealth.EconomicEventDetails
         * @instance
         */
        EconomicEventDetails.prototype.Consensus = "";

        /**
         * Creates a new EconomicEventDetails instance using the specified properties.
         * @function create
         * @memberof stealth.EconomicEventDetails
         * @static
         * @param {stealth.IEconomicEventDetails=} [properties] Properties to set
         * @returns {stealth.EconomicEventDetails} EconomicEventDetails instance
         */
        EconomicEventDetails.create = function create(properties) {
            return new EconomicEventDetails(properties);
        };

        /**
         * Encodes the specified EconomicEventDetails message. Does not implicitly {@link stealth.EconomicEventDetails.verify|verify} messages.
         * @function encode
         * @memberof stealth.EconomicEventDetails
         * @static
         * @param {stealth.IEconomicEventDetails} message EconomicEventDetails message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EconomicEventDetails.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.eventId != null && Object.hasOwnProperty.call(message, "eventId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.eventId);
            if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.timestamp);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
            if (message.country != null && Object.hasOwnProperty.call(message, "country"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.country);
            if (message.volatility != null && Object.hasOwnProperty.call(message, "volatility"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.volatility);
            if (message.Actual != null && Object.hasOwnProperty.call(message, "Actual"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.Actual);
            if (message.Previous != null && Object.hasOwnProperty.call(message, "Previous"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.Previous);
            if (message.Consensus != null && Object.hasOwnProperty.call(message, "Consensus"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.Consensus);
            return writer;
        };

        /**
         * Encodes the specified EconomicEventDetails message, length delimited. Does not implicitly {@link stealth.EconomicEventDetails.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.EconomicEventDetails
         * @static
         * @param {stealth.IEconomicEventDetails} message EconomicEventDetails message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EconomicEventDetails.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EconomicEventDetails message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.EconomicEventDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.EconomicEventDetails} EconomicEventDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EconomicEventDetails.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.EconomicEventDetails();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.eventId = reader.string();
                        break;
                    }
                case 2: {
                        message.timestamp = reader.uint64();
                        break;
                    }
                case 3: {
                        message.name = reader.string();
                        break;
                    }
                case 4: {
                        message.country = reader.string();
                        break;
                    }
                case 5: {
                        message.volatility = reader.int32();
                        break;
                    }
                case 6: {
                        message.Actual = reader.string();
                        break;
                    }
                case 7: {
                        message.Previous = reader.string();
                        break;
                    }
                case 8: {
                        message.Consensus = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EconomicEventDetails message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.EconomicEventDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.EconomicEventDetails} EconomicEventDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EconomicEventDetails.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EconomicEventDetails message.
         * @function verify
         * @memberof stealth.EconomicEventDetails
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EconomicEventDetails.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.eventId != null && message.hasOwnProperty("eventId"))
                if (!$util.isString(message.eventId))
                    return "eventId: string expected";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                    return "timestamp: integer|Long expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.country != null && message.hasOwnProperty("country"))
                if (!$util.isString(message.country))
                    return "country: string expected";
            if (message.volatility != null && message.hasOwnProperty("volatility"))
                switch (message.volatility) {
                default:
                    return "volatility: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.Actual != null && message.hasOwnProperty("Actual"))
                if (!$util.isString(message.Actual))
                    return "Actual: string expected";
            if (message.Previous != null && message.hasOwnProperty("Previous"))
                if (!$util.isString(message.Previous))
                    return "Previous: string expected";
            if (message.Consensus != null && message.hasOwnProperty("Consensus"))
                if (!$util.isString(message.Consensus))
                    return "Consensus: string expected";
            return null;
        };

        /**
         * Creates an EconomicEventDetails message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.EconomicEventDetails
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.EconomicEventDetails} EconomicEventDetails
         */
        EconomicEventDetails.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.EconomicEventDetails)
                return object;
            let message = new $root.stealth.EconomicEventDetails();
            if (object.eventId != null)
                message.eventId = String(object.eventId);
            if (object.timestamp != null)
                if ($util.Long)
                    (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
                else if (typeof object.timestamp === "string")
                    message.timestamp = parseInt(object.timestamp, 10);
                else if (typeof object.timestamp === "number")
                    message.timestamp = object.timestamp;
                else if (typeof object.timestamp === "object")
                    message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
            if (object.name != null)
                message.name = String(object.name);
            if (object.country != null)
                message.country = String(object.country);
            switch (object.volatility) {
            default:
                if (typeof object.volatility === "number") {
                    message.volatility = object.volatility;
                    break;
                }
                break;
            case "None":
            case 0:
                message.volatility = 0;
                break;
            case "Low":
            case 1:
                message.volatility = 1;
                break;
            case "Medium":
            case 2:
                message.volatility = 2;
                break;
            case "High":
            case 3:
                message.volatility = 3;
                break;
            }
            if (object.Actual != null)
                message.Actual = String(object.Actual);
            if (object.Previous != null)
                message.Previous = String(object.Previous);
            if (object.Consensus != null)
                message.Consensus = String(object.Consensus);
            return message;
        };

        /**
         * Creates a plain object from an EconomicEventDetails message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.EconomicEventDetails
         * @static
         * @param {stealth.EconomicEventDetails} message EconomicEventDetails
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EconomicEventDetails.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.eventId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.timestamp = options.longs === String ? "0" : 0;
                object.name = "";
                object.country = "";
                object.volatility = options.enums === String ? "None" : 0;
                object.Actual = "";
                object.Previous = "";
                object.Consensus = "";
            }
            if (message.eventId != null && message.hasOwnProperty("eventId"))
                object.eventId = message.eventId;
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (typeof message.timestamp === "number")
                    object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                else
                    object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.country != null && message.hasOwnProperty("country"))
                object.country = message.country;
            if (message.volatility != null && message.hasOwnProperty("volatility"))
                object.volatility = options.enums === String ? $root.stealth.EconomicEventDetails.Volatility[message.volatility] === undefined ? message.volatility : $root.stealth.EconomicEventDetails.Volatility[message.volatility] : message.volatility;
            if (message.Actual != null && message.hasOwnProperty("Actual"))
                object.Actual = message.Actual;
            if (message.Previous != null && message.hasOwnProperty("Previous"))
                object.Previous = message.Previous;
            if (message.Consensus != null && message.hasOwnProperty("Consensus"))
                object.Consensus = message.Consensus;
            return object;
        };

        /**
         * Converts this EconomicEventDetails to JSON.
         * @function toJSON
         * @memberof stealth.EconomicEventDetails
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EconomicEventDetails.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for EconomicEventDetails
         * @function getTypeUrl
         * @memberof stealth.EconomicEventDetails
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        EconomicEventDetails.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.EconomicEventDetails";
        };

        /**
         * Volatility enum.
         * @name stealth.EconomicEventDetails.Volatility
         * @enum {number}
         * @property {number} None=0 None value
         * @property {number} Low=1 Low value
         * @property {number} Medium=2 Medium value
         * @property {number} High=3 High value
         */
        EconomicEventDetails.Volatility = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "None"] = 0;
            values[valuesById[1] = "Low"] = 1;
            values[valuesById[2] = "Medium"] = 2;
            values[valuesById[3] = "High"] = 3;
            return values;
        })();

        return EconomicEventDetails;
    })();

    stealth.EconomicEventsUpdate = (function() {

        /**
         * Properties of an EconomicEventsUpdate.
         * @memberof stealth
         * @interface IEconomicEventsUpdate
         * @property {Object.<string,stealth.IEconomicEventDetails>|null} [events] EconomicEventsUpdate events
         */

        /**
         * Constructs a new EconomicEventsUpdate.
         * @memberof stealth
         * @classdesc Represents an EconomicEventsUpdate.
         * @implements IEconomicEventsUpdate
         * @constructor
         * @param {stealth.IEconomicEventsUpdate=} [properties] Properties to set
         */
        function EconomicEventsUpdate(properties) {
            this.events = {};
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EconomicEventsUpdate events.
         * @member {Object.<string,stealth.IEconomicEventDetails>} events
         * @memberof stealth.EconomicEventsUpdate
         * @instance
         */
        EconomicEventsUpdate.prototype.events = $util.emptyObject;

        /**
         * Creates a new EconomicEventsUpdate instance using the specified properties.
         * @function create
         * @memberof stealth.EconomicEventsUpdate
         * @static
         * @param {stealth.IEconomicEventsUpdate=} [properties] Properties to set
         * @returns {stealth.EconomicEventsUpdate} EconomicEventsUpdate instance
         */
        EconomicEventsUpdate.create = function create(properties) {
            return new EconomicEventsUpdate(properties);
        };

        /**
         * Encodes the specified EconomicEventsUpdate message. Does not implicitly {@link stealth.EconomicEventsUpdate.verify|verify} messages.
         * @function encode
         * @memberof stealth.EconomicEventsUpdate
         * @static
         * @param {stealth.IEconomicEventsUpdate} message EconomicEventsUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EconomicEventsUpdate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.events != null && Object.hasOwnProperty.call(message, "events"))
                for (let keys = Object.keys(message.events), i = 0; i < keys.length; ++i) {
                    writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                    $root.stealth.EconomicEventDetails.encode(message.events[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                }
            return writer;
        };

        /**
         * Encodes the specified EconomicEventsUpdate message, length delimited. Does not implicitly {@link stealth.EconomicEventsUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof stealth.EconomicEventsUpdate
         * @static
         * @param {stealth.IEconomicEventsUpdate} message EconomicEventsUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EconomicEventsUpdate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EconomicEventsUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof stealth.EconomicEventsUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stealth.EconomicEventsUpdate} EconomicEventsUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EconomicEventsUpdate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stealth.EconomicEventsUpdate(), key, value;
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        if (message.events === $util.emptyObject)
                            message.events = {};
                        let end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            let tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.stealth.EconomicEventDetails.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.events[key] = value;
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EconomicEventsUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof stealth.EconomicEventsUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {stealth.EconomicEventsUpdate} EconomicEventsUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EconomicEventsUpdate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EconomicEventsUpdate message.
         * @function verify
         * @memberof stealth.EconomicEventsUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EconomicEventsUpdate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.events != null && message.hasOwnProperty("events")) {
                if (!$util.isObject(message.events))
                    return "events: object expected";
                let key = Object.keys(message.events);
                for (let i = 0; i < key.length; ++i) {
                    let error = $root.stealth.EconomicEventDetails.verify(message.events[key[i]]);
                    if (error)
                        return "events." + error;
                }
            }
            return null;
        };

        /**
         * Creates an EconomicEventsUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof stealth.EconomicEventsUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {stealth.EconomicEventsUpdate} EconomicEventsUpdate
         */
        EconomicEventsUpdate.fromObject = function fromObject(object) {
            if (object instanceof $root.stealth.EconomicEventsUpdate)
                return object;
            let message = new $root.stealth.EconomicEventsUpdate();
            if (object.events) {
                if (typeof object.events !== "object")
                    throw TypeError(".stealth.EconomicEventsUpdate.events: object expected");
                message.events = {};
                for (let keys = Object.keys(object.events), i = 0; i < keys.length; ++i) {
                    if (typeof object.events[keys[i]] !== "object")
                        throw TypeError(".stealth.EconomicEventsUpdate.events: object expected");
                    message.events[keys[i]] = $root.stealth.EconomicEventDetails.fromObject(object.events[keys[i]]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an EconomicEventsUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof stealth.EconomicEventsUpdate
         * @static
         * @param {stealth.EconomicEventsUpdate} message EconomicEventsUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EconomicEventsUpdate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.objects || options.defaults)
                object.events = {};
            let keys2;
            if (message.events && (keys2 = Object.keys(message.events)).length) {
                object.events = {};
                for (let j = 0; j < keys2.length; ++j)
                    object.events[keys2[j]] = $root.stealth.EconomicEventDetails.toObject(message.events[keys2[j]], options);
            }
            return object;
        };

        /**
         * Converts this EconomicEventsUpdate to JSON.
         * @function toJSON
         * @memberof stealth.EconomicEventsUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EconomicEventsUpdate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for EconomicEventsUpdate
         * @function getTypeUrl
         * @memberof stealth.EconomicEventsUpdate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        EconomicEventsUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/stealth.EconomicEventsUpdate";
        };

        return EconomicEventsUpdate;
    })();

    return stealth;
})();

export { $root as default };
